import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as React from 'react';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHoc from '@apollo/react-hoc';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  EvidenceCustomDataFieldsDynamicZoneInput: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  Long: any;
  TaskTypeDataFieldsDynamicZoneInput: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type AddDataCollectorToProjectInput = {
  projectId: Scalars['ID'];
  dataCollectorId: Scalars['ID'];
};

export type Analytic = {
  __typename?: 'Analytic';
  default_dashboard?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type AnalyticEntity = {
  __typename?: 'AnalyticEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Analytic>;
};

export type AnalyticEntityResponse = {
  __typename?: 'AnalyticEntityResponse';
  data?: Maybe<AnalyticEntity>;
};

export type AnalyticInput = {
  default_dashboard?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type AverageMetirc = {
  __typename?: 'AverageMetirc';
  total: Scalars['Float'];
  wow: Scalars['Float'];
  dod: Scalars['Float'];
};

export type BaoleaderPayload = {
  __typename?: 'BaoleaderPayload';
  baoleader?: Maybe<UsersPermissionsUserEntity>;
};

export type BaoriderCommunityMetrics = {
  __typename?: 'BaoriderCommunityMetrics';
  community?: Maybe<Community>;
  completedTasks: Scalars['Int'];
  completedProjects: Scalars['Int'];
  activeMembers: Scalars['Int'];
};

export type BaoriderPayload = {
  __typename?: 'BaoriderPayload';
  baorider?: Maybe<UsersPermissionsUserEntity>;
  phoneNumberWarning?: Maybe<PhoneNumberWarning>;
};

export type BaoriderPhoneNumberWarning = {
  __typename?: 'BaoriderPhoneNumberWarning';
  phoneNumber?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  message: Scalars['String'];
};

export type BaoriderTaskMetrics = {
  __typename?: 'BaoriderTaskMetrics';
  currentTask?: Maybe<TaskEntity>;
  availableTasks: Scalars['Int'];
  completedTasks: Scalars['Int'];
  currentProject?: Maybe<ProjectSet>;
};

export type BaoverifierApp = {
  __typename?: 'BaoverifierApp';
  appVersion?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  status?: Maybe<Enum_Baoverifierapp_Status>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type BaoverifierAppEntity = {
  __typename?: 'BaoverifierAppEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<BaoverifierApp>;
};

export type BaoverifierAppEntityResponse = {
  __typename?: 'BaoverifierAppEntityResponse';
  data?: Maybe<BaoverifierAppEntity>;
};

export type BaoverifierAppInput = {
  appVersion?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  status?: Maybe<Enum_Baoverifierapp_Status>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type BooleanFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  or?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  not?: Maybe<BooleanFilterInput>;
  eq?: Maybe<Scalars['Boolean']>;
  eqi?: Maybe<Scalars['Boolean']>;
  ne?: Maybe<Scalars['Boolean']>;
  nei?: Maybe<Scalars['Boolean']>;
  startsWith?: Maybe<Scalars['Boolean']>;
  endsWith?: Maybe<Scalars['Boolean']>;
  contains?: Maybe<Scalars['Boolean']>;
  notContains?: Maybe<Scalars['Boolean']>;
  containsi?: Maybe<Scalars['Boolean']>;
  notContainsi?: Maybe<Scalars['Boolean']>;
  gt?: Maybe<Scalars['Boolean']>;
  gte?: Maybe<Scalars['Boolean']>;
  lt?: Maybe<Scalars['Boolean']>;
  lte?: Maybe<Scalars['Boolean']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  between?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
};

export type CardPayload = {
  __typename?: 'CardPayload';
  id?: Maybe<Scalars['ID']>;
  brand?: Maybe<Scalars['String']>;
  exp_month?: Maybe<Scalars['Int']>;
  exp_year?: Maybe<Scalars['Int']>;
  last4?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
};

export type Category = {
  __typename?: 'Category';
  featureImage?: Maybe<UploadFileEntityResponse>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  onlyEmployeesVerify?: Maybe<Scalars['Boolean']>;
  task_types?: Maybe<TaskTypeRelationResponseCollection>;
  ER_ID?: Maybe<Scalars['String']>;
  company?: Maybe<CompanyEntityResponse>;
  status?: Maybe<Enum_Category_Status>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type CategoryTask_TypesArgs = {
  filters?: Maybe<TaskTypeFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};

export type CategoryEntity = {
  __typename?: 'CategoryEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Category>;
};

export type CategoryEntityResponse = {
  __typename?: 'CategoryEntityResponse';
  data?: Maybe<CategoryEntity>;
};

export type CategoryEntityResponseCollection = {
  __typename?: 'CategoryEntityResponseCollection';
  data: Array<CategoryEntity>;
  meta: ResponseCollectionMeta;
};

export type CategoryFiltersInput = {
  id?: Maybe<IdFilterInput>;
  title?: Maybe<StringFilterInput>;
  description?: Maybe<StringFilterInput>;
  onlyEmployeesVerify?: Maybe<BooleanFilterInput>;
  task_types?: Maybe<TaskTypeFiltersInput>;
  ER_ID?: Maybe<StringFilterInput>;
  company?: Maybe<CompanyFiltersInput>;
  status?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<CategoryFiltersInput>>>;
  or?: Maybe<Array<Maybe<CategoryFiltersInput>>>;
  not?: Maybe<CategoryFiltersInput>;
};

export type CategoryInput = {
  featureImage?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  onlyEmployeesVerify?: Maybe<Scalars['Boolean']>;
  task_types?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ER_ID?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['ID']>;
  status?: Maybe<Enum_Category_Status>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type CategoryRelationResponseCollection = {
  __typename?: 'CategoryRelationResponseCollection';
  data: Array<CategoryEntity>;
};

export type CategorySet = {
  __typename?: 'CategorySet';
  id: Scalars['String'];
  title: Scalars['String'];
  index: Scalars['Int'];
};

export type CategorysWithCount = {
  __typename?: 'CategorysWithCount';
  categories?: Maybe<Array<Maybe<CategoryEntity>>>;
  count?: Maybe<Scalars['Int']>;
};

export type ChartData = {
  __typename?: 'ChartData';
  key: Scalars['String'];
  value: Scalars['Int'];
};

export type CodeValid = {
  __typename?: 'CodeValid';
  valid?: Maybe<Scalars['Boolean']>;
  code?: Maybe<Scalars['String']>;
};

export type Community = {
  __typename?: 'Community';
  name?: Maybe<Scalars['String']>;
  community_members?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  description?: Maybe<Scalars['String']>;
  chief_name?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['JSON']>;
  featured_image?: Maybe<UploadFileEntityResponse>;
  baoleader?: Maybe<UsersPermissionsUserEntityResponse>;
  type?: Maybe<Enum_Community_Type>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type CommunityCommunity_MembersArgs = {
  filters?: Maybe<UsersPermissionsUserFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CommunityEntity = {
  __typename?: 'CommunityEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Community>;
};

export type CommunityEntityResponse = {
  __typename?: 'CommunityEntityResponse';
  data?: Maybe<CommunityEntity>;
};

export type CommunityEntityResponseCollection = {
  __typename?: 'CommunityEntityResponseCollection';
  data: Array<CommunityEntity>;
  meta: ResponseCollectionMeta;
};

export type CommunityFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  community_members?: Maybe<UsersPermissionsUserFiltersInput>;
  description?: Maybe<StringFilterInput>;
  chief_name?: Maybe<StringFilterInput>;
  location?: Maybe<JsonFilterInput>;
  baoleader?: Maybe<UsersPermissionsUserFiltersInput>;
  type?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<CommunityFiltersInput>>>;
  or?: Maybe<Array<Maybe<CommunityFiltersInput>>>;
  not?: Maybe<CommunityFiltersInput>;
};

export type CommunityInput = {
  name?: Maybe<Scalars['String']>;
  community_members?: Maybe<Array<Maybe<Scalars['ID']>>>;
  description?: Maybe<Scalars['String']>;
  chief_name?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['JSON']>;
  featured_image?: Maybe<Scalars['ID']>;
  baoleader?: Maybe<Scalars['ID']>;
  type?: Maybe<Enum_Community_Type>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type CommunityMembersPayload = {
  __typename?: 'CommunityMembersPayload';
  member?: Maybe<UsersPermissionsUserEntity>;
};

export type Company = {
  __typename?: 'Company';
  name?: Maybe<Scalars['String']>;
  id_number?: Maybe<Scalars['String']>;
  wildlife_association_number?: Maybe<Scalars['String']>;
  pin_registration?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  affiliates?: Maybe<Scalars['JSON']>;
  team_members?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  subscription?: Maybe<SubscriptionEntityResponse>;
  email: Scalars['String'];
  data_lists?: Maybe<DataListRelationResponseCollection>;
  matabase_group_ID?: Maybe<Scalars['String']>;
  projects?: Maybe<ProjectRelationResponseCollection>;
  default_dashboard?: Maybe<Scalars['String']>;
  status?: Maybe<Enum_Company_Status>;
  paymentMethod?: Maybe<Scalars['String']>;
  onboardingInformation?: Maybe<Scalars['JSON']>;
  categories?: Maybe<CategoryRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type CompanyTeam_MembersArgs = {
  filters?: Maybe<UsersPermissionsUserFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type CompanyData_ListsArgs = {
  filters?: Maybe<DataListFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};


export type CompanyProjectsArgs = {
  filters?: Maybe<ProjectFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};


export type CompanyCategoriesArgs = {
  filters?: Maybe<CategoryFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};

export type CompanyEntity = {
  __typename?: 'CompanyEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Company>;
};

export type CompanyEntityResponse = {
  __typename?: 'CompanyEntityResponse';
  data?: Maybe<CompanyEntity>;
};

export type CompanyEntityResponseCollection = {
  __typename?: 'CompanyEntityResponseCollection';
  data: Array<CompanyEntity>;
  meta: ResponseCollectionMeta;
};

export type CompanyFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  id_number?: Maybe<StringFilterInput>;
  wildlife_association_number?: Maybe<StringFilterInput>;
  pin_registration?: Maybe<StringFilterInput>;
  website?: Maybe<StringFilterInput>;
  affiliates?: Maybe<JsonFilterInput>;
  team_members?: Maybe<UsersPermissionsUserFiltersInput>;
  customerId?: Maybe<StringFilterInput>;
  subscription?: Maybe<SubscriptionFiltersInput>;
  email?: Maybe<StringFilterInput>;
  data_lists?: Maybe<DataListFiltersInput>;
  matabase_group_ID?: Maybe<StringFilterInput>;
  projects?: Maybe<ProjectFiltersInput>;
  default_dashboard?: Maybe<StringFilterInput>;
  status?: Maybe<StringFilterInput>;
  paymentMethod?: Maybe<StringFilterInput>;
  onboardingInformation?: Maybe<JsonFilterInput>;
  categories?: Maybe<CategoryFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<CompanyFiltersInput>>>;
  or?: Maybe<Array<Maybe<CompanyFiltersInput>>>;
  not?: Maybe<CompanyFiltersInput>;
};

export type CompanyInput = {
  name?: Maybe<Scalars['String']>;
  id_number?: Maybe<Scalars['String']>;
  wildlife_association_number?: Maybe<Scalars['String']>;
  pin_registration?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  affiliates?: Maybe<Scalars['JSON']>;
  team_members?: Maybe<Array<Maybe<Scalars['ID']>>>;
  customerId?: Maybe<Scalars['String']>;
  subscription?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
  data_lists?: Maybe<Array<Maybe<Scalars['ID']>>>;
  matabase_group_ID?: Maybe<Scalars['String']>;
  projects?: Maybe<Array<Maybe<Scalars['ID']>>>;
  default_dashboard?: Maybe<Scalars['String']>;
  status?: Maybe<Enum_Company_Status>;
  paymentMethod?: Maybe<Scalars['String']>;
  onboardingInformation?: Maybe<Scalars['JSON']>;
  categories?: Maybe<Array<Maybe<Scalars['ID']>>>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type CompanyRelationResponseCollection = {
  __typename?: 'CompanyRelationResponseCollection';
  data: Array<CompanyEntity>;
};

export type ComponentComboFieldOption = {
  __typename?: 'ComponentComboFieldOption';
  id: Scalars['ID'];
  option?: Maybe<Scalars['String']>;
};

export type ComponentComboFieldOptionFiltersInput = {
  option?: Maybe<StringFilterInput>;
  and?: Maybe<Array<Maybe<ComponentComboFieldOptionFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentComboFieldOptionFiltersInput>>>;
  not?: Maybe<ComponentComboFieldOptionFiltersInput>;
};

export type ComponentComboFieldOptionInput = {
  id?: Maybe<Scalars['ID']>;
  option?: Maybe<Scalars['String']>;
};

export type ComponentCustomDataFieldsCheckbox = {
  __typename?: 'ComponentCustomDataFieldsCheckbox';
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  option?: Maybe<Array<Maybe<ComponentComboFieldOption>>>;
  isRequired?: Maybe<Scalars['Boolean']>;
};


export type ComponentCustomDataFieldsCheckboxOptionArgs = {
  filters?: Maybe<ComponentComboFieldOptionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentCustomDataFieldsDataList = {
  __typename?: 'ComponentCustomDataFieldsDataList';
  id: Scalars['ID'];
  listId: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  isRequired?: Maybe<Scalars['Boolean']>;
  option?: Maybe<Array<Maybe<ComponentComboFieldOption>>>;
};


export type ComponentCustomDataFieldsDataListOptionArgs = {
  filters?: Maybe<ComponentComboFieldOptionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentCustomDataFieldsDateTimeField = {
  __typename?: 'ComponentCustomDataFieldsDateTimeField';
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  datetime?: Maybe<Scalars['DateTime']>;
  isRequired?: Maybe<Scalars['Boolean']>;
};

export type ComponentCustomDataFieldsEmailField = {
  __typename?: 'ComponentCustomDataFieldsEmailField';
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  isRequired?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
};

export type ComponentCustomDataFieldsImageField = {
  __typename?: 'ComponentCustomDataFieldsImageField';
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  images?: Maybe<UploadFileRelationResponseCollection>;
  isRequired?: Maybe<Scalars['Boolean']>;
  imageUrls?: Maybe<Scalars['JSON']>;
  upload_state?: Maybe<Enum_Componentcustomdatafieldsimagefield_Upload_State>;
};


export type ComponentCustomDataFieldsImageFieldImagesArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentCustomDataFieldsMetricsSpecific = {
  __typename?: 'ComponentCustomDataFieldsMetricsSpecific';
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  metric?: Maybe<Scalars['String']>;
  isRequired?: Maybe<Scalars['Boolean']>;
  min?: Maybe<Scalars['Long']>;
  max?: Maybe<Scalars['Long']>;
  number_value?: Maybe<Scalars['String']>;
};

export type ComponentCustomDataFieldsNumberDropDown = {
  __typename?: 'ComponentCustomDataFieldsNumberDropDown';
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Long']>;
  min?: Maybe<Scalars['Long']>;
  max?: Maybe<Scalars['Long']>;
  isRequired?: Maybe<Scalars['Boolean']>;
};

export type ComponentCustomDataFieldsNumberField = {
  __typename?: 'ComponentCustomDataFieldsNumberField';
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  isRequired?: Maybe<Scalars['Boolean']>;
  min?: Maybe<Scalars['Long']>;
  max?: Maybe<Scalars['Long']>;
  number_field_value?: Maybe<Scalars['String']>;
};

export type ComponentCustomDataFieldsNumberRange = {
  __typename?: 'ComponentCustomDataFieldsNumberRange';
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  min?: Maybe<Scalars['Long']>;
  max?: Maybe<Scalars['Long']>;
  isRequired?: Maybe<Scalars['Boolean']>;
};

export type ComponentCustomDataFieldsPercentage = {
  __typename?: 'ComponentCustomDataFieldsPercentage';
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Long']>;
  isRequired?: Maybe<Scalars['Boolean']>;
};

export type ComponentCustomDataFieldsPhoneNumberField = {
  __typename?: 'ComponentCustomDataFieldsPhoneNumberField';
  id: Scalars['ID'];
  phoneNumber?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  isRequired?: Maybe<Scalars['Boolean']>;
};

export type ComponentCustomDataFieldsRadio = {
  __typename?: 'ComponentCustomDataFieldsRadio';
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  option?: Maybe<Array<Maybe<ComponentComboFieldOption>>>;
  isRequired?: Maybe<Scalars['Boolean']>;
};


export type ComponentCustomDataFieldsRadioOptionArgs = {
  filters?: Maybe<ComponentComboFieldOptionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentCustomDataFieldsRating = {
  __typename?: 'ComponentCustomDataFieldsRating';
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  number_of_stars?: Maybe<Scalars['Long']>;
  isRequired?: Maybe<Scalars['Boolean']>;
};

export type ComponentCustomDataFieldsSelect = {
  __typename?: 'ComponentCustomDataFieldsSelect';
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  option?: Maybe<Array<Maybe<ComponentComboFieldOption>>>;
  isRequired?: Maybe<Scalars['Boolean']>;
};


export type ComponentCustomDataFieldsSelectOptionArgs = {
  filters?: Maybe<ComponentComboFieldOptionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentCustomDataFieldsText = {
  __typename?: 'ComponentCustomDataFieldsText';
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  text_value?: Maybe<Scalars['String']>;
  isRequired?: Maybe<Scalars['Boolean']>;
};

export type ComponentFaqFaq = {
  __typename?: 'ComponentFaqFaq';
  id: Scalars['ID'];
  question?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
  category?: Maybe<Enum_Componentfaqfaq_Category>;
  tags?: Maybe<Array<Maybe<ComponentComboFieldOption>>>;
  page?: Maybe<Enum_Componentfaqfaq_Page>;
};


export type ComponentFaqFaqTagsArgs = {
  filters?: Maybe<ComponentComboFieldOptionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentFaqFaqFiltersInput = {
  question?: Maybe<StringFilterInput>;
  answer?: Maybe<StringFilterInput>;
  category?: Maybe<StringFilterInput>;
  tags?: Maybe<ComponentComboFieldOptionFiltersInput>;
  page?: Maybe<StringFilterInput>;
  and?: Maybe<Array<Maybe<ComponentFaqFaqFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentFaqFaqFiltersInput>>>;
  not?: Maybe<ComponentFaqFaqFiltersInput>;
};

export type ComponentFaqFaqInput = {
  id?: Maybe<Scalars['ID']>;
  question?: Maybe<Scalars['String']>;
  answer?: Maybe<Scalars['String']>;
  category?: Maybe<Enum_Componentfaqfaq_Category>;
  tags?: Maybe<Array<Maybe<ComponentComboFieldOptionInput>>>;
  page?: Maybe<Enum_Componentfaqfaq_Page>;
};

export type ComponentPricePlansPlans = {
  __typename?: 'ComponentPricePlansPlans';
  id: Scalars['ID'];
  price?: Maybe<Scalars['Float']>;
  recurring?: Maybe<Enum_Componentpriceplansplans_Recurring>;
  priceId?: Maybe<Scalars['String']>;
};

export type ComponentProductFeaturePlanFeature = {
  __typename?: 'ComponentProductFeaturePlanFeature';
  id: Scalars['ID'];
  label: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  isHighlighted?: Maybe<Scalars['Boolean']>;
  sortOrder?: Maybe<Scalars['Int']>;
};

export type ComponentProductFeaturePlanFeatureFiltersInput = {
  label?: Maybe<StringFilterInput>;
  description?: Maybe<StringFilterInput>;
  isHighlighted?: Maybe<BooleanFilterInput>;
  sortOrder?: Maybe<IntFilterInput>;
  and?: Maybe<Array<Maybe<ComponentProductFeaturePlanFeatureFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentProductFeaturePlanFeatureFiltersInput>>>;
  not?: Maybe<ComponentProductFeaturePlanFeatureFiltersInput>;
};

export type ComponentProductFeaturePlanFeatureInput = {
  id?: Maybe<Scalars['ID']>;
  label?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  isHighlighted?: Maybe<Scalars['Boolean']>;
  sortOrder?: Maybe<Scalars['Int']>;
};

export type ComponentProductFeatureProductFeature = {
  __typename?: 'ComponentProductFeatureProductFeature';
  id: Scalars['ID'];
  baoriders_allowed?: Maybe<Scalars['Int']>;
  cost_per_baorider?: Maybe<Scalars['Float']>;
  recurring?: Maybe<Enum_Componentproductfeatureproductfeature_Recurring>;
  price?: Maybe<Scalars['Long']>;
  price_usd?: Maybe<Scalars['Long']>;
  price_zar?: Maybe<Scalars['Long']>;
  support_hours?: Maybe<Scalars['Float']>;
};

export type ComponentProductFeatureProductFeatureFiltersInput = {
  baoriders_allowed?: Maybe<IntFilterInput>;
  cost_per_baorider?: Maybe<FloatFilterInput>;
  recurring?: Maybe<StringFilterInput>;
  price?: Maybe<LongFilterInput>;
  price_usd?: Maybe<LongFilterInput>;
  price_zar?: Maybe<LongFilterInput>;
  support_hours?: Maybe<FloatFilterInput>;
  and?: Maybe<Array<Maybe<ComponentProductFeatureProductFeatureFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentProductFeatureProductFeatureFiltersInput>>>;
  not?: Maybe<ComponentProductFeatureProductFeatureFiltersInput>;
};

export type ComponentProductFeatureProductFeatureInput = {
  id?: Maybe<Scalars['ID']>;
  baoriders_allowed?: Maybe<Scalars['Int']>;
  cost_per_baorider?: Maybe<Scalars['Float']>;
  recurring?: Maybe<Enum_Componentproductfeatureproductfeature_Recurring>;
  price?: Maybe<Scalars['Long']>;
  price_usd?: Maybe<Scalars['Long']>;
  price_zar?: Maybe<Scalars['Long']>;
  support_hours?: Maybe<Scalars['Float']>;
};

export type ComponentTrainingVideoTrainingVideo = {
  __typename?: 'ComponentTrainingVideoTrainingVideo';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<ComponentComboFieldOption>>>;
  category?: Maybe<Enum_Componenttrainingvideotrainingvideo_Category>;
  page?: Maybe<Enum_Componenttrainingvideotrainingvideo_Page>;
};


export type ComponentTrainingVideoTrainingVideoTagsArgs = {
  filters?: Maybe<ComponentComboFieldOptionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ComponentTrainingVideoTrainingVideoFiltersInput = {
  title?: Maybe<StringFilterInput>;
  url?: Maybe<StringFilterInput>;
  description?: Maybe<StringFilterInput>;
  tags?: Maybe<ComponentComboFieldOptionFiltersInput>;
  category?: Maybe<StringFilterInput>;
  page?: Maybe<StringFilterInput>;
  and?: Maybe<Array<Maybe<ComponentTrainingVideoTrainingVideoFiltersInput>>>;
  or?: Maybe<Array<Maybe<ComponentTrainingVideoTrainingVideoFiltersInput>>>;
  not?: Maybe<ComponentTrainingVideoTrainingVideoFiltersInput>;
};

export type ComponentTrainingVideoTrainingVideoInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<ComponentComboFieldOptionInput>>>;
  category?: Maybe<Enum_Componenttrainingvideotrainingvideo_Category>;
  page?: Maybe<Enum_Componenttrainingvideotrainingvideo_Page>;
};

export type ContactMessageResult = {
  __typename?: 'ContactMessageResult';
  sent: Scalars['Boolean'];
};

export type CreateBaoleaderInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  title: Scalars['String'];
  email: Scalars['String'];
  role: Scalars['String'];
};

export type CreateBaoriderInput = {
  phoneNumber: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  community: Scalars['ID'];
  projects?: Maybe<Array<Scalars['ID']>>;
  idNumber?: Maybe<Scalars['String']>;
  isVerifier?: Maybe<Scalars['Boolean']>;
};

export type CreateCommunityMembersInput = {
  phoneNumber: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  community: Scalars['ID'];
  idNumber?: Maybe<Scalars['String']>;
};

export type CreateNewSubscriptionInput = {
  priceId: Scalars['String'];
  plan: Scalars['String'];
  recurring: Scalars['String'];
  collectionMethod: Scalars['String'];
  currency?: Maybe<Scalars['String']>;
};

export type CustomDataLabel = {
  __typename?: 'CustomDataLabel';
  label?: Maybe<Scalars['String']>;
  type?: Maybe<DataLabelTypeEntityResponse>;
  options?: Maybe<ProjectDataLabelTypeOptionRelationResponseCollection>;
  task_type?: Maybe<TaskTypeEntityResponse>;
  baoleader?: Maybe<UsersPermissionsUserEntityResponse>;
  is_default?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type CustomDataLabelOptionsArgs = {
  filters?: Maybe<ProjectDataLabelTypeOptionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};

export type CustomDataLabelEntity = {
  __typename?: 'CustomDataLabelEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<CustomDataLabel>;
};

export type CustomDataLabelEntityResponse = {
  __typename?: 'CustomDataLabelEntityResponse';
  data?: Maybe<CustomDataLabelEntity>;
};

export type CustomDataLabelEntityResponseCollection = {
  __typename?: 'CustomDataLabelEntityResponseCollection';
  data: Array<CustomDataLabelEntity>;
  meta: ResponseCollectionMeta;
};

export type CustomDataLabelFiltersInput = {
  id?: Maybe<IdFilterInput>;
  label?: Maybe<StringFilterInput>;
  type?: Maybe<DataLabelTypeFiltersInput>;
  options?: Maybe<ProjectDataLabelTypeOptionFiltersInput>;
  task_type?: Maybe<TaskTypeFiltersInput>;
  baoleader?: Maybe<UsersPermissionsUserFiltersInput>;
  is_default?: Maybe<BooleanFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<CustomDataLabelFiltersInput>>>;
  or?: Maybe<Array<Maybe<CustomDataLabelFiltersInput>>>;
  not?: Maybe<CustomDataLabelFiltersInput>;
};

export type CustomDataLabelInput = {
  label?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['ID']>;
  options?: Maybe<Array<Maybe<Scalars['ID']>>>;
  task_type?: Maybe<Scalars['ID']>;
  baoleader?: Maybe<Scalars['ID']>;
  is_default?: Maybe<Scalars['Boolean']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type CustomDataLabelRelationResponseCollection = {
  __typename?: 'CustomDataLabelRelationResponseCollection';
  data: Array<CustomDataLabelEntity>;
};

export type DataCollectorInviteLink = {
  __typename?: 'DataCollectorInviteLink';
  url: Scalars['String'];
};

export type DataLabelType = {
  __typename?: 'DataLabelType';
  name?: Maybe<Scalars['String']>;
  has_options?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type DataLabelTypeEntity = {
  __typename?: 'DataLabelTypeEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<DataLabelType>;
};

export type DataLabelTypeEntityResponse = {
  __typename?: 'DataLabelTypeEntityResponse';
  data?: Maybe<DataLabelTypeEntity>;
};

export type DataLabelTypeEntityResponseCollection = {
  __typename?: 'DataLabelTypeEntityResponseCollection';
  data: Array<DataLabelTypeEntity>;
  meta: ResponseCollectionMeta;
};

export type DataLabelTypeFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  has_options?: Maybe<BooleanFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<DataLabelTypeFiltersInput>>>;
  or?: Maybe<Array<Maybe<DataLabelTypeFiltersInput>>>;
  not?: Maybe<DataLabelTypeFiltersInput>;
};

export type DataLabelTypeInput = {
  name?: Maybe<Scalars['String']>;
  has_options?: Maybe<Scalars['Boolean']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type DataList = {
  __typename?: 'DataList';
  name: Scalars['String'];
  data_list_options?: Maybe<DataListOptionRelationResponseCollection>;
  company?: Maybe<CompanyEntityResponse>;
  status?: Maybe<Enum_Datalist_Status>;
  updateKey?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type DataListData_List_OptionsArgs = {
  filters?: Maybe<DataListOptionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};

export type DataListEntity = {
  __typename?: 'DataListEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<DataList>;
};

export type DataListEntityResponse = {
  __typename?: 'DataListEntityResponse';
  data?: Maybe<DataListEntity>;
};

export type DataListEntityResponseCollection = {
  __typename?: 'DataListEntityResponseCollection';
  data: Array<DataListEntity>;
  meta: ResponseCollectionMeta;
};

export type DataListFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  data_list_options?: Maybe<DataListOptionFiltersInput>;
  company?: Maybe<CompanyFiltersInput>;
  status?: Maybe<StringFilterInput>;
  updateKey?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<DataListFiltersInput>>>;
  or?: Maybe<Array<Maybe<DataListFiltersInput>>>;
  not?: Maybe<DataListFiltersInput>;
};

export type DataListInput = {
  name?: Maybe<Scalars['String']>;
  data_list_options?: Maybe<Array<Maybe<Scalars['ID']>>>;
  company?: Maybe<Scalars['ID']>;
  status?: Maybe<Enum_Datalist_Status>;
  updateKey?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type DataListOption = {
  __typename?: 'DataListOption';
  data_list?: Maybe<DataListEntityResponse>;
  value: Scalars['String'];
  status?: Maybe<Enum_Datalistoption_Status>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type DataListOptionEntity = {
  __typename?: 'DataListOptionEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<DataListOption>;
};

export type DataListOptionEntityResponse = {
  __typename?: 'DataListOptionEntityResponse';
  data?: Maybe<DataListOptionEntity>;
};

export type DataListOptionEntityResponseCollection = {
  __typename?: 'DataListOptionEntityResponseCollection';
  data: Array<DataListOptionEntity>;
  meta: ResponseCollectionMeta;
};

export type DataListOptionFiltersInput = {
  id?: Maybe<IdFilterInput>;
  data_list?: Maybe<DataListFiltersInput>;
  value?: Maybe<StringFilterInput>;
  status?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<DataListOptionFiltersInput>>>;
  or?: Maybe<Array<Maybe<DataListOptionFiltersInput>>>;
  not?: Maybe<DataListOptionFiltersInput>;
};

export type DataListOptionInput = {
  data_list?: Maybe<Scalars['ID']>;
  value?: Maybe<Scalars['String']>;
  status?: Maybe<Enum_Datalistoption_Status>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type DataListOptionRelationResponseCollection = {
  __typename?: 'DataListOptionRelationResponseCollection';
  data: Array<DataListOptionEntity>;
};

export type DataListOptionWithCount = {
  __typename?: 'DataListOptionWithCount';
  data?: Maybe<Array<Maybe<DataListOptionEntity>>>;
  count?: Maybe<Scalars['Int']>;
};

export type DataListRelationResponseCollection = {
  __typename?: 'DataListRelationResponseCollection';
  data: Array<DataListEntity>;
};


export type DateFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['Date']>>>;
  or?: Maybe<Array<Maybe<Scalars['Date']>>>;
  not?: Maybe<DateFilterInput>;
  eq?: Maybe<Scalars['Date']>;
  eqi?: Maybe<Scalars['Date']>;
  ne?: Maybe<Scalars['Date']>;
  nei?: Maybe<Scalars['Date']>;
  startsWith?: Maybe<Scalars['Date']>;
  endsWith?: Maybe<Scalars['Date']>;
  contains?: Maybe<Scalars['Date']>;
  notContains?: Maybe<Scalars['Date']>;
  containsi?: Maybe<Scalars['Date']>;
  notContainsi?: Maybe<Scalars['Date']>;
  gt?: Maybe<Scalars['Date']>;
  gte?: Maybe<Scalars['Date']>;
  lt?: Maybe<Scalars['Date']>;
  lte?: Maybe<Scalars['Date']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['Date']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['Date']>>>;
  between?: Maybe<Array<Maybe<Scalars['Date']>>>;
};

export type DateRangeInput = {
  start?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['String']>;
};


export type DateTimeFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  or?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  not?: Maybe<DateTimeFilterInput>;
  eq?: Maybe<Scalars['DateTime']>;
  eqi?: Maybe<Scalars['DateTime']>;
  ne?: Maybe<Scalars['DateTime']>;
  nei?: Maybe<Scalars['DateTime']>;
  startsWith?: Maybe<Scalars['DateTime']>;
  endsWith?: Maybe<Scalars['DateTime']>;
  contains?: Maybe<Scalars['DateTime']>;
  notContains?: Maybe<Scalars['DateTime']>;
  containsi?: Maybe<Scalars['DateTime']>;
  notContainsi?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  between?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
};

export type DeliveryReportCounts = {
  __typename?: 'DeliveryReportCounts';
  received: Scalars['Int'];
  sent: Scalars['Int'];
  failed: Scalars['Int'];
  notSent: Scalars['Int'];
};

export enum Enum_Baoverifierapp_Status {
  Active = 'active',
  Inactive = 'inactive'
}

export enum Enum_Category_Status {
  Active = 'active',
  Inactive = 'inactive'
}

export enum Enum_Community_Type {
  Community = 'Community',
  Team = 'Team',
  Volunteers = 'Volunteers'
}

export enum Enum_Company_Status {
  Active = 'active',
  Inactive = 'inactive'
}

export enum Enum_Componentcustomdatafieldsimagefield_Upload_State {
  InProgress = 'in_progress',
  Done = 'done'
}

export enum Enum_Componentfaqfaq_Category {
  Admin = 'Admin',
  DataCollector = 'Data_Collector',
  WelcomeToBaotree = 'Welcome_to_Baotree'
}

export enum Enum_Componentfaqfaq_Page {
  TasksFeed = 'Tasks_Feed',
  TaskBuilder_101 = 'Task_Builder_101',
  ProjectsHowTo = 'Projects_How_To',
  GroupsGuide = 'Groups_Guide',
  Settings = 'Settings',
  DataCollectors = 'Data_Collectors',
  Onboarding = 'Onboarding',
  Help = 'Help',
  Analytics = 'Analytics',
  Dashboard = 'Dashboard',
  DataLists = 'Data_Lists',
  Notifications = 'Notifications'
}

export enum Enum_Componentpriceplansplans_Recurring {
  Month = 'month',
  Year = 'year'
}

export enum Enum_Componentproductfeatureproductfeature_Recurring {
  Month = 'month',
  Year = 'year'
}

export enum Enum_Componenttrainingvideotrainingvideo_Category {
  Admin = 'Admin',
  DataCollector = 'Data_Collector',
  WelcomeToBaotree = 'Welcome_to_Baotree'
}

export enum Enum_Componenttrainingvideotrainingvideo_Page {
  TasksFeed = 'Tasks_Feed',
  TaskBuilder_101 = 'Task_Builder_101',
  ProjectsHowTo = 'Projects_How_To',
  GroupsGuide = 'Groups_Guide',
  Settings = 'Settings',
  DataCollectors = 'Data_Collectors',
  Onboarding = 'Onboarding',
  Help = 'Help',
  Analytics = 'Analytics',
  Dashboard = 'Dashboard',
  DataLists = 'Data_Lists',
  Notifications = 'Notifications'
}

export enum Enum_Datalistoption_Status {
  Active = 'active',
  Inactive = 'inactive'
}

export enum Enum_Datalist_Status {
  Active = 'active',
  Inactive = 'inactive'
}

export enum Enum_Evidence_Upload_State {
  InProgress = 'in_progress',
  Done = 'done'
}

export enum Enum_Featurecoupon_Feature {
  Analytics = 'analytics'
}

export enum Enum_Featureunlock_Feature {
  Analytics = 'analytics'
}

export enum Enum_Insightreport_Status {
  Draft = 'draft',
  Published = 'published'
}

export enum Enum_Notification_Recur {
  None = 'NONE',
  Daily = 'DAILY',
  Weekly = 'WEEKLY',
  Monthly = 'MONTHLY',
  Yearly = 'YEARLY'
}

export enum Enum_Notification_Status {
  Draft = 'DRAFT',
  Active = 'ACTIVE',
  Sent = 'SENT',
  Failed = 'FAILED',
  Archived = 'ARCHIVED',
  Info = 'INFO',
  Received = 'RECEIVED',
  Done = 'DONE'
}

export enum Enum_Notification_Type {
  General = 'GENERAL',
  Reminder = 'REMINDER',
  EarlyWarning = 'EARLY_WARNING',
  MoreInfoRequested = 'MORE_INFO_REQUESTED',
  ReminderAlert = 'REMINDER_ALERT'
}

export enum Enum_Project_Partners {
  Ftt = 'FTT'
}

export enum Enum_Project_Status {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Cancelled = 'CANCELLED',
  Archived = 'ARCHIVED'
}

export enum Enum_Pushnotificationstatus_Status {
  Sent = 'SENT',
  Failed = 'FAILED',
  Received = 'RECEIVED'
}

export enum Enum_Request_Status {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export enum Enum_Scheduledcronjob_Jobtype {
  Login = 'LOGIN',
  DcWeeklyActivities = 'DC_WEEKLY_ACTIVITIES',
  DcInactivity = 'DC_INACTIVITY',
  DcLastTaskReported = 'DC_LAST_TASK_REPORTED'
}

export enum Enum_Scheduledcronjob_Status {
  Pending = 'PENDING',
  Done = 'DONE',
  Error = 'ERROR'
}

export enum Enum_Schedulednotification_Priority {
  Low = 'LOW',
  Default = 'DEFAULT',
  High = 'HIGH',
  Max = 'MAX'
}

export enum Enum_Schedulednotification_Recur {
  None = 'NONE',
  Daily = 'DAILY',
  Weekly = 'WEEKLY',
  Monthly = 'MONTHLY',
  Yearly = 'YEARLY'
}

export enum Enum_Schedulednotification_Status {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export enum Enum_Subscription_Collection_Method {
  ChargeAutomatically = 'charge_automatically',
  SendInvoice = 'send_invoice'
}

export enum Enum_Subscription_Currency {
  Gbp = 'gbp',
  Usd = 'usd',
  Zar = 'zar'
}

export enum Enum_Subscription_Recurring {
  Month = 'month',
  Year = 'year'
}

export enum Enum_Subscription_Status {
  Active = 'active',
  Incomplete = 'incomplete',
  IncompleteExpired = 'incomplete_expired',
  Trialing = 'trialing',
  PastDue = 'past_due',
  Canceled = 'canceled',
  Unpaid = 'unpaid'
}

export enum Enum_Taskdefinition_Status {
  Active = 'active',
  Deactivated = 'deactivated',
  Old = 'old'
}

export enum Enum_Tasktype_Status {
  Active = 'active',
  Deactivated = 'deactivated',
  Drafted = 'drafted',
  Old = 'old'
}

export enum Enum_Task_Status {
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  Reported = 'REPORTED',
  Pending = 'PENDING',
  MoreInfoRequested = 'MORE_INFO_REQUESTED',
  Rejected = 'REJECTED'
}

export enum Enum_Task_Task_Origin {
  DataCollector = 'DATA_COLLECTOR',
  Leader = 'LEADER',
  CommunityMember = 'COMMUNITY_MEMBER',
  Baoverifier = 'BAOVERIFIER',
  Baoleader = 'BAOLEADER',
  Desktop = 'DESKTOP'
}

export enum Enum_Userspermissionsuser_Gender {
  Male = 'Male',
  Female = 'Female',
  NonBinary = 'Non_binary',
  Other = 'Other',
  PreferNotToSay = 'Prefer_not_to_say'
}

export enum Enum_Userspermissionsuser_Onboarding {
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED'
}

export enum Enum_Userspermissionsuser_Status {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  RequestPending = 'REQUEST_PENDING',
  Archived = 'ARCHIVED'
}

export enum Enum_Video_Category {
  General = 'general',
  Community = 'community',
  Project = 'project',
  Task = 'task',
  Baorider = 'baorider',
  Request = 'request'
}

export type EmailOtp = {
  __typename?: 'EmailOtp';
  email: Scalars['String'];
  expiresAt?: Maybe<Scalars['DateTime']>;
  attempts?: Maybe<Scalars['Int']>;
  sendCount?: Maybe<Scalars['Int']>;
  verified?: Maybe<Scalars['Boolean']>;
  verifiedAt?: Maybe<Scalars['DateTime']>;
  consumedAt?: Maybe<Scalars['DateTime']>;
  lastSentAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EmailOtpEntity = {
  __typename?: 'EmailOtpEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<EmailOtp>;
};

export type EmailOtpEntityResponse = {
  __typename?: 'EmailOtpEntityResponse';
  data?: Maybe<EmailOtpEntity>;
};

export type EmailOtpEntityResponseCollection = {
  __typename?: 'EmailOtpEntityResponseCollection';
  data: Array<EmailOtpEntity>;
  meta: ResponseCollectionMeta;
};

export type EmailOtpFiltersInput = {
  id?: Maybe<IdFilterInput>;
  email?: Maybe<StringFilterInput>;
  codeHash?: Maybe<StringFilterInput>;
  expiresAt?: Maybe<DateTimeFilterInput>;
  attempts?: Maybe<IntFilterInput>;
  sendCount?: Maybe<IntFilterInput>;
  verified?: Maybe<BooleanFilterInput>;
  verifiedAt?: Maybe<DateTimeFilterInput>;
  consumedAt?: Maybe<DateTimeFilterInput>;
  lastSentAt?: Maybe<DateTimeFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<EmailOtpFiltersInput>>>;
  or?: Maybe<Array<Maybe<EmailOtpFiltersInput>>>;
  not?: Maybe<EmailOtpFiltersInput>;
};

export type EmailOtpInput = {
  email?: Maybe<Scalars['String']>;
  codeHash?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  attempts?: Maybe<Scalars['Int']>;
  sendCount?: Maybe<Scalars['Int']>;
  verified?: Maybe<Scalars['Boolean']>;
  verifiedAt?: Maybe<Scalars['DateTime']>;
  consumedAt?: Maybe<Scalars['DateTime']>;
  lastSentAt?: Maybe<Scalars['DateTime']>;
};

export type Error = {
  __typename?: 'Error';
  code: Scalars['String'];
  message?: Maybe<Scalars['String']>;
};

export type Evidence = {
  __typename?: 'Evidence';
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<UploadFileRelationResponseCollection>;
  location?: Maybe<Scalars['String']>;
  baorider?: Maybe<UsersPermissionsUserEntityResponse>;
  cancellationReason?: Maybe<Scalars['String']>;
  requestedInfo?: Maybe<Scalars['String']>;
  data_field_values?: Maybe<TaskDataLabelValueRelationResponseCollection>;
  task?: Maybe<TaskEntityResponse>;
  custom_data_fields?: Maybe<Array<Maybe<EvidenceCustomDataFieldsDynamicZone>>>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  accuracy?: Maybe<Scalars['Float']>;
  connectivity?: Maybe<Scalars['JSON']>;
  upload_state?: Maybe<Enum_Evidence_Upload_State>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type EvidencePhotosArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type EvidenceData_Field_ValuesArgs = {
  filters?: Maybe<TaskDataLabelValueFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};

export type EvidenceCustomDataFieldsDynamicZone = ComponentCustomDataFieldsRadio | ComponentCustomDataFieldsText | ComponentCustomDataFieldsCheckbox | ComponentCustomDataFieldsSelect | ComponentCustomDataFieldsNumberRange | ComponentCustomDataFieldsPercentage | ComponentCustomDataFieldsMetricsSpecific | ComponentCustomDataFieldsNumberDropDown | ComponentCustomDataFieldsRating | ComponentCustomDataFieldsNumberField | ComponentCustomDataFieldsDateTimeField | ComponentCustomDataFieldsDataList | ComponentCustomDataFieldsEmailField | ComponentCustomDataFieldsPhoneNumberField | ComponentCustomDataFieldsImageField | Error;


export type EvidenceEntity = {
  __typename?: 'EvidenceEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Evidence>;
};

export type EvidenceEntityResponse = {
  __typename?: 'EvidenceEntityResponse';
  data?: Maybe<EvidenceEntity>;
};

export type EvidenceEntityResponseCollection = {
  __typename?: 'EvidenceEntityResponseCollection';
  data: Array<EvidenceEntity>;
  meta: ResponseCollectionMeta;
};

export type EvidenceFiltersInput = {
  id?: Maybe<IdFilterInput>;
  notes?: Maybe<StringFilterInput>;
  location?: Maybe<StringFilterInput>;
  baorider?: Maybe<UsersPermissionsUserFiltersInput>;
  cancellationReason?: Maybe<StringFilterInput>;
  requestedInfo?: Maybe<StringFilterInput>;
  data_field_values?: Maybe<TaskDataLabelValueFiltersInput>;
  task?: Maybe<TaskFiltersInput>;
  latitude?: Maybe<FloatFilterInput>;
  longitude?: Maybe<FloatFilterInput>;
  accuracy?: Maybe<FloatFilterInput>;
  connectivity?: Maybe<JsonFilterInput>;
  upload_state?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<EvidenceFiltersInput>>>;
  or?: Maybe<Array<Maybe<EvidenceFiltersInput>>>;
  not?: Maybe<EvidenceFiltersInput>;
};

export type EvidenceInput = {
  notes?: Maybe<Scalars['String']>;
  photos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  location?: Maybe<Scalars['String']>;
  baorider?: Maybe<Scalars['ID']>;
  cancellationReason?: Maybe<Scalars['String']>;
  requestedInfo?: Maybe<Scalars['String']>;
  data_field_values?: Maybe<Array<Maybe<Scalars['ID']>>>;
  task?: Maybe<Scalars['ID']>;
  custom_data_fields?: Maybe<Array<Scalars['EvidenceCustomDataFieldsDynamicZoneInput']>>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  accuracy?: Maybe<Scalars['Float']>;
  connectivity?: Maybe<Scalars['JSON']>;
  upload_state?: Maybe<Enum_Evidence_Upload_State>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type EvidenceInputType = {
  input?: Maybe<EvidenceInput>;
  dataLabelValuesArr?: Maybe<Scalars['JSON']>;
  taskOfflineId?: Maybe<Scalars['String']>;
};

export type EvidenceRelationResponseCollection = {
  __typename?: 'EvidenceRelationResponseCollection';
  data: Array<EvidenceEntity>;
};

export type FeatureAccessPayload = {
  __typename?: 'FeatureAccessPayload';
  feature?: Maybe<Scalars['String']>;
  hasAccess?: Maybe<Scalars['Boolean']>;
  /** Why access is (or is not) granted: 'coupon', 'manual_grace', 'plan' or 'none'. */
  source?: Maybe<Scalars['String']>;
  /**
   * When a time-limited grant ends — a coupon's expiry, or the manual-plan
   * cutoff. Null when access is not time-limited.
   */
  accessEndsAt?: Maybe<Scalars['DateTime']>;
  /**
   * Whether the client should run the manual-plan countdown. False for
   * coupon holders, who are deliberately keeping access.
   */
  showCountdown?: Maybe<Scalars['Boolean']>;
  /**
   * Whether the account should be prompted to move onto an automated
   * (Stripe-billed) plan. True for every manual account, coupon or not.
   */
  requiresMigration?: Maybe<Scalars['Boolean']>;
  migrationDeadline?: Maybe<Scalars['DateTime']>;
  isManual?: Maybe<Scalars['Boolean']>;
};

export type FeatureCoupon = {
  __typename?: 'FeatureCoupon';
  code: Scalars['String'];
  feature: Enum_Featurecoupon_Feature;
  durationDays: Scalars['Int'];
  maxRedemptions?: Maybe<Scalars['Int']>;
  redemptionCount?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  validUntil?: Maybe<Scalars['DateTime']>;
  feature_unlocks?: Maybe<FeatureUnlockRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type FeatureCouponFeature_UnlocksArgs = {
  filters?: Maybe<FeatureUnlockFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type FeatureCouponEntity = {
  __typename?: 'FeatureCouponEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<FeatureCoupon>;
};

export type FeatureCouponEntityResponse = {
  __typename?: 'FeatureCouponEntityResponse';
  data?: Maybe<FeatureCouponEntity>;
};

export type FeatureCouponEntityResponseCollection = {
  __typename?: 'FeatureCouponEntityResponseCollection';
  data: Array<FeatureCouponEntity>;
  meta: ResponseCollectionMeta;
};

export type FeatureCouponFiltersInput = {
  id?: Maybe<IdFilterInput>;
  code?: Maybe<StringFilterInput>;
  feature?: Maybe<StringFilterInput>;
  durationDays?: Maybe<IntFilterInput>;
  maxRedemptions?: Maybe<IntFilterInput>;
  redemptionCount?: Maybe<IntFilterInput>;
  isActive?: Maybe<BooleanFilterInput>;
  validUntil?: Maybe<DateTimeFilterInput>;
  feature_unlocks?: Maybe<FeatureUnlockFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<FeatureCouponFiltersInput>>>;
  or?: Maybe<Array<Maybe<FeatureCouponFiltersInput>>>;
  not?: Maybe<FeatureCouponFiltersInput>;
};

export type FeatureCouponInput = {
  code?: Maybe<Scalars['String']>;
  feature?: Maybe<Enum_Featurecoupon_Feature>;
  durationDays?: Maybe<Scalars['Int']>;
  maxRedemptions?: Maybe<Scalars['Int']>;
  redemptionCount?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Boolean']>;
  validUntil?: Maybe<Scalars['DateTime']>;
  feature_unlocks?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type FeatureUnlock = {
  __typename?: 'FeatureUnlock';
  feature: Enum_Featureunlock_Feature;
  expiresAt: Scalars['DateTime'];
  company?: Maybe<CompanyEntityResponse>;
  feature_coupon?: Maybe<FeatureCouponEntityResponse>;
  redeemedBy?: Maybe<UsersPermissionsUserEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FeatureUnlockEntity = {
  __typename?: 'FeatureUnlockEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<FeatureUnlock>;
};

export type FeatureUnlockEntityResponse = {
  __typename?: 'FeatureUnlockEntityResponse';
  data?: Maybe<FeatureUnlockEntity>;
};

export type FeatureUnlockEntityResponseCollection = {
  __typename?: 'FeatureUnlockEntityResponseCollection';
  data: Array<FeatureUnlockEntity>;
  meta: ResponseCollectionMeta;
};

export type FeatureUnlockFiltersInput = {
  id?: Maybe<IdFilterInput>;
  feature?: Maybe<StringFilterInput>;
  expiresAt?: Maybe<DateTimeFilterInput>;
  company?: Maybe<CompanyFiltersInput>;
  feature_coupon?: Maybe<FeatureCouponFiltersInput>;
  redeemedBy?: Maybe<UsersPermissionsUserFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<FeatureUnlockFiltersInput>>>;
  or?: Maybe<Array<Maybe<FeatureUnlockFiltersInput>>>;
  not?: Maybe<FeatureUnlockFiltersInput>;
};

export type FeatureUnlockInput = {
  feature?: Maybe<Enum_Featureunlock_Feature>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  company?: Maybe<Scalars['ID']>;
  feature_coupon?: Maybe<Scalars['ID']>;
  redeemedBy?: Maybe<Scalars['ID']>;
};

export type FeatureUnlockPayload = {
  __typename?: 'FeatureUnlockPayload';
  feature?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  active?: Maybe<Scalars['Boolean']>;
};

export type FeatureUnlockRelationResponseCollection = {
  __typename?: 'FeatureUnlockRelationResponseCollection';
  data: Array<FeatureUnlockEntity>;
};

export type FileInfoInput = {
  name?: Maybe<Scalars['String']>;
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
};

export type FloatFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['Float']>>>;
  or?: Maybe<Array<Maybe<Scalars['Float']>>>;
  not?: Maybe<FloatFilterInput>;
  eq?: Maybe<Scalars['Float']>;
  eqi?: Maybe<Scalars['Float']>;
  ne?: Maybe<Scalars['Float']>;
  nei?: Maybe<Scalars['Float']>;
  startsWith?: Maybe<Scalars['Float']>;
  endsWith?: Maybe<Scalars['Float']>;
  contains?: Maybe<Scalars['Float']>;
  notContains?: Maybe<Scalars['Float']>;
  containsi?: Maybe<Scalars['Float']>;
  notContainsi?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['Float']>>>;
  between?: Maybe<Array<Maybe<Scalars['Float']>>>;
};

export type FreeTrialPayload = {
  __typename?: 'FreeTrialPayload';
  status?: Maybe<Scalars['String']>;
  trialStartsAt?: Maybe<Scalars['DateTime']>;
  trialEndsAt?: Maybe<Scalars['DateTime']>;
  billingRequired?: Maybe<Scalars['Boolean']>;
  subscriptionId?: Maybe<Scalars['ID']>;
};

export type GenericMorph = ComponentComboFieldOption | ComponentCustomDataFieldsCheckbox | ComponentCustomDataFieldsDataList | ComponentCustomDataFieldsDateTimeField | ComponentCustomDataFieldsEmailField | ComponentCustomDataFieldsImageField | ComponentCustomDataFieldsMetricsSpecific | ComponentCustomDataFieldsNumberDropDown | ComponentCustomDataFieldsNumberField | ComponentCustomDataFieldsNumberRange | ComponentCustomDataFieldsPercentage | ComponentCustomDataFieldsPhoneNumberField | ComponentCustomDataFieldsRadio | ComponentCustomDataFieldsRating | ComponentCustomDataFieldsSelect | ComponentCustomDataFieldsText | ComponentFaqFaq | ComponentPricePlansPlans | ComponentProductFeaturePlanFeature | ComponentProductFeatureProductFeature | ComponentTrainingVideoTrainingVideo | UploadFile | UploadFolder | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsUser | I18NLocale | Analytic | BaoverifierApp | Category | Community | Company | CustomDataLabel | DataLabelType | DataList | DataListOption | EmailOtp | Evidence | FeatureCoupon | FeatureUnlock | InsightReport | Notification | ProductPlan | Project | ProjectDataLabelTypeOption | Request | ScheduledCronEmailStatus | ScheduledCronJob | ScheduledNotification | Subscription | Task | TaskDataLabelValue | TaskDefinition | TaskType | TermsAndCondition | TrainingVideo | UnSdg | Video;

export type I18NLocale = {
  __typename?: 'I18NLocale';
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type I18NLocaleEntity = {
  __typename?: 'I18NLocaleEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<I18NLocale>;
};

export type I18NLocaleEntityResponse = {
  __typename?: 'I18NLocaleEntityResponse';
  data?: Maybe<I18NLocaleEntity>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  data: Array<I18NLocaleEntity>;
  meta: ResponseCollectionMeta;
};

export type I18NLocaleFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  code?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<I18NLocaleFiltersInput>>>;
  or?: Maybe<Array<Maybe<I18NLocaleFiltersInput>>>;
  not?: Maybe<I18NLocaleFiltersInput>;
};

export type IdFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['ID']>>>;
  or?: Maybe<Array<Maybe<Scalars['ID']>>>;
  not?: Maybe<IdFilterInput>;
  eq?: Maybe<Scalars['ID']>;
  eqi?: Maybe<Scalars['ID']>;
  ne?: Maybe<Scalars['ID']>;
  nei?: Maybe<Scalars['ID']>;
  startsWith?: Maybe<Scalars['ID']>;
  endsWith?: Maybe<Scalars['ID']>;
  contains?: Maybe<Scalars['ID']>;
  notContains?: Maybe<Scalars['ID']>;
  containsi?: Maybe<Scalars['ID']>;
  notContainsi?: Maybe<Scalars['ID']>;
  gt?: Maybe<Scalars['ID']>;
  gte?: Maybe<Scalars['ID']>;
  lt?: Maybe<Scalars['ID']>;
  lte?: Maybe<Scalars['ID']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['ID']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['ID']>>>;
  between?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type InsightAiMessageInput = {
  role: Scalars['String'];
  content: Scalars['String'];
};

export type InsightAiResponse = {
  __typename?: 'InsightAIResponse';
  message?: Maybe<Scalars['String']>;
  suggestions?: Maybe<Array<Maybe<InsightAiSuggestion>>>;
  suggestedChartType?: Maybe<Scalars['String']>;
  suggestedColumns?: Maybe<Array<Maybe<Scalars['String']>>>;
  reportPlan?: Maybe<Scalars['JSON']>;
};

export type InsightAiSuggestion = {
  __typename?: 'InsightAISuggestion';
  label?: Maybe<Scalars['String']>;
  prompt?: Maybe<Scalars['String']>;
};

export type InsightAgentFilterInput = {
  column: Scalars['String'];
  operator: Scalars['String'];
  value?: Maybe<Scalars['JSON']>;
};

export type InsightAgentReportInput = {
  taskDefinitionIds: Array<Scalars['ID']>;
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  chartType: Scalars['String'];
  selectedColumns: Array<Scalars['String']>;
  aggregation?: Maybe<Scalars['String']>;
  timeSeries?: Maybe<Scalars['String']>;
  dateRange?: Maybe<DateRangeInput>;
  dateSource?: Maybe<Scalars['String']>;
  statuses?: Maybe<Array<Scalars['String']>>;
  filters?: Maybe<Array<InsightAgentFilterInput>>;
  previewOnly?: Maybe<Scalars['Boolean']>;
};

export type InsightAgentReportResult = {
  __typename?: 'InsightAgentReportResult';
  preview: Scalars['JSON'];
  report?: Maybe<InsightReportEntity>;
  warnings: Array<Scalars['String']>;
};

export type InsightColumn = {
  __typename?: 'InsightColumn';
  key?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  isFromOlderVersion?: Maybe<Scalars['Boolean']>;
  taskTypeName?: Maybe<Scalars['String']>;
  taskTypeId?: Maybe<Scalars['String']>;
};

export type InsightReport = {
  __typename?: 'InsightReport';
  /** Chart count, types and a first-chart thumbnail — what the reports list draws. */
  graphSummary?: Maybe<Scalars['JSON']>;
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  status?: Maybe<Enum_Insightreport_Status>;
  graphs?: Maybe<Scalars['JSON']>;
  company?: Maybe<CompanyEntityResponse>;
  created_by_user?: Maybe<UsersPermissionsUserEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InsightReportCustomInput = {
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  graphs?: Maybe<Scalars['JSON']>;
};

export type InsightReportEntity = {
  __typename?: 'InsightReportEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<InsightReport>;
};

export type InsightReportEntityResponse = {
  __typename?: 'InsightReportEntityResponse';
  data?: Maybe<InsightReportEntity>;
};

export type InsightReportEntityResponseCollection = {
  __typename?: 'InsightReportEntityResponseCollection';
  data: Array<InsightReportEntity>;
  meta: ResponseCollectionMeta;
};

export type InsightReportFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  description?: Maybe<StringFilterInput>;
  status?: Maybe<StringFilterInput>;
  graphs?: Maybe<JsonFilterInput>;
  company?: Maybe<CompanyFiltersInput>;
  created_by_user?: Maybe<UsersPermissionsUserFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<InsightReportFiltersInput>>>;
  or?: Maybe<Array<Maybe<InsightReportFiltersInput>>>;
  not?: Maybe<InsightReportFiltersInput>;
};

export type InsightReportInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  status?: Maybe<Enum_Insightreport_Status>;
  graphs?: Maybe<Scalars['JSON']>;
  company?: Maybe<Scalars['ID']>;
  created_by_user?: Maybe<Scalars['ID']>;
};

export type InsightTaskData = {
  __typename?: 'InsightTaskData';
  columns?: Maybe<Array<Maybe<InsightColumn>>>;
  rows?: Maybe<Scalars['JSON']>;
  aggregatedData?: Maybe<Scalars['JSON']>;
  totalRows?: Maybe<Scalars['Int']>;
  dateInfo?: Maybe<Scalars['JSON']>;
};

export type IntFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['Int']>>>;
  or?: Maybe<Array<Maybe<Scalars['Int']>>>;
  not?: Maybe<IntFilterInput>;
  eq?: Maybe<Scalars['Int']>;
  eqi?: Maybe<Scalars['Int']>;
  ne?: Maybe<Scalars['Int']>;
  nei?: Maybe<Scalars['Int']>;
  startsWith?: Maybe<Scalars['Int']>;
  endsWith?: Maybe<Scalars['Int']>;
  contains?: Maybe<Scalars['Int']>;
  notContains?: Maybe<Scalars['Int']>;
  containsi?: Maybe<Scalars['Int']>;
  notContainsi?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['Int']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['Int']>>>;
  between?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type InvoicePayload = {
  __typename?: 'InvoicePayload';
  id?: Maybe<Scalars['ID']>;
  account_country?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
  account_tax_ids?: Maybe<Scalars['String']>;
  amount_due?: Maybe<Scalars['Float']>;
  amount_paid?: Maybe<Scalars['Float']>;
  amount_remaining?: Maybe<Scalars['Float']>;
  application_fee_amount?: Maybe<Scalars['Float']>;
  attempt_count?: Maybe<Scalars['Int']>;
  attempted?: Maybe<Scalars['Boolean']>;
  auto_advance?: Maybe<Scalars['Boolean']>;
  billing_reason?: Maybe<Scalars['String']>;
  collection_method?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Scalars['String']>;
  customer?: Maybe<Scalars['String']>;
  default_payment_method?: Maybe<Scalars['String']>;
  default_source?: Maybe<Scalars['String']>;
  default_tax_rates?: Maybe<Array<Maybe<Scalars['Float']>>>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Float']>;
  discounts?: Maybe<Array<Maybe<Scalars['Float']>>>;
  due_date?: Maybe<Scalars['String']>;
  ending_balance?: Maybe<Scalars['Float']>;
  hosted_invoice_url?: Maybe<Scalars['String']>;
  invoice_pdf?: Maybe<Scalars['String']>;
  paid?: Maybe<Scalars['Boolean']>;
  period_end?: Maybe<Scalars['String']>;
  period_start?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subscription?: Maybe<Scalars['String']>;
  lines?: Maybe<Scalars['JSON']>;
  number?: Maybe<Scalars['String']>;
};

export type IsListInUseResponse = {
  __typename?: 'IsListInUseResponse';
  isListInUse?: Maybe<Scalars['Boolean']>;
  amountOfUses?: Maybe<Scalars['Int']>;
  foundLists?: Maybe<Array<Maybe<ComponentCustomDataFieldsDataList>>>;
};


export type JsonFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  or?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  not?: Maybe<JsonFilterInput>;
  eq?: Maybe<Scalars['JSON']>;
  eqi?: Maybe<Scalars['JSON']>;
  ne?: Maybe<Scalars['JSON']>;
  nei?: Maybe<Scalars['JSON']>;
  startsWith?: Maybe<Scalars['JSON']>;
  endsWith?: Maybe<Scalars['JSON']>;
  contains?: Maybe<Scalars['JSON']>;
  notContains?: Maybe<Scalars['JSON']>;
  containsi?: Maybe<Scalars['JSON']>;
  notContainsi?: Maybe<Scalars['JSON']>;
  gt?: Maybe<Scalars['JSON']>;
  gte?: Maybe<Scalars['JSON']>;
  lt?: Maybe<Scalars['JSON']>;
  lte?: Maybe<Scalars['JSON']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  between?: Maybe<Array<Maybe<Scalars['JSON']>>>;
};


export type LongFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['Long']>>>;
  or?: Maybe<Array<Maybe<Scalars['Long']>>>;
  not?: Maybe<LongFilterInput>;
  eq?: Maybe<Scalars['Long']>;
  eqi?: Maybe<Scalars['Long']>;
  ne?: Maybe<Scalars['Long']>;
  nei?: Maybe<Scalars['Long']>;
  startsWith?: Maybe<Scalars['Long']>;
  endsWith?: Maybe<Scalars['Long']>;
  contains?: Maybe<Scalars['Long']>;
  notContains?: Maybe<Scalars['Long']>;
  containsi?: Maybe<Scalars['Long']>;
  notContainsi?: Maybe<Scalars['Long']>;
  gt?: Maybe<Scalars['Long']>;
  gte?: Maybe<Scalars['Long']>;
  lt?: Maybe<Scalars['Long']>;
  lte?: Maybe<Scalars['Long']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['Long']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['Long']>>>;
  between?: Maybe<Array<Maybe<Scalars['Long']>>>;
};

export type Metric = {
  __typename?: 'Metric';
  total: Scalars['Float'];
  last30Days: Scalars['Float'];
  chartData?: Maybe<Array<Maybe<ChartData>>>;
};

export type MigrateToAutomatedPlanInput = {
  productPlanId: Scalars['ID'];
  paymentMethodId: Scalars['String'];
  currency?: Maybe<Scalars['String']>;
};

export type MultipleBaoriderPayload = {
  __typename?: 'MultipleBaoriderPayload';
  baoriders?: Maybe<Array<Maybe<UsersPermissionsUserEntity>>>;
  phoneNumberWarnings?: Maybe<Array<BaoriderPhoneNumberWarning>>;
};

export type MultipleCommunityMembersPayload = {
  __typename?: 'MultipleCommunityMembersPayload';
  members?: Maybe<Array<Maybe<UsersPermissionsUserEntity>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createBaoleaderCommunity?: Maybe<CommunityEntity>;
  updateBaoleaderCommunity?: Maybe<CommunityEntity>;
  sendContactMessage: ContactMessageResult;
  removeCompanyMember?: Maybe<UsersPermissionsUserEntity>;
  unarchiveCompanyMember?: Maybe<UsersPermissionsUserEntity>;
  requestUpdateCompanyDetails?: Maybe<Company>;
  updateCompanyOnboardingInformation?: Maybe<CompanyEntity>;
  createBaoriderEvidence: EvidenceEntity;
  updateBaoriderEvidence: Evidence;
  updateBaoleaderEvidence: Evidence;
  createBaoleaderProject?: Maybe<ProjectEntity>;
  updateBaoleaderProject?: Maybe<ProjectEntity>;
  addDataCollectorToProject?: Maybe<ProjectEntity>;
  useProjectTemplate?: Maybe<ProjectEntity>;
  useProjectTemplates?: Maybe<Array<Maybe<ProjectEntity>>>;
  exportExcel?: Maybe<Scalars['JSON']>;
  acceptBaoriderTask: TaskEntity;
  createBaoleaderTask: TaskEntity;
  createBaoverifierTask: TaskEntity;
  createBaoverifierFullTask: TaskAndEvidenceType;
  createBaoverifierFullTaskFromDesktop: TaskAndEvidenceType;
  updateBaoleaderTask: TaskEntity;
  deleteBaoleaderTask?: Maybe<TaskEntity>;
  updateBaoriderTask: TaskEntity;
  requestMoreInfo: TaskEntity;
  createDataLabelValue?: Maybe<TaskDataLabelValue>;
  createBaoleaderTaskDefinition: TaskDefinitionEntity;
  updateBaoleaderTaskDefinition: TaskDefinitionEntity;
  deleteBaoleaderTaskDefinition?: Maybe<TaskDefinitionEntity>;
  createBaoleaderTaskType: TaskTypeEntity;
  updateBaoleaderTaskType: TaskTypeEntity;
  deactivateTaskType: TaskTypeEntity;
  activateTaskType: TaskTypeEntity;
  verifyDatacollectOtp?: Maybe<CodeValid>;
  resendDataCollectorInvite?: Maybe<UsersPermissionsUserEntity>;
  dataCollectorInviteLink: DataCollectorInviteLink;
  changeMyPassword?: Maybe<UsersPermissionsUserEntity>;
  createBaoriders: MultipleBaoriderPayload;
  createBaoleader: BaoleaderPayload;
  createBaorider: BaoriderPayload;
  updateBaorider: BaoriderPayload;
  removeBaorider: BaoriderPayload;
  updateMyUser?: Maybe<UsersPermissionsUserEntity>;
  skipOnboardingStep?: Maybe<UsersPermissionsUserEntity>;
  completeOnboardingStep?: Maybe<UsersPermissionsUserEntity>;
  createCommunityMembers: Array<Maybe<CommunityMembersPayload>>;
  createCommunityMember: CommunityMembersPayload;
  updateCommunityMember: CommunityMembersPayload;
  removeCommunityMember: CommunityMembersPayload;
  suggestCommunityMember: CommunityMembersPayload;
  acceptCommunityMemberRequest: UsersPermissionsUserEntity;
  rejectCommunityMemberRequest: UsersPermissionsUserEntity;
  migrateToAutomatedPlan?: Maybe<PlanMigrationPayload>;
  createNewSubscription?: Maybe<Subscription>;
  createSetupIntent?: Maybe<SetupIntentPayload>;
  setDefaultPaymentMethod: Scalars['Boolean'];
  removePaymentMethod: Scalars['Boolean'];
  startFreeTrial?: Maybe<FreeTrialPayload>;
  changeSubscriptionPlan?: Maybe<PlanChangePayload>;
  cancelSubscription?: Maybe<SubscriptionCancellationPayload>;
  resumeSubscription?: Maybe<SubscriptionCancellationPayload>;
  loginCustomerPortal?: Maybe<Scalars['String']>;
  createBaoleaderNotification?: Maybe<NotificationEntity>;
  updateBaoleaderNotification?: Maybe<NotificationEntity>;
  markDataCollectorNotificationAsRead?: Maybe<NotificationEntity>;
  markDataCollectorNotificationAsUnread?: Maybe<NotificationEntity>;
  deleteBaoleaderNotification?: Maybe<NotificationEntity>;
  markNotificationAsReceived?: Maybe<PushNotificationStatusEntity>;
  createBaoleaderScheduledNotification?: Maybe<ScheduledNotificationEntity>;
  updateBaoleaderScheduledNotification?: Maybe<ScheduledNotificationEntity>;
  deleteBaoleaderScheduledNotification?: Maybe<ScheduledNotificationEntity>;
  createBaoleaderInsightReport: InsightReportEntity;
  executeInsightReportAgent: InsightAgentReportResult;
  updateBaoleaderInsightReport: InsightReportEntity;
  deleteBaoleaderInsightReport?: Maybe<InsightReportEntity>;
  redeemFeatureCoupon?: Maybe<FeatureUnlockPayload>;
  createUploadFile?: Maybe<UploadFileEntityResponse>;
  updateUploadFile?: Maybe<UploadFileEntityResponse>;
  deleteUploadFile?: Maybe<UploadFileEntityResponse>;
  createUploadFolder?: Maybe<UploadFolderEntityResponse>;
  updateUploadFolder?: Maybe<UploadFolderEntityResponse>;
  deleteUploadFolder?: Maybe<UploadFolderEntityResponse>;
  updateAnalytic?: Maybe<AnalyticEntityResponse>;
  deleteAnalytic?: Maybe<AnalyticEntityResponse>;
  updateBaoverifierApp?: Maybe<BaoverifierAppEntityResponse>;
  deleteBaoverifierApp?: Maybe<BaoverifierAppEntityResponse>;
  createCategory?: Maybe<CategoryEntityResponse>;
  updateCategory?: Maybe<CategoryEntityResponse>;
  deleteCategory?: Maybe<CategoryEntityResponse>;
  createCommunity?: Maybe<CommunityEntityResponse>;
  updateCommunity?: Maybe<CommunityEntityResponse>;
  deleteCommunity?: Maybe<CommunityEntityResponse>;
  createCompany?: Maybe<CompanyEntityResponse>;
  updateCompany?: Maybe<CompanyEntityResponse>;
  deleteCompany?: Maybe<CompanyEntityResponse>;
  createCustomDataLabel?: Maybe<CustomDataLabelEntityResponse>;
  updateCustomDataLabel?: Maybe<CustomDataLabelEntityResponse>;
  deleteCustomDataLabel?: Maybe<CustomDataLabelEntityResponse>;
  createDataLabelType?: Maybe<DataLabelTypeEntityResponse>;
  updateDataLabelType?: Maybe<DataLabelTypeEntityResponse>;
  deleteDataLabelType?: Maybe<DataLabelTypeEntityResponse>;
  createDataList?: Maybe<DataListEntityResponse>;
  updateDataList?: Maybe<DataListEntityResponse>;
  deleteDataList?: Maybe<DataListEntityResponse>;
  createDataListOption?: Maybe<DataListOptionEntityResponse>;
  updateDataListOption?: Maybe<DataListOptionEntityResponse>;
  deleteDataListOption?: Maybe<DataListOptionEntityResponse>;
  createEmailOtp?: Maybe<EmailOtpEntityResponse>;
  updateEmailOtp?: Maybe<EmailOtpEntityResponse>;
  deleteEmailOtp?: Maybe<EmailOtpEntityResponse>;
  createEvidence?: Maybe<EvidenceEntityResponse>;
  updateEvidence?: Maybe<EvidenceEntityResponse>;
  deleteEvidence?: Maybe<EvidenceEntityResponse>;
  createFeatureCoupon?: Maybe<FeatureCouponEntityResponse>;
  updateFeatureCoupon?: Maybe<FeatureCouponEntityResponse>;
  deleteFeatureCoupon?: Maybe<FeatureCouponEntityResponse>;
  createFeatureUnlock?: Maybe<FeatureUnlockEntityResponse>;
  updateFeatureUnlock?: Maybe<FeatureUnlockEntityResponse>;
  deleteFeatureUnlock?: Maybe<FeatureUnlockEntityResponse>;
  createInsightReport?: Maybe<InsightReportEntityResponse>;
  updateInsightReport?: Maybe<InsightReportEntityResponse>;
  deleteInsightReport?: Maybe<InsightReportEntityResponse>;
  createNotification?: Maybe<NotificationEntityResponse>;
  updateNotification?: Maybe<NotificationEntityResponse>;
  deleteNotification?: Maybe<NotificationEntityResponse>;
  createProductPlan?: Maybe<ProductPlanEntityResponse>;
  updateProductPlan?: Maybe<ProductPlanEntityResponse>;
  deleteProductPlan?: Maybe<ProductPlanEntityResponse>;
  createProject?: Maybe<ProjectEntityResponse>;
  updateProject?: Maybe<ProjectEntityResponse>;
  deleteProject?: Maybe<ProjectEntityResponse>;
  createProjectDataLabelTypeOption?: Maybe<ProjectDataLabelTypeOptionEntityResponse>;
  updateProjectDataLabelTypeOption?: Maybe<ProjectDataLabelTypeOptionEntityResponse>;
  deleteProjectDataLabelTypeOption?: Maybe<ProjectDataLabelTypeOptionEntityResponse>;
  createRequest?: Maybe<RequestEntityResponse>;
  updateRequest?: Maybe<RequestEntityResponse>;
  deleteRequest?: Maybe<RequestEntityResponse>;
  createScheduledCronEmailStatus?: Maybe<ScheduledCronEmailStatusEntityResponse>;
  updateScheduledCronEmailStatus?: Maybe<ScheduledCronEmailStatusEntityResponse>;
  deleteScheduledCronEmailStatus?: Maybe<ScheduledCronEmailStatusEntityResponse>;
  createScheduledCronJob?: Maybe<ScheduledCronJobEntityResponse>;
  updateScheduledCronJob?: Maybe<ScheduledCronJobEntityResponse>;
  deleteScheduledCronJob?: Maybe<ScheduledCronJobEntityResponse>;
  createScheduledNotification?: Maybe<ScheduledNotificationEntityResponse>;
  updateScheduledNotification?: Maybe<ScheduledNotificationEntityResponse>;
  deleteScheduledNotification?: Maybe<ScheduledNotificationEntityResponse>;
  createSubscription?: Maybe<SubscriptionEntityResponse>;
  updateSubscription?: Maybe<SubscriptionEntityResponse>;
  deleteSubscription?: Maybe<SubscriptionEntityResponse>;
  createTask?: Maybe<TaskEntityResponse>;
  updateTask?: Maybe<TaskEntityResponse>;
  deleteTask?: Maybe<TaskEntityResponse>;
  createTaskDataLabelValue?: Maybe<TaskDataLabelValueEntityResponse>;
  updateTaskDataLabelValue?: Maybe<TaskDataLabelValueEntityResponse>;
  deleteTaskDataLabelValue?: Maybe<TaskDataLabelValueEntityResponse>;
  createTaskDefinition?: Maybe<TaskDefinitionEntityResponse>;
  updateTaskDefinition?: Maybe<TaskDefinitionEntityResponse>;
  deleteTaskDefinition?: Maybe<TaskDefinitionEntityResponse>;
  createTaskType?: Maybe<TaskTypeEntityResponse>;
  updateTaskType?: Maybe<TaskTypeEntityResponse>;
  deleteTaskType?: Maybe<TaskTypeEntityResponse>;
  updateTermsAndCondition?: Maybe<TermsAndConditionEntityResponse>;
  deleteTermsAndCondition?: Maybe<TermsAndConditionEntityResponse>;
  updateTrainingVideo?: Maybe<TrainingVideoEntityResponse>;
  deleteTrainingVideo?: Maybe<TrainingVideoEntityResponse>;
  createUnSdg?: Maybe<UnSdgEntityResponse>;
  updateUnSdg?: Maybe<UnSdgEntityResponse>;
  deleteUnSdg?: Maybe<UnSdgEntityResponse>;
  createVideo?: Maybe<VideoEntityResponse>;
  updateVideo?: Maybe<VideoEntityResponse>;
  deleteVideo?: Maybe<VideoEntityResponse>;
  upload: UploadFileEntityResponse;
  multipleUpload: Array<Maybe<UploadFileEntityResponse>>;
  updateFileInfo: UploadFileEntityResponse;
  removeFile?: Maybe<UploadFileEntityResponse>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  login: UsersPermissionsLoginPayload;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
};


export type MutationCreateBaoleaderCommunityArgs = {
  input?: Maybe<CommunityInput>;
};


export type MutationUpdateBaoleaderCommunityArgs = {
  id: Scalars['ID'];
  input?: Maybe<CommunityInput>;
};


export type MutationSendContactMessageArgs = {
  input: SendContactMessageInput;
};


export type MutationRemoveCompanyMemberArgs = {
  memberId: Scalars['ID'];
};


export type MutationUnarchiveCompanyMemberArgs = {
  memberId: Scalars['ID'];
};


export type MutationRequestUpdateCompanyDetailsArgs = {
  data: RequestCompanyDetailsChangeInput;
};


export type MutationUpdateCompanyOnboardingInformationArgs = {
  onboardingInformation: Scalars['JSON'];
};


export type MutationCreateBaoriderEvidenceArgs = {
  input?: Maybe<EvidenceInput>;
  dataLabelValuesArr?: Maybe<Scalars['JSON']>;
};


export type MutationUpdateBaoriderEvidenceArgs = {
  id: Scalars['ID'];
  input?: Maybe<EvidenceInput>;
};


export type MutationUpdateBaoleaderEvidenceArgs = {
  id: Scalars['ID'];
  input?: Maybe<EvidenceInput>;
};


export type MutationCreateBaoleaderProjectArgs = {
  input?: Maybe<ProjectInput>;
};


export type MutationUpdateBaoleaderProjectArgs = {
  id: Scalars['ID'];
  input?: Maybe<ProjectInput>;
};


export type MutationAddDataCollectorToProjectArgs = {
  input?: Maybe<AddDataCollectorToProjectInput>;
};


export type MutationUseProjectTemplateArgs = {
  templateId: Scalars['ID'];
};


export type MutationUseProjectTemplatesArgs = {
  templateIds: Array<Scalars['ID']>;
};


export type MutationExportExcelArgs = {
  filterValues?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
};


export type MutationAcceptBaoriderTaskArgs = {
  id: Scalars['ID'];
};


export type MutationCreateBaoleaderTaskArgs = {
  input?: Maybe<TaskInput>;
};


export type MutationCreateBaoverifierTaskArgs = {
  input?: Maybe<TaskInput>;
};


export type MutationCreateBaoverifierFullTaskArgs = {
  task?: Maybe<TaskInput>;
  evidence?: Maybe<EvidenceInputType>;
  taskEdited?: Maybe<Scalars['String']>;
};


export type MutationCreateBaoverifierFullTaskFromDesktopArgs = {
  task?: Maybe<TaskInput>;
  evidence?: Maybe<EvidenceInputType>;
  taskEdited?: Maybe<Scalars['String']>;
};


export type MutationUpdateBaoleaderTaskArgs = {
  id: Scalars['ID'];
  input: TaskInput;
};


export type MutationDeleteBaoleaderTaskArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateBaoriderTaskArgs = {
  id: Scalars['ID'];
  input?: Maybe<TaskInput>;
};


export type MutationRequestMoreInfoArgs = {
  id: Scalars['ID'];
  input?: Maybe<TaskInput>;
};


export type MutationCreateDataLabelValueArgs = {
  input?: Maybe<TaskDataLabelValueInput>;
};


export type MutationCreateBaoleaderTaskDefinitionArgs = {
  input?: Maybe<TaskDefinitionInput>;
};


export type MutationUpdateBaoleaderTaskDefinitionArgs = {
  id: Scalars['ID'];
  input?: Maybe<TaskDefinitionInput>;
};


export type MutationDeleteBaoleaderTaskDefinitionArgs = {
  id: Scalars['ID'];
};


export type MutationCreateBaoleaderTaskTypeArgs = {
  input: TaskTypeInput;
  dataFieldsArr?: Maybe<Scalars['JSON']>;
};


export type MutationUpdateBaoleaderTaskTypeArgs = {
  id: Scalars['ID'];
  input: TaskTypeInput;
  dataFieldsArr?: Maybe<Scalars['JSON']>;
  diffs?: Maybe<Scalars['JSON']>;
};


export type MutationDeactivateTaskTypeArgs = {
  id: Scalars['ID'];
};


export type MutationActivateTaskTypeArgs = {
  id: Scalars['ID'];
};


export type MutationVerifyDatacollectOtpArgs = {
  code: Scalars['String'];
  otp: Scalars['String'];
};


export type MutationResendDataCollectorInviteArgs = {
  id: Scalars['ID'];
};


export type MutationDataCollectorInviteLinkArgs = {
  id: Scalars['ID'];
};


export type MutationChangeMyPasswordArgs = {
  password: Scalars['String'];
  passwordNew: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationCreateBaoridersArgs = {
  input: Array<Maybe<CreateBaoriderInput>>;
};


export type MutationCreateBaoleaderArgs = {
  input: CreateBaoleaderInput;
};


export type MutationCreateBaoriderArgs = {
  input: CreateBaoriderInput;
  sendInvite?: Maybe<Scalars['Boolean']>;
};


export type MutationUpdateBaoriderArgs = {
  id: Scalars['ID'];
  baorider?: Maybe<UpdateBaoriderInput>;
};


export type MutationRemoveBaoriderArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateMyUserArgs = {
  input?: Maybe<UpdateMyUserInput>;
};


export type MutationSkipOnboardingStepArgs = {
  index: Scalars['String'];
  completeOnboarding?: Maybe<Scalars['Boolean']>;
};


export type MutationCompleteOnboardingStepArgs = {
  index: Scalars['String'];
  completeOnboarding?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateCommunityMembersArgs = {
  input?: Maybe<Array<Maybe<CreateCommunityMembersInput>>>;
};


export type MutationCreateCommunityMemberArgs = {
  input?: Maybe<CreateCommunityMembersInput>;
  sendInvite?: Maybe<Scalars['Boolean']>;
};


export type MutationUpdateCommunityMemberArgs = {
  id: Scalars['ID'];
  input?: Maybe<UpdateCommunityMembersInput>;
};


export type MutationRemoveCommunityMemberArgs = {
  id: Scalars['ID'];
};


export type MutationSuggestCommunityMemberArgs = {
  input?: Maybe<SuggestCommunityMembersInput>;
};


export type MutationAcceptCommunityMemberRequestArgs = {
  requestId: Scalars['ID'];
};


export type MutationRejectCommunityMemberRequestArgs = {
  requestId: Scalars['ID'];
};


export type MutationMigrateToAutomatedPlanArgs = {
  input?: Maybe<MigrateToAutomatedPlanInput>;
};


export type MutationCreateNewSubscriptionArgs = {
  input?: Maybe<CreateNewSubscriptionInput>;
};


export type MutationSetDefaultPaymentMethodArgs = {
  paymentMethodId: Scalars['ID'];
};


export type MutationRemovePaymentMethodArgs = {
  paymentMethodId: Scalars['ID'];
};


export type MutationStartFreeTrialArgs = {
  input?: Maybe<StartFreeTrialInput>;
};


export type MutationChangeSubscriptionPlanArgs = {
  productPlanId: Scalars['ID'];
};


export type MutationCreateBaoleaderNotificationArgs = {
  data: NotificationInput;
};


export type MutationUpdateBaoleaderNotificationArgs = {
  id: Scalars['ID'];
  data: NotificationInput;
};


export type MutationMarkDataCollectorNotificationAsReadArgs = {
  id: Scalars['ID'];
};


export type MutationMarkDataCollectorNotificationAsUnreadArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteBaoleaderNotificationArgs = {
  id: Scalars['ID'];
};


export type MutationMarkNotificationAsReceivedArgs = {
  notificationId: Scalars['ID'];
};


export type MutationCreateBaoleaderScheduledNotificationArgs = {
  input: ScheduledNotificationInput;
};


export type MutationUpdateBaoleaderScheduledNotificationArgs = {
  id: Scalars['ID'];
  input: ScheduledNotificationInput;
};


export type MutationDeleteBaoleaderScheduledNotificationArgs = {
  id: Scalars['ID'];
};


export type MutationCreateBaoleaderInsightReportArgs = {
  input: InsightReportCustomInput;
};


export type MutationExecuteInsightReportAgentArgs = {
  input: InsightAgentReportInput;
};


export type MutationUpdateBaoleaderInsightReportArgs = {
  id: Scalars['ID'];
  input: InsightReportCustomInput;
};


export type MutationDeleteBaoleaderInsightReportArgs = {
  id: Scalars['ID'];
};


export type MutationRedeemFeatureCouponArgs = {
  code: Scalars['String'];
};


export type MutationCreateUploadFileArgs = {
  data: UploadFileInput;
};


export type MutationUpdateUploadFileArgs = {
  id: Scalars['ID'];
  data: UploadFileInput;
};


export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID'];
};


export type MutationCreateUploadFolderArgs = {
  data: UploadFolderInput;
};


export type MutationUpdateUploadFolderArgs = {
  id: Scalars['ID'];
  data: UploadFolderInput;
};


export type MutationDeleteUploadFolderArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateAnalyticArgs = {
  data: AnalyticInput;
};


export type MutationUpdateBaoverifierAppArgs = {
  data: BaoverifierAppInput;
};


export type MutationCreateCategoryArgs = {
  data: CategoryInput;
};


export type MutationUpdateCategoryArgs = {
  id: Scalars['ID'];
  data: CategoryInput;
};


export type MutationDeleteCategoryArgs = {
  id: Scalars['ID'];
};


export type MutationCreateCommunityArgs = {
  data: CommunityInput;
};


export type MutationUpdateCommunityArgs = {
  id: Scalars['ID'];
  data: CommunityInput;
};


export type MutationDeleteCommunityArgs = {
  id: Scalars['ID'];
};


export type MutationCreateCompanyArgs = {
  data: CompanyInput;
};


export type MutationUpdateCompanyArgs = {
  id: Scalars['ID'];
  data: CompanyInput;
};


export type MutationDeleteCompanyArgs = {
  id: Scalars['ID'];
};


export type MutationCreateCustomDataLabelArgs = {
  data: CustomDataLabelInput;
};


export type MutationUpdateCustomDataLabelArgs = {
  id: Scalars['ID'];
  data: CustomDataLabelInput;
};


export type MutationDeleteCustomDataLabelArgs = {
  id: Scalars['ID'];
};


export type MutationCreateDataLabelTypeArgs = {
  data: DataLabelTypeInput;
};


export type MutationUpdateDataLabelTypeArgs = {
  id: Scalars['ID'];
  data: DataLabelTypeInput;
};


export type MutationDeleteDataLabelTypeArgs = {
  id: Scalars['ID'];
};


export type MutationCreateDataListArgs = {
  data: DataListInput;
};


export type MutationUpdateDataListArgs = {
  id: Scalars['ID'];
  data: DataListInput;
};


export type MutationDeleteDataListArgs = {
  id: Scalars['ID'];
};


export type MutationCreateDataListOptionArgs = {
  data: DataListOptionInput;
};


export type MutationUpdateDataListOptionArgs = {
  id: Scalars['ID'];
  data: DataListOptionInput;
};


export type MutationDeleteDataListOptionArgs = {
  id: Scalars['ID'];
};


export type MutationCreateEmailOtpArgs = {
  data: EmailOtpInput;
};


export type MutationUpdateEmailOtpArgs = {
  id: Scalars['ID'];
  data: EmailOtpInput;
};


export type MutationDeleteEmailOtpArgs = {
  id: Scalars['ID'];
};


export type MutationCreateEvidenceArgs = {
  data: EvidenceInput;
};


export type MutationUpdateEvidenceArgs = {
  id: Scalars['ID'];
  data: EvidenceInput;
};


export type MutationDeleteEvidenceArgs = {
  id: Scalars['ID'];
};


export type MutationCreateFeatureCouponArgs = {
  data: FeatureCouponInput;
};


export type MutationUpdateFeatureCouponArgs = {
  id: Scalars['ID'];
  data: FeatureCouponInput;
};


export type MutationDeleteFeatureCouponArgs = {
  id: Scalars['ID'];
};


export type MutationCreateFeatureUnlockArgs = {
  data: FeatureUnlockInput;
};


export type MutationUpdateFeatureUnlockArgs = {
  id: Scalars['ID'];
  data: FeatureUnlockInput;
};


export type MutationDeleteFeatureUnlockArgs = {
  id: Scalars['ID'];
};


export type MutationCreateInsightReportArgs = {
  data: InsightReportInput;
};


export type MutationUpdateInsightReportArgs = {
  id: Scalars['ID'];
  data: InsightReportInput;
};


export type MutationDeleteInsightReportArgs = {
  id: Scalars['ID'];
};


export type MutationCreateNotificationArgs = {
  data: NotificationInput;
};


export type MutationUpdateNotificationArgs = {
  id: Scalars['ID'];
  data: NotificationInput;
};


export type MutationDeleteNotificationArgs = {
  id: Scalars['ID'];
};


export type MutationCreateProductPlanArgs = {
  data: ProductPlanInput;
};


export type MutationUpdateProductPlanArgs = {
  id: Scalars['ID'];
  data: ProductPlanInput;
};


export type MutationDeleteProductPlanArgs = {
  id: Scalars['ID'];
};


export type MutationCreateProjectArgs = {
  data: ProjectInput;
};


export type MutationUpdateProjectArgs = {
  id: Scalars['ID'];
  data: ProjectInput;
};


export type MutationDeleteProjectArgs = {
  id: Scalars['ID'];
};


export type MutationCreateProjectDataLabelTypeOptionArgs = {
  data: ProjectDataLabelTypeOptionInput;
};


export type MutationUpdateProjectDataLabelTypeOptionArgs = {
  id: Scalars['ID'];
  data: ProjectDataLabelTypeOptionInput;
};


export type MutationDeleteProjectDataLabelTypeOptionArgs = {
  id: Scalars['ID'];
};


export type MutationCreateRequestArgs = {
  data: RequestInput;
};


export type MutationUpdateRequestArgs = {
  id: Scalars['ID'];
  data: RequestInput;
};


export type MutationDeleteRequestArgs = {
  id: Scalars['ID'];
};


export type MutationCreateScheduledCronEmailStatusArgs = {
  data: ScheduledCronEmailStatusInput;
};


export type MutationUpdateScheduledCronEmailStatusArgs = {
  id: Scalars['ID'];
  data: ScheduledCronEmailStatusInput;
};


export type MutationDeleteScheduledCronEmailStatusArgs = {
  id: Scalars['ID'];
};


export type MutationCreateScheduledCronJobArgs = {
  data: ScheduledCronJobInput;
};


export type MutationUpdateScheduledCronJobArgs = {
  id: Scalars['ID'];
  data: ScheduledCronJobInput;
};


export type MutationDeleteScheduledCronJobArgs = {
  id: Scalars['ID'];
};


export type MutationCreateScheduledNotificationArgs = {
  data: ScheduledNotificationInput;
};


export type MutationUpdateScheduledNotificationArgs = {
  id: Scalars['ID'];
  data: ScheduledNotificationInput;
};


export type MutationDeleteScheduledNotificationArgs = {
  id: Scalars['ID'];
};


export type MutationCreateSubscriptionArgs = {
  data: SubscriptionInput;
};


export type MutationUpdateSubscriptionArgs = {
  id: Scalars['ID'];
  data: SubscriptionInput;
};


export type MutationDeleteSubscriptionArgs = {
  id: Scalars['ID'];
};


export type MutationCreateTaskArgs = {
  data: TaskInput;
};


export type MutationUpdateTaskArgs = {
  id: Scalars['ID'];
  data: TaskInput;
};


export type MutationDeleteTaskArgs = {
  id: Scalars['ID'];
};


export type MutationCreateTaskDataLabelValueArgs = {
  data: TaskDataLabelValueInput;
};


export type MutationUpdateTaskDataLabelValueArgs = {
  id: Scalars['ID'];
  data: TaskDataLabelValueInput;
};


export type MutationDeleteTaskDataLabelValueArgs = {
  id: Scalars['ID'];
};


export type MutationCreateTaskDefinitionArgs = {
  data: TaskDefinitionInput;
};


export type MutationUpdateTaskDefinitionArgs = {
  id: Scalars['ID'];
  data: TaskDefinitionInput;
};


export type MutationDeleteTaskDefinitionArgs = {
  id: Scalars['ID'];
};


export type MutationCreateTaskTypeArgs = {
  data: TaskTypeInput;
};


export type MutationUpdateTaskTypeArgs = {
  id: Scalars['ID'];
  data: TaskTypeInput;
};


export type MutationDeleteTaskTypeArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateTermsAndConditionArgs = {
  data: TermsAndConditionInput;
};


export type MutationUpdateTrainingVideoArgs = {
  data: TrainingVideoInput;
};


export type MutationCreateUnSdgArgs = {
  data: UnSdgInput;
};


export type MutationUpdateUnSdgArgs = {
  id: Scalars['ID'];
  data: UnSdgInput;
};


export type MutationDeleteUnSdgArgs = {
  id: Scalars['ID'];
};


export type MutationCreateVideoArgs = {
  data: VideoInput;
};


export type MutationUpdateVideoArgs = {
  id: Scalars['ID'];
  data: VideoInput;
};


export type MutationDeleteVideoArgs = {
  id: Scalars['ID'];
};


export type MutationUploadArgs = {
  refId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  info?: Maybe<FileInfoInput>;
  file: Scalars['Upload'];
};


export type MutationMultipleUploadArgs = {
  refId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  files: Array<Maybe<Scalars['Upload']>>;
};


export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID'];
  info?: Maybe<FileInfoInput>;
};


export type MutationRemoveFileArgs = {
  id: Scalars['ID'];
};


export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};


export type MutationUpdateUsersPermissionsRoleArgs = {
  id: Scalars['ID'];
  data: UsersPermissionsRoleInput;
};


export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID'];
};


export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};


export type MutationUpdateUsersPermissionsUserArgs = {
  id: Scalars['ID'];
  data: UsersPermissionsUserInput;
};


export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID'];
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  code: Scalars['String'];
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String'];
};

export type Notification = {
  __typename?: 'Notification';
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  read?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Enum_Notification_Status>;
  type?: Maybe<Enum_Notification_Type>;
  attachment?: Maybe<UploadFileEntityResponse>;
  recipients?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  dateSent?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UsersPermissionsUserEntityResponse>;
  action?: Maybe<Scalars['JSON']>;
  timezone?: Maybe<Scalars['String']>;
  recur?: Maybe<Enum_Notification_Recur>;
  nextScheduledNotificationDetails?: Maybe<NotificationScheduledDetails>;
  scheduled_notification?: Maybe<ScheduledNotificationEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type NotificationRecipientsArgs = {
  filters?: Maybe<UsersPermissionsUserFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type NotificationEntity = {
  __typename?: 'NotificationEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Notification>;
};

export type NotificationEntityResponse = {
  __typename?: 'NotificationEntityResponse';
  data?: Maybe<NotificationEntity>;
};

export type NotificationEntityResponseCollection = {
  __typename?: 'NotificationEntityResponseCollection';
  data: Array<NotificationEntity>;
  meta: ResponseCollectionMeta;
};

export type NotificationFiltersInput = {
  id?: Maybe<IdFilterInput>;
  title?: Maybe<StringFilterInput>;
  message?: Maybe<StringFilterInput>;
  read?: Maybe<BooleanFilterInput>;
  status?: Maybe<StringFilterInput>;
  type?: Maybe<StringFilterInput>;
  recipients?: Maybe<UsersPermissionsUserFiltersInput>;
  dateSent?: Maybe<DateTimeFilterInput>;
  user?: Maybe<UsersPermissionsUserFiltersInput>;
  action?: Maybe<JsonFilterInput>;
  timezone?: Maybe<StringFilterInput>;
  recur?: Maybe<StringFilterInput>;
  scheduled_notification?: Maybe<ScheduledNotificationFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<NotificationFiltersInput>>>;
  or?: Maybe<Array<Maybe<NotificationFiltersInput>>>;
  not?: Maybe<NotificationFiltersInput>;
};

export type NotificationInput = {
  title?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  read?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Enum_Notification_Status>;
  type?: Maybe<Enum_Notification_Type>;
  attachment?: Maybe<Scalars['ID']>;
  recipients?: Maybe<Array<Maybe<Scalars['ID']>>>;
  dateSent?: Maybe<Scalars['DateTime']>;
  user?: Maybe<Scalars['ID']>;
  action?: Maybe<Scalars['JSON']>;
  timezone?: Maybe<Scalars['String']>;
  recur?: Maybe<Enum_Notification_Recur>;
  endAt?: Maybe<Scalars['DateTime']>;
  scheduled_notification?: Maybe<Scalars['ID']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type NotificationRelationResponseCollection = {
  __typename?: 'NotificationRelationResponseCollection';
  data: Array<NotificationEntity>;
};

export type NotificationScheduledDetails = {
  __typename?: 'NotificationScheduledDetails';
  id?: Maybe<Scalars['ID']>;
  sendAt?: Maybe<Scalars['DateTime']>;
  endAt?: Maybe<Scalars['DateTime']>;
  recur?: Maybe<Enum_Schedulednotification_Recur>;
  status?: Maybe<Enum_Schedulednotification_Status>;
  priority?: Maybe<Enum_Schedulednotification_Priority>;
  sent?: Maybe<Scalars['Boolean']>;
};

export type NumberOfDataCollectorsAndAdmins = {
  __typename?: 'NumberOfDataCollectorsAndAdmins';
  dataCollectors?: Maybe<Scalars['Int']>;
  admins?: Maybe<Scalars['Int']>;
};

export type Pagination = {
  __typename?: 'Pagination';
  total: Scalars['Int'];
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  pageCount: Scalars['Int'];
};

export type PaginationArg = {
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};

export type PhoneNumberWarning = {
  __typename?: 'PhoneNumberWarning';
  code: Scalars['String'];
  message: Scalars['String'];
};

export type PlanChangePayload = {
  __typename?: 'PlanChangePayload';
  status?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['ID']>;
  planName?: Maybe<Scalars['String']>;
  priceId?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
};

export type PlanMigrationPayload = {
  __typename?: 'PlanMigrationPayload';
  status?: Maybe<Scalars['String']>;
  planId?: Maybe<Scalars['ID']>;
  planName?: Maybe<Scalars['String']>;
  priceId?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  /** When the first automatic charge falls due. */
  billingStartsAt?: Maybe<Scalars['DateTime']>;
};

export type PopularTaskDefinitionEntityWithCount = {
  __typename?: 'PopularTaskDefinitionEntityWithCount';
  count: Scalars['Int'];
  taskDefinition: TaskDefinitionEntity;
};

export type Prices = {
  __typename?: 'Prices';
  id?: Maybe<Scalars['ID']>;
  active?: Maybe<Scalars['Boolean']>;
  currency?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  unit_amount?: Maybe<Scalars['Float']>;
  unit_amount_decimal?: Maybe<Scalars['Float']>;
  recurring?: Maybe<Recurring>;
};

export type ProductMetaData = {
  __typename?: 'ProductMetaData';
  baoriders_allowed?: Maybe<Scalars['Int']>;
  baoriders_cost?: Maybe<Scalars['Float']>;
};

export type ProductPlan = {
  __typename?: 'ProductPlan';
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  ProductFeature?: Maybe<ComponentProductFeatureProductFeature>;
  features?: Maybe<Array<Maybe<ComponentProductFeaturePlanFeature>>>;
  subscriptions?: Maybe<SubscriptionRelationResponseCollection>;
  isDefault?: Maybe<Scalars['Boolean']>;
  priceId?: Maybe<Scalars['String']>;
  isManual?: Maybe<Scalars['Boolean']>;
  tagline?: Maybe<Scalars['String']>;
  isPopular?: Maybe<Scalars['Boolean']>;
  sortOrder?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type ProductPlanFeaturesArgs = {
  filters?: Maybe<ComponentProductFeaturePlanFeatureFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type ProductPlanSubscriptionsArgs = {
  filters?: Maybe<SubscriptionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ProductPlanEntity = {
  __typename?: 'ProductPlanEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<ProductPlan>;
};

export type ProductPlanEntityResponse = {
  __typename?: 'ProductPlanEntityResponse';
  data?: Maybe<ProductPlanEntity>;
};

export type ProductPlanEntityResponseCollection = {
  __typename?: 'ProductPlanEntityResponseCollection';
  data: Array<ProductPlanEntity>;
  meta: ResponseCollectionMeta;
};

export type ProductPlanFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  description?: Maybe<StringFilterInput>;
  productId?: Maybe<StringFilterInput>;
  ProductFeature?: Maybe<ComponentProductFeatureProductFeatureFiltersInput>;
  features?: Maybe<ComponentProductFeaturePlanFeatureFiltersInput>;
  subscriptions?: Maybe<SubscriptionFiltersInput>;
  isDefault?: Maybe<BooleanFilterInput>;
  priceId?: Maybe<StringFilterInput>;
  isManual?: Maybe<BooleanFilterInput>;
  tagline?: Maybe<StringFilterInput>;
  isPopular?: Maybe<BooleanFilterInput>;
  sortOrder?: Maybe<IntFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<ProductPlanFiltersInput>>>;
  or?: Maybe<Array<Maybe<ProductPlanFiltersInput>>>;
  not?: Maybe<ProductPlanFiltersInput>;
};

export type ProductPlanInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  ProductFeature?: Maybe<ComponentProductFeatureProductFeatureInput>;
  features?: Maybe<Array<Maybe<ComponentProductFeaturePlanFeatureInput>>>;
  subscriptions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  isDefault?: Maybe<Scalars['Boolean']>;
  priceId?: Maybe<Scalars['String']>;
  isManual?: Maybe<Scalars['Boolean']>;
  tagline?: Maybe<Scalars['String']>;
  isPopular?: Maybe<Scalars['Boolean']>;
  sortOrder?: Maybe<Scalars['Int']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type Products = {
  __typename?: 'Products';
  id?: Maybe<Scalars['ID']>;
  active?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  statement_descriptor?: Maybe<Scalars['String']>;
  prices?: Maybe<Array<Maybe<Prices>>>;
  metadata?: Maybe<ProductMetaData>;
};

export type Project = {
  __typename?: 'Project';
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  status?: Maybe<Enum_Project_Status>;
  featured_image?: Maybe<UploadFileEntityResponse>;
  budget?: Maybe<Scalars['String']>;
  isTemplate?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<Scalars['JSON']>;
  partners?: Maybe<Enum_Project_Partners>;
  outcomes?: Maybe<Scalars['String']>;
  statement?: Maybe<Scalars['String']>;
  collaborators?: Maybe<Scalars['JSON']>;
  breakdown?: Maybe<Scalars['JSON']>;
  reward?: Maybe<Scalars['String']>;
  baoleaders?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  task_definitions?: Maybe<TaskDefinitionRelationResponseCollection>;
  companies?: Maybe<CompanyRelationResponseCollection>;
  verifiers?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type ProjectBaoleadersArgs = {
  filters?: Maybe<UsersPermissionsUserFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type ProjectTask_DefinitionsArgs = {
  filters?: Maybe<TaskDefinitionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};


export type ProjectCompaniesArgs = {
  filters?: Maybe<CompanyFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};


export type ProjectVerifiersArgs = {
  filters?: Maybe<UsersPermissionsUserFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ProjectDataLabelTypeOption = {
  __typename?: 'ProjectDataLabelTypeOption';
  value: Scalars['String'];
  custom_data_field?: Maybe<CustomDataLabelEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type ProjectDataLabelTypeOptionEntity = {
  __typename?: 'ProjectDataLabelTypeOptionEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<ProjectDataLabelTypeOption>;
};

export type ProjectDataLabelTypeOptionEntityResponse = {
  __typename?: 'ProjectDataLabelTypeOptionEntityResponse';
  data?: Maybe<ProjectDataLabelTypeOptionEntity>;
};

export type ProjectDataLabelTypeOptionEntityResponseCollection = {
  __typename?: 'ProjectDataLabelTypeOptionEntityResponseCollection';
  data: Array<ProjectDataLabelTypeOptionEntity>;
  meta: ResponseCollectionMeta;
};

export type ProjectDataLabelTypeOptionFiltersInput = {
  id?: Maybe<IdFilterInput>;
  value?: Maybe<StringFilterInput>;
  custom_data_field?: Maybe<CustomDataLabelFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<ProjectDataLabelTypeOptionFiltersInput>>>;
  or?: Maybe<Array<Maybe<ProjectDataLabelTypeOptionFiltersInput>>>;
  not?: Maybe<ProjectDataLabelTypeOptionFiltersInput>;
};

export type ProjectDataLabelTypeOptionInput = {
  value?: Maybe<Scalars['String']>;
  custom_data_field?: Maybe<Scalars['ID']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type ProjectDataLabelTypeOptionRelationResponseCollection = {
  __typename?: 'ProjectDataLabelTypeOptionRelationResponseCollection';
  data: Array<ProjectDataLabelTypeOptionEntity>;
};

export type ProjectEntity = {
  __typename?: 'ProjectEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Project>;
};

export type ProjectEntityResponse = {
  __typename?: 'ProjectEntityResponse';
  data?: Maybe<ProjectEntity>;
};

export type ProjectEntityResponseCollection = {
  __typename?: 'ProjectEntityResponseCollection';
  data: Array<ProjectEntity>;
  meta: ResponseCollectionMeta;
};

export type ProjectFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  description?: Maybe<StringFilterInput>;
  status?: Maybe<StringFilterInput>;
  budget?: Maybe<StringFilterInput>;
  isTemplate?: Maybe<BooleanFilterInput>;
  tags?: Maybe<JsonFilterInput>;
  partners?: Maybe<StringFilterInput>;
  outcomes?: Maybe<StringFilterInput>;
  statement?: Maybe<StringFilterInput>;
  collaborators?: Maybe<JsonFilterInput>;
  breakdown?: Maybe<JsonFilterInput>;
  reward?: Maybe<StringFilterInput>;
  baoleaders?: Maybe<UsersPermissionsUserFiltersInput>;
  task_definitions?: Maybe<TaskDefinitionFiltersInput>;
  companies?: Maybe<CompanyFiltersInput>;
  verifiers?: Maybe<UsersPermissionsUserFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<ProjectFiltersInput>>>;
  or?: Maybe<Array<Maybe<ProjectFiltersInput>>>;
  not?: Maybe<ProjectFiltersInput>;
};

export type ProjectInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  status?: Maybe<Enum_Project_Status>;
  featured_image?: Maybe<Scalars['ID']>;
  budget?: Maybe<Scalars['String']>;
  isTemplate?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<Scalars['JSON']>;
  partners?: Maybe<Enum_Project_Partners>;
  outcomes?: Maybe<Scalars['String']>;
  statement?: Maybe<Scalars['String']>;
  collaborators?: Maybe<Scalars['JSON']>;
  breakdown?: Maybe<Scalars['JSON']>;
  reward?: Maybe<Scalars['String']>;
  baoleaders?: Maybe<Array<Maybe<Scalars['ID']>>>;
  task_definitions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  companies?: Maybe<Array<Maybe<Scalars['ID']>>>;
  verifiers?: Maybe<Array<Maybe<Scalars['ID']>>>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type ProjectRelationResponseCollection = {
  __typename?: 'ProjectRelationResponseCollection';
  data: Array<ProjectEntity>;
};

export type ProjectSet = {
  __typename?: 'ProjectSet';
  project?: Maybe<ProjectEntity>;
  taskCompleted: Scalars['Int'];
  increaseIn30days: Scalars['Int'];
  completedPercentage: Scalars['Float'];
  chartData?: Maybe<Array<Maybe<ChartData>>>;
};

export enum PublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export type PushNotificationStatus = {
  __typename?: 'PushNotificationStatus';
  id: Scalars['ID'];
  status?: Maybe<Enum_Pushnotificationstatus_Status>;
  error?: Maybe<Scalars['Boolean']>;
  sentAt?: Maybe<Scalars['DateTime']>;
  receivedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UsersPermissionsUserEntityResponse>;
};

export type PushNotificationStatusEntity = {
  __typename?: 'PushNotificationStatusEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<PushNotificationStatus>;
};

export type Query = {
  __typename?: 'Query';
  getCategories?: Maybe<Array<Maybe<CategoryEntity>>>;
  getCompanyCategories?: Maybe<Array<Maybe<CategoryEntity>>>;
  getTaskBuilderFilterCategories?: Maybe<Array<Maybe<CategoryEntity>>>;
  getTaskBuilderFilterCreators?: Maybe<Array<Maybe<UsersPermissionsUserEntity>>>;
  getCompanyOnlyCategories?: Maybe<CategorysWithCount>;
  canDeactivateCategory?: Maybe<Scalars['Boolean']>;
  getTaskFilterCommunities?: Maybe<Array<Maybe<CommunityEntity>>>;
  getSingleBaoleaderCommunity?: Maybe<CommunityEntity>;
  getBaoleaderCommunity?: Maybe<CommunityEntity>;
  getBaoleaderCommunities?: Maybe<Array<Maybe<CommunityEntity>>>;
  getSingleBaoriderCommunity?: Maybe<BaoriderCommunityMetrics>;
  getBaoriderCommunities?: Maybe<Array<Maybe<CommunityEntity>>>;
  countCompanyCommunities?: Maybe<Scalars['Int']>;
  getCompanyInfo?: Maybe<Company>;
  countCompanyMembers?: Maybe<Scalars['Int']>;
  getAllProducts?: Maybe<Array<Maybe<Products>>>;
  getAllInvoices?: Maybe<Array<Maybe<InvoicePayload>>>;
  getSubscription?: Maybe<SubscriptionPayload>;
  getCustomerPaymentDetails?: Maybe<Array<Maybe<CardPayload>>>;
  getBaoriderEvidence?: Maybe<Evidence>;
  getTaskFilterProjects?: Maybe<Array<Maybe<ProjectEntity>>>;
  getBaoleaderProjectsCategories?: Maybe<Array<Maybe<CategorySet>>>;
  countCompanyProjects?: Maybe<Scalars['Int']>;
  getCommunityProjects?: Maybe<Array<Maybe<ProjectEntity>>>;
  getCommunityProjectsCount?: Maybe<Scalars['Int']>;
  getProjectDataCollectorsCount?: Maybe<Scalars['Int']>;
  getProjectUnsdgTags?: Maybe<Array<Maybe<Scalars['String']>>>;
  getBaoleaderProject?: Maybe<ProjectEntity>;
  getProjectMetrics?: Maybe<TaskMetrics>;
  getSingleBaoleaderProject?: Maybe<ProjectEntity>;
  getBaoleaderProjects?: Maybe<Array<Maybe<ProjectEntity>>>;
  getBaoriderProjects?: Maybe<Array<Maybe<ProjectEntity>>>;
  getSingleBaoriderProject?: Maybe<ProjectEntity>;
  getBaoriderCommunityProjects?: Maybe<Array<Maybe<ProjectEntity>>>;
  getProjectGroups?: Maybe<Array<Maybe<CommunityEntity>>>;
  getTemplateProjects?: Maybe<Array<Maybe<ProjectEntity>>>;
  getRecommendedTemplates?: Maybe<Array<Maybe<ProjectEntity>>>;
  getTemplateProjectForms?: Maybe<Array<Maybe<TemplateProjectForm>>>;
  getRequests?: Maybe<Array<Maybe<Request>>>;
  getTasksDashboardMetrics?: Maybe<TaskMetrics>;
  getBaoriderDashboardMetrics?: Maybe<BaoriderTaskMetrics>;
  getBaoleaderTasksWithCount?: Maybe<TasksWithCount>;
  getMapTasks?: Maybe<Scalars['JSON']>;
  getBaoleaderTask?: Maybe<TaskEntity>;
  getBaoriderTasks?: Maybe<TasksWithCount>;
  getNotificationTasks?: Maybe<Array<Maybe<TaskWithCanEdit>>>;
  getSingleBaoriderTask?: Maybe<TaskEntity>;
  countTasks?: Maybe<Scalars['Int']>;
  countTasksByStatus?: Maybe<Scalars['JSON']>;
  countTasksWithTrend?: Maybe<TaskCountWithTrend>;
  canEditTask?: Maybe<Scalars['Boolean']>;
  getNumberOfTasksPerProject?: Maybe<Array<Maybe<TaskPer>>>;
  getNumberOfTasksPerTaskTypeCollapsed?: Maybe<Array<Maybe<TaskPer>>>;
  getNumberOfTasksPerTaskType?: Maybe<Array<Maybe<TaskPer>>>;
  getNumberOfTasksPerDataCollector?: Maybe<Array<Maybe<TaskPer>>>;
  getNumberOfTasksPerSDG?: Maybe<Array<Maybe<TaskPer>>>;
  getNumberOfTasksPerTag?: Maybe<Array<Maybe<TaskPer>>>;
  getNumberOfTasksPerDay?: Maybe<Array<Maybe<TaskPer>>>;
  getNumberOfTasksPerMonth?: Maybe<Array<Maybe<TaskPer>>>;
  getDataCollectorTasksLeaderBoard?: Maybe<Array<Maybe<TasksWithDataCollector>>>;
  getNumberDataCollectorsTasks?: Maybe<Scalars['Int']>;
  getBaoleaderTaskDefinitions?: Maybe<Array<Maybe<TaskDefinitionEntity>>>;
  getBaoleaderTaskDefinitionsCount?: Maybe<Scalars['Int']>;
  getBaoverifierTaskDefinitions?: Maybe<Array<Maybe<TaskDefinitionEntity>>>;
  getBaoverifierTaskDefinition?: Maybe<TaskDefinitionEntity>;
  getBaoverifierMostPopularTaskDefinitions?: Maybe<Array<Maybe<PopularTaskDefinitionEntityWithCount>>>;
  getBaoleaderTaskDefinition?: Maybe<TaskDefinitionEntity>;
  getCompanyTaskTypes?: Maybe<Array<Maybe<TaskTypeEntity>>>;
  getTaskType?: Maybe<TaskTypeEntity>;
  getWholeCompanyTaskTypes?: Maybe<Array<Maybe<TaskTypeEntity>>>;
  getCompanyTaskTypesCount?: Maybe<Scalars['Int']>;
  getTaskFilterTaskTypes?: Maybe<Array<Maybe<TaskTypeEntity>>>;
  getTaskTypeProjects?: Maybe<Array<Maybe<ProjectEntity>>>;
  getTaskTypeTemplates?: Maybe<Array<Maybe<TaskTypeEntity>>>;
  getBaoriders?: Maybe<Array<Maybe<UsersPermissionsUserEntity>>>;
  getCompanyLeaders?: Maybe<Array<Maybe<UsersPermissionsUserEntity>>>;
  getCompanyLeadersCount?: Maybe<Scalars['Int']>;
  getTopPerformingUsers?: Maybe<TopPerforming>;
  myUser?: Maybe<UsersPermissionsUserEntity>;
  getTaskFilterDataCollectors?: Maybe<Array<Maybe<UsersPermissionsUserEntity>>>;
  getCommunityMembers?: Maybe<MultipleCommunityMembersPayload>;
  countCommunityMembers?: Maybe<Scalars['Int']>;
  getSingleCommunityMember?: Maybe<CommunityMembersPayload>;
  getSingleBaorider?: Maybe<BaoriderPayload>;
  getCommunityBaoriders?: Maybe<MultipleCommunityMembersPayload>;
  getCommunityVerifiers?: Maybe<MultipleCommunityMembersPayload>;
  countRiders?: Maybe<Scalars['Int']>;
  getTaskFilterDataCollectorsCount?: Maybe<Scalars['Int']>;
  getNumberOfUsers?: Maybe<NumberOfDataCollectorsAndAdmins>;
  getDataLists?: Maybe<Array<Maybe<DataListEntity>>>;
  getCountDataLists?: Maybe<Scalars['Int']>;
  isListInUse?: Maybe<IsListInUseResponse>;
  getSubscriptionPlans?: Maybe<Array<Maybe<SubscriptionPlan>>>;
  findDataListOptionWithCount?: Maybe<DataListOptionWithCount>;
  getTaskFilterUnsdgs?: Maybe<Array<Maybe<UnSdgEntity>>>;
  getDataCollectorNotifications?: Maybe<Array<Maybe<NotificationEntity>>>;
  getDataCollectorNotification?: Maybe<NotificationEntity>;
  getUnreadNotificationsCount?: Maybe<Scalars['Int']>;
  getAdminNotifications?: Maybe<Array<Maybe<NotificationEntity>>>;
  getAdminNotification?: Maybe<NotificationEntity>;
  getAdminNotificationsCount?: Maybe<Scalars['Int']>;
  deliveryReportCounts: DeliveryReportCounts;
  getCompanyScheduledNotifications?: Maybe<Array<Maybe<ScheduledNotificationEntity>>>;
  getCompanyScheduledNotificationsCount?: Maybe<Scalars['Int']>;
  getCompanyScheduledNotification?: Maybe<ScheduledNotificationEntity>;
  getInsightReports?: Maybe<Array<Maybe<InsightReportEntity>>>;
  getInsightReport?: Maybe<InsightReportEntity>;
  getInsightReportsCount?: Maybe<Scalars['Int']>;
  getInsightTaskData?: Maybe<InsightTaskData>;
  getInsightTaskDefinitions?: Maybe<Array<Maybe<TaskDefinitionEntity>>>;
  getInsightAIAnalysis?: Maybe<InsightAiResponse>;
  getMyFeatureUnlocks?: Maybe<Array<Maybe<FeatureUnlockPayload>>>;
  getMyFeatureAccess?: Maybe<FeatureAccessPayload>;
  uploadFile?: Maybe<UploadFileEntityResponse>;
  uploadFiles?: Maybe<UploadFileEntityResponseCollection>;
  uploadFolder?: Maybe<UploadFolderEntityResponse>;
  uploadFolders?: Maybe<UploadFolderEntityResponseCollection>;
  usersPermissionsRole?: Maybe<UsersPermissionsRoleEntityResponse>;
  usersPermissionsRoles?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser?: Maybe<UsersPermissionsUserEntityResponse>;
  usersPermissionsUsers?: Maybe<UsersPermissionsUserEntityResponseCollection>;
  i18NLocale?: Maybe<I18NLocaleEntityResponse>;
  i18NLocales?: Maybe<I18NLocaleEntityResponseCollection>;
  analytic?: Maybe<AnalyticEntityResponse>;
  baoverifierApp?: Maybe<BaoverifierAppEntityResponse>;
  category?: Maybe<CategoryEntityResponse>;
  categories?: Maybe<CategoryEntityResponseCollection>;
  community?: Maybe<CommunityEntityResponse>;
  communities?: Maybe<CommunityEntityResponseCollection>;
  company?: Maybe<CompanyEntityResponse>;
  companies?: Maybe<CompanyEntityResponseCollection>;
  customDataLabel?: Maybe<CustomDataLabelEntityResponse>;
  customDataLabels?: Maybe<CustomDataLabelEntityResponseCollection>;
  dataLabelType?: Maybe<DataLabelTypeEntityResponse>;
  dataLabelTypes?: Maybe<DataLabelTypeEntityResponseCollection>;
  dataList?: Maybe<DataListEntityResponse>;
  dataLists?: Maybe<DataListEntityResponseCollection>;
  dataListOption?: Maybe<DataListOptionEntityResponse>;
  dataListOptions?: Maybe<DataListOptionEntityResponseCollection>;
  emailOtp?: Maybe<EmailOtpEntityResponse>;
  emailOtps?: Maybe<EmailOtpEntityResponseCollection>;
  evidence?: Maybe<EvidenceEntityResponse>;
  evidences?: Maybe<EvidenceEntityResponseCollection>;
  featureCoupon?: Maybe<FeatureCouponEntityResponse>;
  featureCoupons?: Maybe<FeatureCouponEntityResponseCollection>;
  featureUnlock?: Maybe<FeatureUnlockEntityResponse>;
  featureUnlocks?: Maybe<FeatureUnlockEntityResponseCollection>;
  insightReport?: Maybe<InsightReportEntityResponse>;
  insightReports?: Maybe<InsightReportEntityResponseCollection>;
  notification?: Maybe<NotificationEntityResponse>;
  notifications?: Maybe<NotificationEntityResponseCollection>;
  productPlan?: Maybe<ProductPlanEntityResponse>;
  productPlans?: Maybe<ProductPlanEntityResponseCollection>;
  project?: Maybe<ProjectEntityResponse>;
  projects?: Maybe<ProjectEntityResponseCollection>;
  projectDataLabelTypeOption?: Maybe<ProjectDataLabelTypeOptionEntityResponse>;
  projectDataLabelTypeOptions?: Maybe<ProjectDataLabelTypeOptionEntityResponseCollection>;
  request?: Maybe<RequestEntityResponse>;
  requests?: Maybe<RequestEntityResponseCollection>;
  scheduledCronEmailStatus?: Maybe<ScheduledCronEmailStatusEntityResponse>;
  scheduledCronEmailStatuses?: Maybe<ScheduledCronEmailStatusEntityResponseCollection>;
  scheduledCronJob?: Maybe<ScheduledCronJobEntityResponse>;
  scheduledCronJobs?: Maybe<ScheduledCronJobEntityResponseCollection>;
  scheduledNotification?: Maybe<ScheduledNotificationEntityResponse>;
  scheduledNotifications?: Maybe<ScheduledNotificationEntityResponseCollection>;
  subscription?: Maybe<SubscriptionEntityResponse>;
  subscriptions?: Maybe<SubscriptionEntityResponseCollection>;
  task?: Maybe<TaskEntityResponse>;
  tasks?: Maybe<TaskEntityResponseCollection>;
  taskDataLabelValue?: Maybe<TaskDataLabelValueEntityResponse>;
  taskDataLabelValues?: Maybe<TaskDataLabelValueEntityResponseCollection>;
  taskDefinition?: Maybe<TaskDefinitionEntityResponse>;
  taskDefinitions?: Maybe<TaskDefinitionEntityResponseCollection>;
  taskType?: Maybe<TaskTypeEntityResponse>;
  taskTypes?: Maybe<TaskTypeEntityResponseCollection>;
  termsAndCondition?: Maybe<TermsAndConditionEntityResponse>;
  trainingVideo?: Maybe<TrainingVideoEntityResponse>;
  unSdg?: Maybe<UnSdgEntityResponse>;
  unSdgs?: Maybe<UnSdgEntityResponseCollection>;
  video?: Maybe<VideoEntityResponse>;
  videos?: Maybe<VideoEntityResponseCollection>;
  me?: Maybe<UsersPermissionsMe>;
};


export type QueryGetCategoriesArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetCompanyCategoriesArgs = {
  where?: Maybe<Scalars['JSON']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
};


export type QueryGetTaskBuilderFilterCategoriesArgs = {
  where?: Maybe<Scalars['JSON']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
};


export type QueryGetTaskBuilderFilterCreatorsArgs = {
  where?: Maybe<Scalars['JSON']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
};


export type QueryGetCompanyOnlyCategoriesArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryCanDeactivateCategoryArgs = {
  id: Scalars['ID'];
};


export type QueryGetTaskFilterCommunitiesArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetSingleBaoleaderCommunityArgs = {
  id: Scalars['ID'];
};


export type QueryGetBaoleaderCommunitiesArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetSingleBaoriderCommunityArgs = {
  id: Scalars['ID'];
};


export type QueryCountCompanyCommunitiesArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetBaoriderEvidenceArgs = {
  id: Scalars['ID'];
};


export type QueryGetTaskFilterProjectsArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryCountCompanyProjectsArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetCommunityProjectsArgs = {
  community: Scalars['ID'];
};


export type QueryGetCommunityProjectsCountArgs = {
  community: Scalars['ID'];
};


export type QueryGetProjectDataCollectorsCountArgs = {
  project: Scalars['ID'];
};


export type QueryGetProjectUnsdgTagsArgs = {
  project: Scalars['ID'];
};


export type QueryGetProjectMetricsArgs = {
  id: Scalars['ID'];
};


export type QueryGetSingleBaoleaderProjectArgs = {
  id: Scalars['ID'];
};


export type QueryGetBaoleaderProjectsArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetBaoriderProjectsArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetSingleBaoriderProjectArgs = {
  id: Scalars['ID'];
};


export type QueryGetBaoriderCommunityProjectsArgs = {
  community: Scalars['ID'];
};


export type QueryGetProjectGroupsArgs = {
  projectId: Scalars['ID'];
};


export type QueryGetTemplateProjectsArgs = {
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  partners?: Maybe<Scalars['String']>;
};


export type QueryGetTemplateProjectFormsArgs = {
  id: Scalars['ID'];
};


export type QueryGetRequestsArgs = {
  where?: Maybe<Scalars['JSON']>;
};


export type QueryGetBaoriderDashboardMetricsArgs = {
  where?: Maybe<Scalars['JSON']>;
};


export type QueryGetBaoleaderTasksWithCountArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetMapTasksArgs = {
  filters?: Maybe<Scalars['JSON']>;
  compact?: Maybe<Scalars['Boolean']>;
};


export type QueryGetBaoleaderTaskArgs = {
  id: Scalars['ID'];
};


export type QueryGetBaoriderTasksArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetNotificationTasksArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetSingleBaoriderTaskArgs = {
  id: Scalars['ID'];
};


export type QueryCountTasksArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryCountTasksByStatusArgs = {
  filters?: Maybe<Scalars['JSON']>;
};


export type QueryCountTasksWithTrendArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryCanEditTaskArgs = {
  id: Scalars['ID'];
};


export type QueryGetNumberOfTasksPerProjectArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetNumberOfTasksPerTaskTypeCollapsedArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetNumberOfTasksPerTaskTypeArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetNumberOfTasksPerDataCollectorArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetNumberOfTasksPerSdgArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetNumberOfTasksPerTagArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetNumberOfTasksPerDayArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetNumberOfTasksPerMonthArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetDataCollectorTasksLeaderBoardArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetNumberDataCollectorsTasksArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetBaoleaderTaskDefinitionsArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetBaoleaderTaskDefinitionsCountArgs = {
  filters?: Maybe<Scalars['JSON']>;
};


export type QueryGetBaoverifierTaskDefinitionsArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetBaoverifierTaskDefinitionArgs = {
  id: Scalars['ID'];
};


export type QueryGetBaoverifierMostPopularTaskDefinitionsArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetBaoleaderTaskDefinitionArgs = {
  id: Scalars['ID'];
};


export type QueryGetCompanyTaskTypesArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetTaskTypeArgs = {
  id: Scalars['ID'];
};


export type QueryGetWholeCompanyTaskTypesArgs = {
  sort?: Maybe<Scalars['JSON']>;
  filters?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
  pagination?: Maybe<PaginationArg>;
};


export type QueryGetCompanyTaskTypesCountArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetTaskFilterTaskTypesArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetTaskTypeProjectsArgs = {
  id: Scalars['ID'];
};


export type QueryGetBaoridersArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetCompanyLeadersArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<UsersPermissionsUserFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetTopPerformingUsersArgs = {
  community?: Maybe<Scalars['ID']>;
  project?: Maybe<Scalars['ID']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
};


export type QueryGetTaskFilterDataCollectorsArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetCommunityMembersArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryCountCommunityMembersArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetSingleCommunityMemberArgs = {
  where?: Maybe<Scalars['JSON']>;
};


export type QueryGetSingleBaoriderArgs = {
  id: Scalars['ID'];
};


export type QueryGetCommunityBaoridersArgs = {
  community: Scalars['ID'];
};


export type QueryGetCommunityVerifiersArgs = {
  community: Scalars['ID'];
};


export type QueryCountRidersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryGetTaskFilterDataCollectorsCountArgs = {
  filters?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetDataListsArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetCountDataListsArgs = {
  filters?: Maybe<Scalars['JSON']>;
};


export type QueryIsListInUseArgs = {
  id: Scalars['ID'];
};


export type QueryFindDataListOptionWithCountArgs = {
  orderBy?: Maybe<Scalars['JSON']>;
  filters?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
  pagination?: Maybe<PaginationArg>;
};


export type QueryGetTaskFilterUnsdgsArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetDataCollectorNotificationsArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetDataCollectorNotificationArgs = {
  id: Scalars['ID'];
};


export type QueryGetAdminNotificationsArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetAdminNotificationArgs = {
  id: Scalars['ID'];
};


export type QueryGetAdminNotificationsCountArgs = {
  filters?: Maybe<Scalars['JSON']>;
};


export type QueryDeliveryReportCountsArgs = {
  notificationId: Scalars['ID'];
};


export type QueryGetCompanyScheduledNotificationsArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryGetCompanyScheduledNotificationsCountArgs = {
  filters?: Maybe<Scalars['JSON']>;
};


export type QueryGetCompanyScheduledNotificationArgs = {
  id: Scalars['ID'];
};


export type QueryGetInsightReportsArgs = {
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
};


export type QueryGetInsightReportArgs = {
  id: Scalars['ID'];
};


export type QueryGetInsightReportsCountArgs = {
  filters?: Maybe<Scalars['JSON']>;
};


export type QueryGetInsightTaskDataArgs = {
  taskDefinitionId?: Maybe<Scalars['ID']>;
  taskDefinitionIds?: Maybe<Array<Scalars['ID']>>;
  dateRange?: Maybe<DateRangeInput>;
  dateSource?: Maybe<Scalars['String']>;
  timeSeries?: Maybe<Scalars['String']>;
  aggregation?: Maybe<Scalars['String']>;
  selectedColumns?: Maybe<Array<Maybe<Scalars['String']>>>;
  statuses?: Maybe<Array<Maybe<Scalars['String']>>>;
  filters?: Maybe<Array<InsightAgentFilterInput>>;
  groupBy?: Maybe<Scalars['String']>;
  compareYears?: Maybe<Scalars['Boolean']>;
};


export type QueryGetInsightAiAnalysisArgs = {
  taskDefinitionIds?: Maybe<Array<Scalars['ID']>>;
  columns?: Maybe<Scalars['JSON']>;
  aggregation?: Maybe<Scalars['String']>;
  timeSeries?: Maybe<Scalars['String']>;
  recordCount?: Maybe<Scalars['Int']>;
  selectedColumns?: Maybe<Array<Maybe<Scalars['String']>>>;
  messages?: Maybe<Array<Maybe<InsightAiMessageInput>>>;
  dataSummary?: Maybe<Scalars['JSON']>;
  dateRange?: Maybe<DateRangeInput>;
  dateSource?: Maybe<Scalars['String']>;
  dateInfo?: Maybe<Scalars['JSON']>;
};


export type QueryGetMyFeatureAccessArgs = {
  feature?: Maybe<Scalars['String']>;
};


export type QueryUploadFileArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryUploadFilesArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryUploadFolderArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryUploadFoldersArgs = {
  filters?: Maybe<UploadFolderFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryUsersPermissionsRoleArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryUsersPermissionsRolesArgs = {
  filters?: Maybe<UsersPermissionsRoleFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryUsersPermissionsUserArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryUsersPermissionsUsersArgs = {
  filters?: Maybe<UsersPermissionsUserFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryI18NLocaleArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryI18NLocalesArgs = {
  filters?: Maybe<I18NLocaleFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryAnalyticArgs = {
  publicationState?: Maybe<PublicationState>;
};


export type QueryBaoverifierAppArgs = {
  publicationState?: Maybe<PublicationState>;
};


export type QueryCategoryArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryCategoriesArgs = {
  filters?: Maybe<CategoryFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryCommunityArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryCommunitiesArgs = {
  filters?: Maybe<CommunityFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryCompanyArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryCompaniesArgs = {
  filters?: Maybe<CompanyFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryCustomDataLabelArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryCustomDataLabelsArgs = {
  filters?: Maybe<CustomDataLabelFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryDataLabelTypeArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryDataLabelTypesArgs = {
  filters?: Maybe<DataLabelTypeFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryDataListArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryDataListsArgs = {
  filters?: Maybe<DataListFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryDataListOptionArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryDataListOptionsArgs = {
  filters?: Maybe<DataListOptionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryEmailOtpArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryEmailOtpsArgs = {
  filters?: Maybe<EmailOtpFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryEvidenceArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryEvidencesArgs = {
  filters?: Maybe<EvidenceFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryFeatureCouponArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryFeatureCouponsArgs = {
  filters?: Maybe<FeatureCouponFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryFeatureUnlockArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryFeatureUnlocksArgs = {
  filters?: Maybe<FeatureUnlockFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryInsightReportArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryInsightReportsArgs = {
  filters?: Maybe<InsightReportFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryNotificationArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryNotificationsArgs = {
  filters?: Maybe<NotificationFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryProductPlanArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryProductPlansArgs = {
  filters?: Maybe<ProductPlanFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryProjectArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryProjectsArgs = {
  filters?: Maybe<ProjectFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryProjectDataLabelTypeOptionArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryProjectDataLabelTypeOptionsArgs = {
  filters?: Maybe<ProjectDataLabelTypeOptionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryRequestArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryRequestsArgs = {
  filters?: Maybe<RequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryScheduledCronEmailStatusArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryScheduledCronEmailStatusesArgs = {
  filters?: Maybe<ScheduledCronEmailStatusFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryScheduledCronJobArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryScheduledCronJobsArgs = {
  filters?: Maybe<ScheduledCronJobFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryScheduledNotificationArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryScheduledNotificationsArgs = {
  filters?: Maybe<ScheduledNotificationFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QuerySubscriptionArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QuerySubscriptionsArgs = {
  filters?: Maybe<SubscriptionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryTaskArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryTasksArgs = {
  filters?: Maybe<TaskFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryTaskDataLabelValueArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryTaskDataLabelValuesArgs = {
  filters?: Maybe<TaskDataLabelValueFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryTaskDefinitionArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryTaskDefinitionsArgs = {
  filters?: Maybe<TaskDefinitionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryTaskTypeArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryTaskTypesArgs = {
  filters?: Maybe<TaskTypeFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryTermsAndConditionArgs = {
  publicationState?: Maybe<PublicationState>;
};


export type QueryTrainingVideoArgs = {
  publicationState?: Maybe<PublicationState>;
};


export type QueryUnSdgArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryUnSdgsArgs = {
  filters?: Maybe<UnSdgFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryVideoArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryVideosArgs = {
  filters?: Maybe<VideoFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};

export type Recurring = {
  __typename?: 'Recurring';
  interval?: Maybe<Scalars['String']>;
  interval_count?: Maybe<Scalars['Int']>;
};

export type Request = {
  __typename?: 'Request';
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<Enum_Request_Status>;
  baoleader?: Maybe<UsersPermissionsUserEntityResponse>;
  community?: Maybe<CommunityEntityResponse>;
  community_member?: Maybe<UsersPermissionsUserEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type RequestCompanyDetailsChangeInput = {
  CompanyName?: Maybe<Scalars['String']>;
  orgID?: Maybe<Scalars['String']>;
  WildlifeAssociationNumber?: Maybe<Scalars['String']>;
  pin_registration?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  currentCompanyName?: Maybe<Scalars['String']>;
};

export type RequestEntity = {
  __typename?: 'RequestEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Request>;
};

export type RequestEntityResponse = {
  __typename?: 'RequestEntityResponse';
  data?: Maybe<RequestEntity>;
};

export type RequestEntityResponseCollection = {
  __typename?: 'RequestEntityResponseCollection';
  data: Array<RequestEntity>;
  meta: ResponseCollectionMeta;
};

export type RequestFiltersInput = {
  id?: Maybe<IdFilterInput>;
  reason?: Maybe<StringFilterInput>;
  status?: Maybe<StringFilterInput>;
  baoleader?: Maybe<UsersPermissionsUserFiltersInput>;
  community?: Maybe<CommunityFiltersInput>;
  community_member?: Maybe<UsersPermissionsUserFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<RequestFiltersInput>>>;
  or?: Maybe<Array<Maybe<RequestFiltersInput>>>;
  not?: Maybe<RequestFiltersInput>;
};

export type RequestInput = {
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<Enum_Request_Status>;
  baoleader?: Maybe<Scalars['ID']>;
  community?: Maybe<Scalars['ID']>;
  community_member?: Maybe<Scalars['ID']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type RequestRelationResponseCollection = {
  __typename?: 'RequestRelationResponseCollection';
  data: Array<RequestEntity>;
};

export type ResponseCollectionMeta = {
  __typename?: 'ResponseCollectionMeta';
  pagination: Pagination;
};

export type ScheduledCronEmailStatus = {
  __typename?: 'ScheduledCronEmailStatus';
  user_id?: Maybe<UsersPermissionsUserEntityResponse>;
  job_id?: Maybe<ScheduledCronJobEntityResponse>;
  email_sent: Scalars['Boolean'];
  email_last_added: Scalars['DateTime'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ScheduledCronEmailStatusEntity = {
  __typename?: 'ScheduledCronEmailStatusEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<ScheduledCronEmailStatus>;
};

export type ScheduledCronEmailStatusEntityResponse = {
  __typename?: 'ScheduledCronEmailStatusEntityResponse';
  data?: Maybe<ScheduledCronEmailStatusEntity>;
};

export type ScheduledCronEmailStatusEntityResponseCollection = {
  __typename?: 'ScheduledCronEmailStatusEntityResponseCollection';
  data: Array<ScheduledCronEmailStatusEntity>;
  meta: ResponseCollectionMeta;
};

export type ScheduledCronEmailStatusFiltersInput = {
  id?: Maybe<IdFilterInput>;
  user_id?: Maybe<UsersPermissionsUserFiltersInput>;
  job_id?: Maybe<ScheduledCronJobFiltersInput>;
  email_sent?: Maybe<BooleanFilterInput>;
  email_last_added?: Maybe<DateTimeFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<ScheduledCronEmailStatusFiltersInput>>>;
  or?: Maybe<Array<Maybe<ScheduledCronEmailStatusFiltersInput>>>;
  not?: Maybe<ScheduledCronEmailStatusFiltersInput>;
};

export type ScheduledCronEmailStatusInput = {
  user_id?: Maybe<Scalars['ID']>;
  job_id?: Maybe<Scalars['ID']>;
  email_sent?: Maybe<Scalars['Boolean']>;
  email_last_added?: Maybe<Scalars['DateTime']>;
};

export type ScheduledCronJob = {
  __typename?: 'ScheduledCronJob';
  jobId: Scalars['String'];
  jobType: Enum_Scheduledcronjob_Jobtype;
  status: Enum_Scheduledcronjob_Status;
  started_at: Scalars['DateTime'];
  finished_at?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ScheduledCronJobEntity = {
  __typename?: 'ScheduledCronJobEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<ScheduledCronJob>;
};

export type ScheduledCronJobEntityResponse = {
  __typename?: 'ScheduledCronJobEntityResponse';
  data?: Maybe<ScheduledCronJobEntity>;
};

export type ScheduledCronJobEntityResponseCollection = {
  __typename?: 'ScheduledCronJobEntityResponseCollection';
  data: Array<ScheduledCronJobEntity>;
  meta: ResponseCollectionMeta;
};

export type ScheduledCronJobFiltersInput = {
  id?: Maybe<IdFilterInput>;
  jobId?: Maybe<StringFilterInput>;
  jobType?: Maybe<StringFilterInput>;
  status?: Maybe<StringFilterInput>;
  started_at?: Maybe<DateTimeFilterInput>;
  finished_at?: Maybe<DateTimeFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<ScheduledCronJobFiltersInput>>>;
  or?: Maybe<Array<Maybe<ScheduledCronJobFiltersInput>>>;
  not?: Maybe<ScheduledCronJobFiltersInput>;
};

export type ScheduledCronJobInput = {
  jobId?: Maybe<Scalars['String']>;
  jobType?: Maybe<Enum_Scheduledcronjob_Jobtype>;
  status?: Maybe<Enum_Scheduledcronjob_Status>;
  started_at?: Maybe<Scalars['DateTime']>;
  finished_at?: Maybe<Scalars['DateTime']>;
};

export type ScheduledNotification = {
  __typename?: 'ScheduledNotification';
  id: Scalars['ID'];
  priority?: Maybe<Enum_Schedulednotification_Priority>;
  sendAt: Scalars['DateTime'];
  endAt?: Maybe<Scalars['DateTime']>;
  sent?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Enum_Schedulednotification_Status>;
  recur: Enum_Schedulednotification_Recur;
  notification?: Maybe<NotificationEntityResponse>;
  data?: Maybe<Scalars['JSON']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ScheduledNotificationEntity = {
  __typename?: 'ScheduledNotificationEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<ScheduledNotification>;
};

export type ScheduledNotificationEntityResponse = {
  __typename?: 'ScheduledNotificationEntityResponse';
  data?: Maybe<ScheduledNotificationEntity>;
};

export type ScheduledNotificationEntityResponseCollection = {
  __typename?: 'ScheduledNotificationEntityResponseCollection';
  data: Array<ScheduledNotificationEntity>;
  meta: ResponseCollectionMeta;
};

export type ScheduledNotificationFiltersInput = {
  id?: Maybe<IdFilterInput>;
  priority?: Maybe<StringFilterInput>;
  sendAt?: Maybe<DateTimeFilterInput>;
  endAt?: Maybe<DateTimeFilterInput>;
  sent?: Maybe<BooleanFilterInput>;
  data?: Maybe<JsonFilterInput>;
  status?: Maybe<StringFilterInput>;
  recur?: Maybe<StringFilterInput>;
  notification?: Maybe<NotificationFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<ScheduledNotificationFiltersInput>>>;
  or?: Maybe<Array<Maybe<ScheduledNotificationFiltersInput>>>;
  not?: Maybe<ScheduledNotificationFiltersInput>;
};

export type ScheduledNotificationInput = {
  notification: Scalars['ID'];
  priority?: Maybe<Enum_Schedulednotification_Priority>;
  sendAt: Scalars['DateTime'];
  endAt?: Maybe<Scalars['DateTime']>;
  recur?: Maybe<Enum_Schedulednotification_Recur>;
  sent?: Maybe<Scalars['Boolean']>;
  data?: Maybe<Scalars['JSON']>;
  status?: Maybe<Enum_Schedulednotification_Status>;
};

export type SendContactMessageInput = {
  message: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['String']>;
};

export type SetupIntentPayload = {
  __typename?: 'SetupIntentPayload';
  clientSecret?: Maybe<Scalars['String']>;
  publishableKey?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
};

export type StartFreeTrialInput = {
  productPlanId?: Maybe<Scalars['ID']>;
  paymentMethodId?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
};

export type StringFilterInput = {
  and?: Maybe<Array<Maybe<Scalars['String']>>>;
  or?: Maybe<Array<Maybe<Scalars['String']>>>;
  not?: Maybe<StringFilterInput>;
  eq?: Maybe<Scalars['String']>;
  eqi?: Maybe<Scalars['String']>;
  ne?: Maybe<Scalars['String']>;
  nei?: Maybe<Scalars['String']>;
  startsWith?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  contains?: Maybe<Scalars['String']>;
  notContains?: Maybe<Scalars['String']>;
  containsi?: Maybe<Scalars['String']>;
  notContainsi?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  null?: Maybe<Scalars['Boolean']>;
  notNull?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['String']>>>;
  notIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  between?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Subscription = {
  __typename?: 'Subscription';
  current_period_start?: Maybe<Scalars['DateTime']>;
  current_period_end?: Maybe<Scalars['DateTime']>;
  cancel_at?: Maybe<Scalars['DateTime']>;
  trial_start?: Maybe<Scalars['DateTime']>;
  trial_end?: Maybe<Scalars['DateTime']>;
  status: Enum_Subscription_Status;
  company?: Maybe<CompanyEntityResponse>;
  product_plan?: Maybe<ProductPlanEntityResponse>;
  recurring: Enum_Subscription_Recurring;
  priceId?: Maybe<Scalars['String']>;
  currency?: Maybe<Enum_Subscription_Currency>;
  subscriptionId?: Maybe<Scalars['String']>;
  cancel_at_period_end?: Maybe<Scalars['Boolean']>;
  items?: Maybe<Scalars['JSON']>;
  created?: Maybe<Scalars['DateTime']>;
  collection_method: Enum_Subscription_Collection_Method;
  monthly_extra?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SubscriptionCancellationPayload = {
  __typename?: 'SubscriptionCancellationPayload';
  status?: Maybe<Scalars['String']>;
  cancelAtPeriodEnd?: Maybe<Scalars['Boolean']>;
  endsAt?: Maybe<Scalars['DateTime']>;
};

export type SubscriptionEntity = {
  __typename?: 'SubscriptionEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Subscription>;
};

export type SubscriptionEntityResponse = {
  __typename?: 'SubscriptionEntityResponse';
  data?: Maybe<SubscriptionEntity>;
};

export type SubscriptionEntityResponseCollection = {
  __typename?: 'SubscriptionEntityResponseCollection';
  data: Array<SubscriptionEntity>;
  meta: ResponseCollectionMeta;
};

export type SubscriptionFiltersInput = {
  id?: Maybe<IdFilterInput>;
  current_period_start?: Maybe<DateTimeFilterInput>;
  current_period_end?: Maybe<DateTimeFilterInput>;
  cancel_at?: Maybe<DateTimeFilterInput>;
  trial_start?: Maybe<DateTimeFilterInput>;
  trial_end?: Maybe<DateTimeFilterInput>;
  status?: Maybe<StringFilterInput>;
  company?: Maybe<CompanyFiltersInput>;
  product_plan?: Maybe<ProductPlanFiltersInput>;
  recurring?: Maybe<StringFilterInput>;
  priceId?: Maybe<StringFilterInput>;
  currency?: Maybe<StringFilterInput>;
  subscriptionId?: Maybe<StringFilterInput>;
  cancel_at_period_end?: Maybe<BooleanFilterInput>;
  items?: Maybe<JsonFilterInput>;
  created?: Maybe<DateTimeFilterInput>;
  collection_method?: Maybe<StringFilterInput>;
  monthly_extra?: Maybe<FloatFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<SubscriptionFiltersInput>>>;
  or?: Maybe<Array<Maybe<SubscriptionFiltersInput>>>;
  not?: Maybe<SubscriptionFiltersInput>;
};

export type SubscriptionInput = {
  current_period_start?: Maybe<Scalars['DateTime']>;
  current_period_end?: Maybe<Scalars['DateTime']>;
  cancel_at?: Maybe<Scalars['DateTime']>;
  trial_start?: Maybe<Scalars['DateTime']>;
  trial_end?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Enum_Subscription_Status>;
  company?: Maybe<Scalars['ID']>;
  product_plan?: Maybe<Scalars['ID']>;
  recurring?: Maybe<Enum_Subscription_Recurring>;
  priceId?: Maybe<Scalars['String']>;
  currency?: Maybe<Enum_Subscription_Currency>;
  subscriptionId?: Maybe<Scalars['String']>;
  cancel_at_period_end?: Maybe<Scalars['Boolean']>;
  items?: Maybe<Scalars['JSON']>;
  created?: Maybe<Scalars['DateTime']>;
  collection_method?: Maybe<Enum_Subscription_Collection_Method>;
  monthly_extra?: Maybe<Scalars['Float']>;
};

export type SubscriptionPayload = {
  __typename?: 'SubscriptionPayload';
  id?: Maybe<Scalars['ID']>;
  cancel_at_period_end?: Maybe<Scalars['Boolean']>;
  cancel_at?: Maybe<Scalars['DateTime']>;
  collection_method?: Maybe<Scalars['String']>;
  recurring?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  current_period_end?: Maybe<Scalars['DateTime']>;
  current_period_start?: Maybe<Scalars['DateTime']>;
  customer?: Maybe<Scalars['ID']>;
  ended_at?: Maybe<Scalars['DateTime']>;
  latest_invoice?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
  trial_end?: Maybe<Scalars['DateTime']>;
  trial_start?: Maybe<Scalars['DateTime']>;
  items?: Maybe<Scalars['JSON']>;
  product_plan?: Maybe<ProductPlan>;
};

export type SubscriptionPlan = {
  __typename?: 'SubscriptionPlan';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  tagline?: Maybe<Scalars['String']>;
  isPopular?: Maybe<Scalars['Boolean']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  sortOrder?: Maybe<Scalars['Int']>;
  priceId?: Maybe<Scalars['String']>;
  feature?: Maybe<SubscriptionPlanFeature>;
  features?: Maybe<Array<Maybe<SubscriptionPlanFeatureItem>>>;
};

export type SubscriptionPlanFeature = {
  __typename?: 'SubscriptionPlanFeature';
  usersAllowed?: Maybe<Scalars['Int']>;
  priceGbp?: Maybe<Scalars['Float']>;
  priceUsd?: Maybe<Scalars['Float']>;
  priceZar?: Maybe<Scalars['Float']>;
  supportHours?: Maybe<Scalars['Float']>;
  recurring?: Maybe<Scalars['String']>;
};

export type SubscriptionPlanFeatureItem = {
  __typename?: 'SubscriptionPlanFeatureItem';
  label?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  isHighlighted?: Maybe<Scalars['Boolean']>;
  sortOrder?: Maybe<Scalars['Int']>;
};

export type SubscriptionRelationResponseCollection = {
  __typename?: 'SubscriptionRelationResponseCollection';
  data: Array<SubscriptionEntity>;
};

export type SuggestCommunityMembersInput = {
  phoneNumber: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  reason: Scalars['String'];
  community: Scalars['ID'];
  role: Scalars['String'];
};

export type Task = {
  __typename?: 'Task';
  status?: Maybe<Enum_Task_Status>;
  community?: Maybe<CommunityEntityResponse>;
  baoleader?: Maybe<UsersPermissionsUserEntityResponse>;
  baorider?: Maybe<UsersPermissionsUserEntityResponse>;
  project?: Maybe<ProjectEntityResponse>;
  location?: Maybe<Scalars['JSON']>;
  onlyEmployeesVerify?: Maybe<Scalars['Boolean']>;
  accepted_at?: Maybe<Scalars['DateTime']>;
  task_definition?: Maybe<TaskDefinitionEntityResponse>;
  evidences?: Maybe<EvidenceRelationResponseCollection>;
  task_origin?: Maybe<Enum_Task_Task_Origin>;
  documents?: Maybe<UploadFileRelationResponseCollection>;
  date_reported?: Maybe<Scalars['DateTime']>;
  ER_ID?: Maybe<Scalars['String']>;
  task_offline_id?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  edit_from?: Maybe<TaskEntityResponse>;
  status_changed_at?: Maybe<Scalars['DateTime']>;
  status_changed_by?: Maybe<UsersPermissionsUserEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type TaskEvidencesArgs = {
  filters?: Maybe<EvidenceFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};


export type TaskDocumentsArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type TaskAndEvidenceType = {
  __typename?: 'TaskAndEvidenceType';
  task?: Maybe<TaskEntity>;
  evidence?: Maybe<EvidenceEntity>;
};

export type TaskCountWithTrend = {
  __typename?: 'TaskCountWithTrend';
  count?: Maybe<Scalars['Int']>;
  trend?: Maybe<Trend>;
};

export type TaskDataLabelValue = {
  __typename?: 'TaskDataLabelValue';
  evidence?: Maybe<EvidenceEntityResponse>;
  data_field?: Maybe<CustomDataLabelEntityResponse>;
  baorider?: Maybe<UsersPermissionsUserEntityResponse>;
  value?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type TaskDataLabelValueEntity = {
  __typename?: 'TaskDataLabelValueEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<TaskDataLabelValue>;
};

export type TaskDataLabelValueEntityResponse = {
  __typename?: 'TaskDataLabelValueEntityResponse';
  data?: Maybe<TaskDataLabelValueEntity>;
};

export type TaskDataLabelValueEntityResponseCollection = {
  __typename?: 'TaskDataLabelValueEntityResponseCollection';
  data: Array<TaskDataLabelValueEntity>;
  meta: ResponseCollectionMeta;
};

export type TaskDataLabelValueFiltersInput = {
  id?: Maybe<IdFilterInput>;
  evidence?: Maybe<EvidenceFiltersInput>;
  data_field?: Maybe<CustomDataLabelFiltersInput>;
  baorider?: Maybe<UsersPermissionsUserFiltersInput>;
  value?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<TaskDataLabelValueFiltersInput>>>;
  or?: Maybe<Array<Maybe<TaskDataLabelValueFiltersInput>>>;
  not?: Maybe<TaskDataLabelValueFiltersInput>;
};

export type TaskDataLabelValueInput = {
  evidence?: Maybe<Scalars['ID']>;
  data_field?: Maybe<Scalars['ID']>;
  baorider?: Maybe<Scalars['ID']>;
  value?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type TaskDataLabelValueRelationResponseCollection = {
  __typename?: 'TaskDataLabelValueRelationResponseCollection';
  data: Array<TaskDataLabelValueEntity>;
};

export type TaskDefinition = {
  __typename?: 'TaskDefinition';
  category?: Maybe<CategoryEntityResponse>;
  task_type?: Maybe<TaskTypeEntityResponse>;
  project?: Maybe<ProjectEntityResponse>;
  baoleader?: Maybe<UsersPermissionsUserEntityResponse>;
  ecoCredits?: Maybe<Scalars['Float']>;
  status?: Maybe<Enum_Taskdefinition_Status>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type TaskDefinitionEntity = {
  __typename?: 'TaskDefinitionEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<TaskDefinition>;
};

export type TaskDefinitionEntityResponse = {
  __typename?: 'TaskDefinitionEntityResponse';
  data?: Maybe<TaskDefinitionEntity>;
};

export type TaskDefinitionEntityResponseCollection = {
  __typename?: 'TaskDefinitionEntityResponseCollection';
  data: Array<TaskDefinitionEntity>;
  meta: ResponseCollectionMeta;
};

export type TaskDefinitionFiltersInput = {
  id?: Maybe<IdFilterInput>;
  category?: Maybe<CategoryFiltersInput>;
  task_type?: Maybe<TaskTypeFiltersInput>;
  project?: Maybe<ProjectFiltersInput>;
  baoleader?: Maybe<UsersPermissionsUserFiltersInput>;
  ecoCredits?: Maybe<FloatFilterInput>;
  status?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<TaskDefinitionFiltersInput>>>;
  or?: Maybe<Array<Maybe<TaskDefinitionFiltersInput>>>;
  not?: Maybe<TaskDefinitionFiltersInput>;
};

export type TaskDefinitionInput = {
  category?: Maybe<Scalars['ID']>;
  task_type?: Maybe<Scalars['ID']>;
  project?: Maybe<Scalars['ID']>;
  baoleader?: Maybe<Scalars['ID']>;
  ecoCredits?: Maybe<Scalars['Float']>;
  status?: Maybe<Enum_Taskdefinition_Status>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type TaskDefinitionRelationResponseCollection = {
  __typename?: 'TaskDefinitionRelationResponseCollection';
  data: Array<TaskDefinitionEntity>;
};

export type TaskEntity = {
  __typename?: 'TaskEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Task>;
};

export type TaskEntityResponse = {
  __typename?: 'TaskEntityResponse';
  data?: Maybe<TaskEntity>;
};

export type TaskEntityResponseCollection = {
  __typename?: 'TaskEntityResponseCollection';
  data: Array<TaskEntity>;
  meta: ResponseCollectionMeta;
};

export type TaskFiltersInput = {
  id?: Maybe<IdFilterInput>;
  status?: Maybe<StringFilterInput>;
  community?: Maybe<CommunityFiltersInput>;
  baoleader?: Maybe<UsersPermissionsUserFiltersInput>;
  baorider?: Maybe<UsersPermissionsUserFiltersInput>;
  project?: Maybe<ProjectFiltersInput>;
  location?: Maybe<JsonFilterInput>;
  onlyEmployeesVerify?: Maybe<BooleanFilterInput>;
  accepted_at?: Maybe<DateTimeFilterInput>;
  task_definition?: Maybe<TaskDefinitionFiltersInput>;
  evidences?: Maybe<EvidenceFiltersInput>;
  task_origin?: Maybe<StringFilterInput>;
  date_reported?: Maybe<DateTimeFilterInput>;
  ER_ID?: Maybe<StringFilterInput>;
  task_offline_id?: Maybe<StringFilterInput>;
  timezone?: Maybe<StringFilterInput>;
  edit_from?: Maybe<TaskFiltersInput>;
  status_changed_at?: Maybe<DateTimeFilterInput>;
  status_changed_by?: Maybe<UsersPermissionsUserFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<TaskFiltersInput>>>;
  or?: Maybe<Array<Maybe<TaskFiltersInput>>>;
  not?: Maybe<TaskFiltersInput>;
};

export type TaskInput = {
  status?: Maybe<Enum_Task_Status>;
  community?: Maybe<Scalars['ID']>;
  baoleader?: Maybe<Scalars['ID']>;
  baorider?: Maybe<Scalars['ID']>;
  project?: Maybe<Scalars['ID']>;
  location?: Maybe<Scalars['JSON']>;
  onlyEmployeesVerify?: Maybe<Scalars['Boolean']>;
  accepted_at?: Maybe<Scalars['DateTime']>;
  task_definition?: Maybe<Scalars['ID']>;
  evidences?: Maybe<Array<Maybe<Scalars['ID']>>>;
  task_origin?: Maybe<Enum_Task_Task_Origin>;
  documents?: Maybe<Array<Maybe<Scalars['ID']>>>;
  date_reported?: Maybe<Scalars['DateTime']>;
  ER_ID?: Maybe<Scalars['String']>;
  task_offline_id?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  edit_from?: Maybe<Scalars['ID']>;
  status_changed_at?: Maybe<Scalars['DateTime']>;
  status_changed_by?: Maybe<Scalars['ID']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type TaskMetrics = {
  __typename?: 'TaskMetrics';
  completedTasks?: Maybe<Metric>;
  reportedTask?: Maybe<Metric>;
  averageCompletionTime?: Maybe<AverageMetirc>;
  averageEvidenceTime?: Maybe<AverageMetirc>;
};

export type TaskPer = {
  __typename?: 'TaskPer';
  name?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
};

export type TaskType = {
  __typename?: 'TaskType';
  title?: Maybe<Scalars['String']>;
  photoEvidence?: Maybe<Scalars['String']>;
  documentedEvidence?: Maybe<Scalars['String']>;
  environmentalImpact?: Maybe<Scalars['String']>;
  socialImpact?: Maybe<Scalars['String']>;
  onlyEmployeesVerify?: Maybe<Scalars['Boolean']>;
  custom_data_fields?: Maybe<CustomDataLabelRelationResponseCollection>;
  dataFields?: Maybe<Array<Maybe<TaskTypeDataFieldsDynamicZone>>>;
  reportingDateField?: Maybe<Scalars['String']>;
  photoRequired?: Maybe<Scalars['Boolean']>;
  creator?: Maybe<UsersPermissionsUserEntityResponse>;
  category?: Maybe<CategoryEntityResponse>;
  status?: Maybe<Enum_Tasktype_Status>;
  un_sdg?: Maybe<UnSdgEntityResponse>;
  ER_ID?: Maybe<Scalars['String']>;
  withComment?: Maybe<Scalars['Boolean']>;
  next?: Maybe<TaskTypeEntityResponse>;
  version?: Maybe<Scalars['Long']>;
  task_definitions?: Maybe<TaskDefinitionRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type TaskTypeCustom_Data_FieldsArgs = {
  filters?: Maybe<CustomDataLabelFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};


export type TaskTypeTask_DefinitionsArgs = {
  filters?: Maybe<TaskDefinitionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};

export type TaskTypeDataFieldsDynamicZone = ComponentCustomDataFieldsCheckbox | ComponentCustomDataFieldsRadio | ComponentCustomDataFieldsSelect | ComponentCustomDataFieldsText | ComponentCustomDataFieldsNumberRange | ComponentCustomDataFieldsPercentage | ComponentCustomDataFieldsMetricsSpecific | ComponentCustomDataFieldsNumberDropDown | ComponentCustomDataFieldsRating | ComponentCustomDataFieldsNumberField | ComponentCustomDataFieldsDateTimeField | ComponentCustomDataFieldsDataList | ComponentCustomDataFieldsEmailField | ComponentCustomDataFieldsPhoneNumberField | ComponentCustomDataFieldsImageField | Error;


export type TaskTypeEntity = {
  __typename?: 'TaskTypeEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<TaskType>;
};

export type TaskTypeEntityResponse = {
  __typename?: 'TaskTypeEntityResponse';
  data?: Maybe<TaskTypeEntity>;
};

export type TaskTypeEntityResponseCollection = {
  __typename?: 'TaskTypeEntityResponseCollection';
  data: Array<TaskTypeEntity>;
  meta: ResponseCollectionMeta;
};

export type TaskTypeFiltersInput = {
  id?: Maybe<IdFilterInput>;
  title?: Maybe<StringFilterInput>;
  photoEvidence?: Maybe<StringFilterInput>;
  documentedEvidence?: Maybe<StringFilterInput>;
  environmentalImpact?: Maybe<StringFilterInput>;
  socialImpact?: Maybe<StringFilterInput>;
  onlyEmployeesVerify?: Maybe<BooleanFilterInput>;
  custom_data_fields?: Maybe<CustomDataLabelFiltersInput>;
  reportingDateField?: Maybe<StringFilterInput>;
  photoRequired?: Maybe<BooleanFilterInput>;
  creator?: Maybe<UsersPermissionsUserFiltersInput>;
  category?: Maybe<CategoryFiltersInput>;
  status?: Maybe<StringFilterInput>;
  un_sdg?: Maybe<UnSdgFiltersInput>;
  ER_ID?: Maybe<StringFilterInput>;
  withComment?: Maybe<BooleanFilterInput>;
  isPublicTemplate?: Maybe<BooleanFilterInput>;
  next?: Maybe<TaskTypeFiltersInput>;
  version?: Maybe<LongFilterInput>;
  task_definitions?: Maybe<TaskDefinitionFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<TaskTypeFiltersInput>>>;
  or?: Maybe<Array<Maybe<TaskTypeFiltersInput>>>;
  not?: Maybe<TaskTypeFiltersInput>;
};

export type TaskTypeInput = {
  title?: Maybe<Scalars['String']>;
  photoEvidence?: Maybe<Scalars['String']>;
  documentedEvidence?: Maybe<Scalars['String']>;
  environmentalImpact?: Maybe<Scalars['String']>;
  socialImpact?: Maybe<Scalars['String']>;
  onlyEmployeesVerify?: Maybe<Scalars['Boolean']>;
  custom_data_fields?: Maybe<Array<Maybe<Scalars['ID']>>>;
  dataFields?: Maybe<Array<Scalars['TaskTypeDataFieldsDynamicZoneInput']>>;
  reportingDateField?: Maybe<Scalars['String']>;
  photoRequired?: Maybe<Scalars['Boolean']>;
  creator?: Maybe<Scalars['ID']>;
  category?: Maybe<Scalars['ID']>;
  status?: Maybe<Enum_Tasktype_Status>;
  un_sdg?: Maybe<Scalars['ID']>;
  ER_ID?: Maybe<Scalars['String']>;
  withComment?: Maybe<Scalars['Boolean']>;
  isPublicTemplate?: Maybe<Scalars['Boolean']>;
  next?: Maybe<Scalars['ID']>;
  version?: Maybe<Scalars['Long']>;
  task_definitions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type TaskTypeRelationResponseCollection = {
  __typename?: 'TaskTypeRelationResponseCollection';
  data: Array<TaskTypeEntity>;
};

export type TaskWithCanEdit = {
  __typename?: 'TaskWithCanEdit';
  task?: Maybe<TaskEntity>;
  canEdit?: Maybe<Scalars['Boolean']>;
};

export type TasksWithCount = {
  __typename?: 'TasksWithCount';
  data?: Maybe<Array<Maybe<TaskEntity>>>;
  count?: Maybe<Scalars['Int']>;
};

export type TasksWithDataCollector = {
  __typename?: 'TasksWithDataCollector';
  dataCollector?: Maybe<UsersPermissionsUserEntity>;
  count?: Maybe<Scalars['Int']>;
};

export type TemplateProjectForm = {
  __typename?: 'TemplateProjectForm';
  title: Scalars['String'];
  tag?: Maybe<Scalars['String']>;
  questionCount: Scalars['Int'];
  questions: Array<Scalars['String']>;
};

export type TermsAndCondition = {
  __typename?: 'TermsAndCondition';
  terms_pdf: UploadFileEntityResponse;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type TermsAndConditionEntity = {
  __typename?: 'TermsAndConditionEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<TermsAndCondition>;
};

export type TermsAndConditionEntityResponse = {
  __typename?: 'TermsAndConditionEntityResponse';
  data?: Maybe<TermsAndConditionEntity>;
};

export type TermsAndConditionInput = {
  terms_pdf?: Maybe<Scalars['ID']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type TopPerforming = {
  __typename?: 'TopPerforming';
  baoriders?: Maybe<Array<Maybe<TopPerformingBaorider>>>;
  communityMembers?: Maybe<Array<Maybe<TopPerformingCommunityMember>>>;
  chartData?: Maybe<TopPerformingChartData>;
};

export type TopPerformingBaorider = {
  __typename?: 'TopPerformingBaorider';
  baorider?: Maybe<UsersPermissionsUserEntity>;
  tasksCompleted: Scalars['Int'];
};

export type TopPerformingChartData = {
  __typename?: 'TopPerformingChartData';
  baoriders?: Maybe<Array<Maybe<ChartData>>>;
  communityMembers?: Maybe<Array<Maybe<ChartData>>>;
};

export type TopPerformingCommunityMember = {
  __typename?: 'TopPerformingCommunityMember';
  communityMember?: Maybe<UsersPermissionsUserEntity>;
  tasksCompleted: Scalars['Int'];
};

export type TrainingVideo = {
  __typename?: 'TrainingVideo';
  training_videos?: Maybe<Array<Maybe<ComponentTrainingVideoTrainingVideo>>>;
  FAQs?: Maybe<Array<Maybe<ComponentFaqFaq>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type TrainingVideoTraining_VideosArgs = {
  filters?: Maybe<ComponentTrainingVideoTrainingVideoFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type TrainingVideoFaQsArgs = {
  filters?: Maybe<ComponentFaqFaqFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type TrainingVideoEntity = {
  __typename?: 'TrainingVideoEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<TrainingVideo>;
};

export type TrainingVideoEntityResponse = {
  __typename?: 'TrainingVideoEntityResponse';
  data?: Maybe<TrainingVideoEntity>;
};

export type TrainingVideoInput = {
  training_videos?: Maybe<Array<Maybe<ComponentTrainingVideoTrainingVideoInput>>>;
  FAQs?: Maybe<Array<Maybe<ComponentFaqFaqInput>>>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type Trend = {
  __typename?: 'Trend';
  count?: Maybe<Scalars['Int']>;
  previousMonthCount?: Maybe<Scalars['Int']>;
  trend?: Maybe<Scalars['Int']>;
  percentage?: Maybe<Scalars['Float']>;
};

export type UnSdg = {
  __typename?: 'UnSdg';
  name?: Maybe<Scalars['String']>;
  task_types?: Maybe<TaskTypeRelationResponseCollection>;
  icon?: Maybe<UploadFileEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};


export type UnSdgTask_TypesArgs = {
  filters?: Maybe<TaskTypeFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};

export type UnSdgEntity = {
  __typename?: 'UnSdgEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<UnSdg>;
};

export type UnSdgEntityResponse = {
  __typename?: 'UnSdgEntityResponse';
  data?: Maybe<UnSdgEntity>;
};

export type UnSdgEntityResponseCollection = {
  __typename?: 'UnSdgEntityResponseCollection';
  data: Array<UnSdgEntity>;
  meta: ResponseCollectionMeta;
};

export type UnSdgFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  task_types?: Maybe<TaskTypeFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<UnSdgFiltersInput>>>;
  or?: Maybe<Array<Maybe<UnSdgFiltersInput>>>;
  not?: Maybe<UnSdgFiltersInput>;
};

export type UnSdgInput = {
  name?: Maybe<Scalars['String']>;
  task_types?: Maybe<Array<Maybe<Scalars['ID']>>>;
  icon?: Maybe<Scalars['ID']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type UpdateBaoriderInput = {
  phoneNumber?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  projects?: Maybe<Array<Scalars['ID']>>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  community?: Maybe<Scalars['ID']>;
  idNumber?: Maybe<Scalars['String']>;
  blocked?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Enum_Userspermissionsuser_Status>;
};

export type UpdateCommunityMembersInput = {
  phoneNumber?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  community?: Maybe<Scalars['ID']>;
  idNumber?: Maybe<Scalars['String']>;
  blocked?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Enum_Userspermissionsuser_Status>;
};


export type UploadFile = {
  __typename?: 'UploadFile';
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UploadFileEntity = {
  __typename?: 'UploadFileEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<UploadFile>;
};

export type UploadFileEntityResponse = {
  __typename?: 'UploadFileEntityResponse';
  data?: Maybe<UploadFileEntity>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  data: Array<UploadFileEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFileFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  alternativeText?: Maybe<StringFilterInput>;
  caption?: Maybe<StringFilterInput>;
  width?: Maybe<IntFilterInput>;
  height?: Maybe<IntFilterInput>;
  formats?: Maybe<JsonFilterInput>;
  hash?: Maybe<StringFilterInput>;
  ext?: Maybe<StringFilterInput>;
  mime?: Maybe<StringFilterInput>;
  size?: Maybe<FloatFilterInput>;
  url?: Maybe<StringFilterInput>;
  previewUrl?: Maybe<StringFilterInput>;
  provider?: Maybe<StringFilterInput>;
  provider_metadata?: Maybe<JsonFilterInput>;
  folder?: Maybe<UploadFolderFiltersInput>;
  folderPath?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<UploadFileFiltersInput>>>;
  or?: Maybe<Array<Maybe<UploadFileFiltersInput>>>;
  not?: Maybe<UploadFileFiltersInput>;
};

export type UploadFileInput = {
  name?: Maybe<Scalars['String']>;
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash?: Maybe<Scalars['String']>;
  ext?: Maybe<Scalars['String']>;
  mime?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  previewUrl?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  provider_metadata?: Maybe<Scalars['JSON']>;
  folder?: Maybe<Scalars['ID']>;
  folderPath?: Maybe<Scalars['String']>;
};

export type UploadFileRelationResponseCollection = {
  __typename?: 'UploadFileRelationResponseCollection';
  data: Array<UploadFileEntity>;
};

export type UploadFolder = {
  __typename?: 'UploadFolder';
  name: Scalars['String'];
  pathId: Scalars['Int'];
  parent?: Maybe<UploadFolderEntityResponse>;
  children?: Maybe<UploadFolderRelationResponseCollection>;
  files?: Maybe<UploadFileRelationResponseCollection>;
  path: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type UploadFolderChildrenArgs = {
  filters?: Maybe<UploadFolderFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UploadFolderFilesArgs = {
  filters?: Maybe<UploadFileFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UploadFolderEntity = {
  __typename?: 'UploadFolderEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<UploadFolder>;
};

export type UploadFolderEntityResponse = {
  __typename?: 'UploadFolderEntityResponse';
  data?: Maybe<UploadFolderEntity>;
};

export type UploadFolderEntityResponseCollection = {
  __typename?: 'UploadFolderEntityResponseCollection';
  data: Array<UploadFolderEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFolderFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  pathId?: Maybe<IntFilterInput>;
  parent?: Maybe<UploadFolderFiltersInput>;
  children?: Maybe<UploadFolderFiltersInput>;
  files?: Maybe<UploadFileFiltersInput>;
  path?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<UploadFolderFiltersInput>>>;
  or?: Maybe<Array<Maybe<UploadFolderFiltersInput>>>;
  not?: Maybe<UploadFolderFiltersInput>;
};

export type UploadFolderInput = {
  name?: Maybe<Scalars['String']>;
  pathId?: Maybe<Scalars['Int']>;
  parent?: Maybe<Scalars['ID']>;
  children?: Maybe<Array<Maybe<Scalars['ID']>>>;
  files?: Maybe<Array<Maybe<Scalars['ID']>>>;
  path?: Maybe<Scalars['String']>;
};

export type UploadFolderRelationResponseCollection = {
  __typename?: 'UploadFolderRelationResponseCollection';
  data: Array<UploadFolderEntity>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
  provider?: Scalars['String'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  id: Scalars['ID'];
  username: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsMeRole>;
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String'];
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UsersPermissionsPermissionEntity = {
  __typename?: 'UsersPermissionsPermissionEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<UsersPermissionsPermission>;
};

export type UsersPermissionsPermissionFiltersInput = {
  id?: Maybe<IdFilterInput>;
  action?: Maybe<StringFilterInput>;
  role?: Maybe<UsersPermissionsRoleFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<UsersPermissionsPermissionFiltersInput>>>;
  or?: Maybe<Array<Maybe<UsersPermissionsPermissionFiltersInput>>>;
  not?: Maybe<UsersPermissionsPermissionFiltersInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  data: Array<UsersPermissionsPermissionEntity>;
};

export type UsersPermissionsRegisterInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  users?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type UsersPermissionsRolePermissionsArgs = {
  filters?: Maybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsRoleUsersArgs = {
  filters?: Maybe<UsersPermissionsUserFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UsersPermissionsRoleEntity = {
  __typename?: 'UsersPermissionsRoleEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<UsersPermissionsRole>;
};

export type UsersPermissionsRoleEntityResponse = {
  __typename?: 'UsersPermissionsRoleEntityResponse';
  data?: Maybe<UsersPermissionsRoleEntity>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  data: Array<UsersPermissionsRoleEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsRoleFiltersInput = {
  id?: Maybe<IdFilterInput>;
  name?: Maybe<StringFilterInput>;
  description?: Maybe<StringFilterInput>;
  type?: Maybe<StringFilterInput>;
  permissions?: Maybe<UsersPermissionsPermissionFiltersInput>;
  users?: Maybe<UsersPermissionsUserFiltersInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<UsersPermissionsRoleFiltersInput>>>;
  or?: Maybe<Array<Maybe<UsersPermissionsRoleFiltersInput>>>;
  not?: Maybe<UsersPermissionsRoleFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  phoneNumber?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<UploadFileEntityResponse>;
  notifications?: Maybe<NotificationRelationResponseCollection>;
  onboardingInformation?: Maybe<Scalars['JSON']>;
  onboarding?: Maybe<Enum_Userspermissionsuser_Onboarding>;
  baoleader?: Maybe<UsersPermissionsUserEntityResponse>;
  baoriders?: Maybe<UsersPermissionsUserRelationResponseCollection>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  gender?: Maybe<Enum_Userspermissionsuser_Gender>;
  dateOfBirth?: Maybe<Scalars['Date']>;
  idNumber?: Maybe<Scalars['String']>;
  status?: Maybe<Enum_Userspermissionsuser_Status>;
  invitedViaSMS?: Maybe<Scalars['Boolean']>;
  receiveSmsNotifications?: Maybe<Scalars['Boolean']>;
  requests?: Maybe<RequestRelationResponseCollection>;
  request?: Maybe<RequestEntityResponse>;
  community?: Maybe<CommunityEntityResponse>;
  customerId?: Maybe<Scalars['String']>;
  company?: Maybe<CompanyEntityResponse>;
  isVerifier?: Maybe<Scalars['Boolean']>;
  pushToken?: Maybe<Scalars['String']>;
  projects?: Maybe<ProjectRelationResponseCollection>;
  location_permission?: Maybe<Scalars['Boolean']>;
  camera_permission?: Maybe<Scalars['Boolean']>;
  media_library_permission?: Maybe<Scalars['Boolean']>;
  metabaseUserID?: Maybe<Scalars['String']>;
  receiveWeeklyStatusReport?: Maybe<Scalars['Boolean']>;
  lastWeeklyStatusReportSentDate?: Maybe<Scalars['Date']>;
  receiveAllTimeWeeklyStatusReport?: Maybe<Scalars['Boolean']>;
  receiveLoginReminder?: Maybe<Scalars['Boolean']>;
  lastLoggedIn?: Maybe<Scalars['Date']>;
  lastLoginReminderSent?: Maybe<Scalars['Date']>;
  receiveProjectNotifications?: Maybe<Scalars['Boolean']>;
  receivePushNotifications?: Maybe<Scalars['Boolean']>;
  lastTaskReportedDate?: Maybe<Scalars['Date']>;
  lastInactivityNotificationSentDate?: Maybe<Scalars['Date']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type UsersPermissionsUserNotificationsArgs = {
  filters?: Maybe<NotificationFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};


export type UsersPermissionsUserBaoridersArgs = {
  filters?: Maybe<UsersPermissionsUserFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type UsersPermissionsUserRequestsArgs = {
  filters?: Maybe<RequestFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};


export type UsersPermissionsUserProjectsArgs = {
  filters?: Maybe<ProjectFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicationState?: Maybe<PublicationState>;
};

export type UsersPermissionsUserEntity = {
  __typename?: 'UsersPermissionsUserEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<UsersPermissionsUser>;
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<UsersPermissionsUserEntity>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsUserFiltersInput = {
  id?: Maybe<IdFilterInput>;
  username?: Maybe<StringFilterInput>;
  email?: Maybe<StringFilterInput>;
  provider?: Maybe<StringFilterInput>;
  password?: Maybe<StringFilterInput>;
  resetPasswordToken?: Maybe<StringFilterInput>;
  otp?: Maybe<StringFilterInput>;
  confirmed?: Maybe<BooleanFilterInput>;
  blocked?: Maybe<BooleanFilterInput>;
  confirmationToken?: Maybe<StringFilterInput>;
  role?: Maybe<UsersPermissionsRoleFiltersInput>;
  phoneNumber?: Maybe<StringFilterInput>;
  notifications?: Maybe<NotificationFiltersInput>;
  onboardingInformation?: Maybe<JsonFilterInput>;
  onboarding?: Maybe<StringFilterInput>;
  baoleader?: Maybe<UsersPermissionsUserFiltersInput>;
  baoriders?: Maybe<UsersPermissionsUserFiltersInput>;
  firstName?: Maybe<StringFilterInput>;
  lastName?: Maybe<StringFilterInput>;
  gender?: Maybe<StringFilterInput>;
  dateOfBirth?: Maybe<DateFilterInput>;
  idNumber?: Maybe<StringFilterInput>;
  status?: Maybe<StringFilterInput>;
  invitedViaSMS?: Maybe<BooleanFilterInput>;
  receiveSmsNotifications?: Maybe<BooleanFilterInput>;
  requests?: Maybe<RequestFiltersInput>;
  request?: Maybe<RequestFiltersInput>;
  community?: Maybe<CommunityFiltersInput>;
  customerId?: Maybe<StringFilterInput>;
  company?: Maybe<CompanyFiltersInput>;
  isVerifier?: Maybe<BooleanFilterInput>;
  pushToken?: Maybe<StringFilterInput>;
  projects?: Maybe<ProjectFiltersInput>;
  location_permission?: Maybe<BooleanFilterInput>;
  camera_permission?: Maybe<BooleanFilterInput>;
  media_library_permission?: Maybe<BooleanFilterInput>;
  metabaseUserID?: Maybe<StringFilterInput>;
  receiveWeeklyStatusReport?: Maybe<BooleanFilterInput>;
  lastWeeklyStatusReportSentDate?: Maybe<DateFilterInput>;
  receiveAllTimeWeeklyStatusReport?: Maybe<BooleanFilterInput>;
  receiveLoginReminder?: Maybe<BooleanFilterInput>;
  lastLoggedIn?: Maybe<DateFilterInput>;
  lastLoginReminderSent?: Maybe<DateFilterInput>;
  receiveProjectNotifications?: Maybe<BooleanFilterInput>;
  receivePushNotifications?: Maybe<BooleanFilterInput>;
  lastTaskReportedDate?: Maybe<DateFilterInput>;
  lastInactivityNotificationSentDate?: Maybe<DateFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<UsersPermissionsUserFiltersInput>>>;
  or?: Maybe<Array<Maybe<UsersPermissionsUserFiltersInput>>>;
  not?: Maybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsUserInput = {
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  otp?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  confirmationToken?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['ID']>;
  phoneNumber?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['ID']>;
  notifications?: Maybe<Array<Maybe<Scalars['ID']>>>;
  onboardingInformation?: Maybe<Scalars['JSON']>;
  onboarding?: Maybe<Enum_Userspermissionsuser_Onboarding>;
  baoleader?: Maybe<Scalars['ID']>;
  baoriders?: Maybe<Array<Maybe<Scalars['ID']>>>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  gender?: Maybe<Enum_Userspermissionsuser_Gender>;
  dateOfBirth?: Maybe<Scalars['Date']>;
  idNumber?: Maybe<Scalars['String']>;
  status?: Maybe<Enum_Userspermissionsuser_Status>;
  invitedViaSMS?: Maybe<Scalars['Boolean']>;
  receiveSmsNotifications?: Maybe<Scalars['Boolean']>;
  requests?: Maybe<Array<Maybe<Scalars['ID']>>>;
  request?: Maybe<Scalars['ID']>;
  community?: Maybe<Scalars['ID']>;
  customerId?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['ID']>;
  isVerifier?: Maybe<Scalars['Boolean']>;
  pushToken?: Maybe<Scalars['String']>;
  projects?: Maybe<Array<Maybe<Scalars['ID']>>>;
  location_permission?: Maybe<Scalars['Boolean']>;
  camera_permission?: Maybe<Scalars['Boolean']>;
  media_library_permission?: Maybe<Scalars['Boolean']>;
  metabaseUserID?: Maybe<Scalars['String']>;
  receiveWeeklyStatusReport?: Maybe<Scalars['Boolean']>;
  lastWeeklyStatusReportSentDate?: Maybe<Scalars['Date']>;
  receiveAllTimeWeeklyStatusReport?: Maybe<Scalars['Boolean']>;
  receiveLoginReminder?: Maybe<Scalars['Boolean']>;
  lastLoggedIn?: Maybe<Scalars['Date']>;
  lastLoginReminderSent?: Maybe<Scalars['Date']>;
  receiveProjectNotifications?: Maybe<Scalars['Boolean']>;
  receivePushNotifications?: Maybe<Scalars['Boolean']>;
  lastTaskReportedDate?: Maybe<Scalars['Date']>;
  lastInactivityNotificationSentDate?: Maybe<Scalars['Date']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
};

export type Video = {
  __typename?: 'Video';
  title: Scalars['String'];
  videoLink: UploadFileEntityResponse;
  order?: Maybe<Scalars['Int']>;
  category?: Maybe<Enum_Video_Category>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type VideoEntity = {
  __typename?: 'VideoEntity';
  id?: Maybe<Scalars['ID']>;
  attributes?: Maybe<Video>;
};

export type VideoEntityResponse = {
  __typename?: 'VideoEntityResponse';
  data?: Maybe<VideoEntity>;
};

export type VideoEntityResponseCollection = {
  __typename?: 'VideoEntityResponseCollection';
  data: Array<VideoEntity>;
  meta: ResponseCollectionMeta;
};

export type VideoFiltersInput = {
  id?: Maybe<IdFilterInput>;
  title?: Maybe<StringFilterInput>;
  order?: Maybe<IntFilterInput>;
  category?: Maybe<StringFilterInput>;
  createdAt?: Maybe<DateTimeFilterInput>;
  updatedAt?: Maybe<DateTimeFilterInput>;
  publishedAt?: Maybe<DateTimeFilterInput>;
  and?: Maybe<Array<Maybe<VideoFiltersInput>>>;
  or?: Maybe<Array<Maybe<VideoFiltersInput>>>;
  not?: Maybe<VideoFiltersInput>;
};

export type VideoInput = {
  title?: Maybe<Scalars['String']>;
  videoLink?: Maybe<Scalars['ID']>;
  order?: Maybe<Scalars['Int']>;
  category?: Maybe<Enum_Video_Category>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type UpdateMyUserInput = {
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  pushToken?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  receiveWeeklyStatusReport?: Maybe<Scalars['Boolean']>;
  receiveAllTimeWeeklyStatusReport?: Maybe<Scalars['Boolean']>;
  receiveLoginReminder?: Maybe<Scalars['Boolean']>;
  receiveProjectNotifications?: Maybe<Scalars['Boolean']>;
  receivePushNotifications?: Maybe<Scalars['Boolean']>;
  profilePicture?: Maybe<Scalars['ID']>;
  notifications?: Maybe<Array<Maybe<Scalars['ID']>>>;
  tasks?: Maybe<Array<Maybe<Scalars['ID']>>>;
  community?: Maybe<Scalars['ID']>;
  requests?: Maybe<Array<Maybe<Scalars['ID']>>>;
  onboardingInformation?: Maybe<Scalars['JSON']>;
  onboarding?: Maybe<Enum_Userspermissionsuser_Onboarding>;
  receiveSmsNotifications?: Maybe<Scalars['Boolean']>;
  baoriders?: Maybe<Array<Maybe<Scalars['ID']>>>;
  firstName?: Maybe<Scalars['String']>;
  location_permission?: Maybe<Scalars['Boolean']>;
  camera_permission?: Maybe<Scalars['Boolean']>;
  media_library_permission?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  idNumber?: Maybe<Scalars['String']>;
};

export type AppFragment = (
  { __typename?: 'BaoverifierApp' }
  & Pick<BaoverifierApp, 'status' | 'appVersion' | 'description' | 'updatedAt' | 'createdAt'>
);

export type CategoryFragment = (
  { __typename?: 'Category' }
  & Pick<Category, 'title' | 'description'>
);

export type CommunityFragment = (
  { __typename?: 'Community' }
  & Pick<Community, 'createdAt' | 'updatedAt' | 'name' | 'description' | 'chief_name' | 'location'>
);

export type ComponentCustomDataFieldsCheckboxFragment = (
  { __typename?: 'ComponentCustomDataFieldsCheckbox' }
  & Pick<ComponentCustomDataFieldsCheckbox, 'id' | 'label' | 'isRequired'>
  & { option?: Maybe<Array<Maybe<(
    { __typename?: 'ComponentComboFieldOption' }
    & Pick<ComponentComboFieldOption, 'id' | 'option'>
  )>>> }
);

export type ComponentCustomDataFieldsDataListFragment = (
  { __typename?: 'ComponentCustomDataFieldsDataList' }
  & Pick<ComponentCustomDataFieldsDataList, 'id' | 'label' | 'isRequired' | 'listId'>
  & { option?: Maybe<Array<Maybe<(
    { __typename?: 'ComponentComboFieldOption' }
    & Pick<ComponentComboFieldOption, 'id' | 'option'>
  )>>> }
);

export type ComponentCustomDataFieldsDateTimeFieldFragment = (
  { __typename?: 'ComponentCustomDataFieldsDateTimeField' }
  & Pick<ComponentCustomDataFieldsDateTimeField, 'id' | 'label' | 'isRequired' | 'datetime'>
);

export type ComponentCustomDataFieldsEmailFieldFragment = (
  { __typename?: 'ComponentCustomDataFieldsEmailField' }
  & Pick<ComponentCustomDataFieldsEmailField, 'id' | 'label' | 'isRequired' | 'email'>
);

export type ComponentCustomDataFieldsImageFieldFragment = (
  { __typename?: 'ComponentCustomDataFieldsImageField' }
  & Pick<ComponentCustomDataFieldsImageField, 'id' | 'isRequired' | 'label' | 'imageUrls' | 'upload_state'>
  & { images?: Maybe<(
    { __typename?: 'UploadFileRelationResponseCollection' }
    & { data: Array<(
      { __typename?: 'UploadFileEntity' }
      & UploadFileFragment
    )> }
  )> }
);

export type ComponentCustomDataFieldsMetricsSpecificFragment = (
  { __typename?: 'ComponentCustomDataFieldsMetricsSpecific' }
  & Pick<ComponentCustomDataFieldsMetricsSpecific, 'id' | 'label' | 'max' | 'min' | 'isRequired' | 'metric' | 'number_value'>
);

export type ComponentCustomDataFieldsNumberDropDownFragment = (
  { __typename?: 'ComponentCustomDataFieldsNumberDropDown' }
  & Pick<ComponentCustomDataFieldsNumberDropDown, 'id' | 'label' | 'isRequired' | 'value' | 'max' | 'min'>
);

export type ComponentCustomDataFieldsNumberFieldFragment = (
  { __typename?: 'ComponentCustomDataFieldsNumberField' }
  & Pick<ComponentCustomDataFieldsNumberField, 'id' | 'label' | 'max' | 'min' | 'number_field_value' | 'isRequired'>
);

export type ComponentCustomDataFieldsNumberRangeFragment = (
  { __typename?: 'ComponentCustomDataFieldsNumberRange' }
  & Pick<ComponentCustomDataFieldsNumberRange, 'id' | 'label' | 'min' | 'isRequired' | 'max'>
);

export type ComponentCustomDataFieldsPercentageFragment = (
  { __typename?: 'ComponentCustomDataFieldsPercentage' }
  & Pick<ComponentCustomDataFieldsPercentage, 'id' | 'label' | 'isRequired' | 'value'>
);

export type ComponentCustomDataFieldsPhoneNumberFieldFragment = (
  { __typename?: 'ComponentCustomDataFieldsPhoneNumberField' }
  & Pick<ComponentCustomDataFieldsPhoneNumberField, 'id' | 'label' | 'isRequired' | 'phoneNumber'>
);

export type ComponentCustomDataFieldsRadioFragment = (
  { __typename?: 'ComponentCustomDataFieldsRadio' }
  & Pick<ComponentCustomDataFieldsRadio, 'id' | 'label' | 'isRequired'>
  & { option?: Maybe<Array<Maybe<(
    { __typename?: 'ComponentComboFieldOption' }
    & Pick<ComponentComboFieldOption, 'id' | 'option'>
  )>>> }
);

export type ComponentCustomDataFieldsRatingFragment = (
  { __typename?: 'ComponentCustomDataFieldsRating' }
  & Pick<ComponentCustomDataFieldsRating, 'id' | 'label' | 'isRequired' | 'rating' | 'number_of_stars'>
);

export type ComponentCustomDataFieldsSelectFragment = (
  { __typename?: 'ComponentCustomDataFieldsSelect' }
  & Pick<ComponentCustomDataFieldsSelect, 'id' | 'label' | 'isRequired'>
  & { option?: Maybe<Array<Maybe<(
    { __typename: 'ComponentComboFieldOption' }
    & Pick<ComponentComboFieldOption, 'id' | 'option'>
  )>>> }
);

export type ComponentCustomDataFieldsTextFragment = (
  { __typename?: 'ComponentCustomDataFieldsText' }
  & Pick<ComponentCustomDataFieldsText, 'id' | 'label' | 'text_value' | 'isRequired'>
);

export type DataListOptionFragment = (
  { __typename?: 'DataListOption' }
  & Pick<DataListOption, 'createdAt' | 'status' | 'updatedAt' | 'value' | 'publishedAt'>
);

export type DataListsFragment = (
  { __typename?: 'DataList' }
  & Pick<DataList, 'name' | 'createdAt' | 'updatedAt' | 'status' | 'publishedAt' | 'updateKey'>
);

export type EvidenceFragment = (
  { __typename?: 'Evidence' }
  & Pick<Evidence, 'notes' | 'location' | 'createdAt' | 'updatedAt' | 'upload_state' | 'cancellationReason' | 'requestedInfo'>
);

export type NotificationFragment = (
  { __typename?: 'Notification' }
  & Pick<Notification, 'title' | 'message' | 'read' | 'status' | 'action' | 'type' | 'createdAt' | 'updatedAt' | 'publishedAt'>
  & { attachment?: Maybe<(
    { __typename?: 'UploadFileEntityResponse' }
    & { data?: Maybe<(
      { __typename?: 'UploadFileEntity' }
      & Pick<UploadFileEntity, 'id'>
      & { attributes?: Maybe<(
        { __typename?: 'UploadFile' }
        & Pick<UploadFile, 'url' | 'mime' | 'width' | 'height'>
      )> }
    )> }
  )>, nextScheduledNotificationDetails?: Maybe<(
    { __typename?: 'NotificationScheduledDetails' }
    & Pick<NotificationScheduledDetails, 'id' | 'sendAt' | 'endAt' | 'recur' | 'status' | 'priority'>
  )> }
);

export type PaginationFragment = (
  { __typename?: 'Pagination' }
  & Pick<Pagination, 'total' | 'page' | 'pageSize' | 'pageCount'>
);

export type ProjectFragment = (
  { __typename?: 'Project' }
  & Pick<Project, 'breakdown' | 'name' | 'createdAt' | 'updatedAt' | 'collaborators' | 'reward' | 'status' | 'statement' | 'description' | 'outcomes'>
);

export type RoleFragment = (
  { __typename?: 'UsersPermissionsRole' }
  & Pick<UsersPermissionsRole, 'name' | 'description' | 'type' | 'createdAt' | 'updatedAt'>
);

export type TaskFragment = (
  { __typename?: 'Task' }
  & Pick<Task, 'createdAt' | 'updatedAt' | 'accepted_at' | 'status' | 'location' | 'task_origin'>
);

export type Task_DefinitionFragment = (
  { __typename?: 'TaskDefinition' }
  & Pick<TaskDefinition, 'status' | 'createdAt' | 'updatedAt'>
);

export type Task_TypeFragment = (
  { __typename?: 'TaskType' }
  & Pick<TaskType, 'title' | 'ER_ID' | 'photoEvidence' | 'documentedEvidence' | 'environmentalImpact' | 'socialImpact' | 'status' | 'createdAt' | 'updatedAt' | 'withComment' | 'photoRequired'>
);

export type UploadFileFragment = (
  { __typename?: 'UploadFileEntity' }
  & Pick<UploadFileEntity, 'id'>
  & { attributes?: Maybe<(
    { __typename?: 'UploadFile' }
    & Pick<UploadFile, 'createdAt' | 'updatedAt' | 'name' | 'alternativeText' | 'caption' | 'size' | 'mime' | 'url' | 'provider' | 'width' | 'height' | 'formats' | 'hash' | 'ext'>
  )> }
);

export type UserFragment = (
  { __typename?: 'UsersPermissionsUser' }
  & Pick<UsersPermissionsUser, 'firstName' | 'lastName' | 'username' | 'idNumber' | 'phoneNumber' | 'email' | 'confirmed' | 'receiveAllTimeWeeklyStatusReport' | 'receiveLoginReminder' | 'receiveWeeklyStatusReport' | 'receiveProjectNotifications' | 'blocked' | 'camera_permission' | 'location_permission' | 'media_library_permission' | 'createdAt' | 'updatedAt'>
);

export type AcceptBaoriderTaskMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AcceptBaoriderTaskMutation = (
  { __typename?: 'Mutation' }
  & { acceptBaoriderTask: (
    { __typename?: 'TaskEntity' }
    & Pick<TaskEntity, 'id'>
    & { attributes?: Maybe<(
      { __typename?: 'Task' }
      & { baoleader?: Maybe<(
        { __typename?: 'UsersPermissionsUserEntityResponse' }
        & { data?: Maybe<(
          { __typename?: 'UsersPermissionsUserEntity' }
          & Pick<UsersPermissionsUserEntity, 'id'>
          & { attributes?: Maybe<(
            { __typename?: 'UsersPermissionsUser' }
            & { profilePicture?: Maybe<(
              { __typename?: 'UploadFileEntityResponse' }
              & { data?: Maybe<(
                { __typename?: 'UploadFileEntity' }
                & UploadFileFragment
              )> }
            )>, baoleader?: Maybe<(
              { __typename?: 'UsersPermissionsUserEntityResponse' }
              & { data?: Maybe<(
                { __typename?: 'UsersPermissionsUserEntity' }
                & Pick<UsersPermissionsUserEntity, 'id'>
              )> }
            )> }
            & UserFragment
          )> }
        )> }
      )>, baorider?: Maybe<(
        { __typename?: 'UsersPermissionsUserEntityResponse' }
        & { data?: Maybe<(
          { __typename?: 'UsersPermissionsUserEntity' }
          & Pick<UsersPermissionsUserEntity, 'id'>
          & { attributes?: Maybe<(
            { __typename?: 'UsersPermissionsUser' }
            & { profilePicture?: Maybe<(
              { __typename?: 'UploadFileEntityResponse' }
              & { data?: Maybe<(
                { __typename?: 'UploadFileEntity' }
                & UploadFileFragment
              )> }
            )>, baoleader?: Maybe<(
              { __typename?: 'UsersPermissionsUserEntityResponse' }
              & { data?: Maybe<(
                { __typename?: 'UsersPermissionsUserEntity' }
                & Pick<UsersPermissionsUserEntity, 'id'>
              )> }
            )> }
            & UserFragment
          )> }
        )> }
      )>, task_definition?: Maybe<(
        { __typename?: 'TaskDefinitionEntityResponse' }
        & { data?: Maybe<(
          { __typename?: 'TaskDefinitionEntity' }
          & Pick<TaskDefinitionEntity, 'id'>
          & { attributes?: Maybe<(
            { __typename?: 'TaskDefinition' }
            & { category?: Maybe<(
              { __typename?: 'CategoryEntityResponse' }
              & { data?: Maybe<(
                { __typename?: 'CategoryEntity' }
                & Pick<CategoryEntity, 'id'>
                & { attributes?: Maybe<(
                  { __typename?: 'Category' }
                  & CategoryFragment
                )> }
              )> }
            )>, task_type?: Maybe<(
              { __typename?: 'TaskTypeEntityResponse' }
              & { data?: Maybe<(
                { __typename?: 'TaskTypeEntity' }
                & Pick<TaskTypeEntity, 'id'>
                & { attributes?: Maybe<(
                  { __typename?: 'TaskType' }
                  & Task_TypeFragment
                )> }
              )> }
            )> }
          )> }
        )> }
      )>, project?: Maybe<(
        { __typename?: 'ProjectEntityResponse' }
        & { data?: Maybe<(
          { __typename?: 'ProjectEntity' }
          & Pick<ProjectEntity, 'id'>
          & { attributes?: Maybe<(
            { __typename?: 'Project' }
            & ProjectFragment
          )> }
        )> }
      )> }
      & TaskFragment
    )> }
  ) }
);

export type ChangeMyPasswordMutationVariables = Exact<{
  password: Scalars['String'];
  passwordNew: Scalars['String'];
  passwordConfirmation: Scalars['String'];
}>;


export type ChangeMyPasswordMutation = (
  { __typename?: 'Mutation' }
  & { changeMyPassword?: Maybe<(
    { __typename?: 'UsersPermissionsUserEntity' }
    & Pick<UsersPermissionsUserEntity, 'id'>
  )> }
);

export type CreateBaoverifierFullTaskMutationVariables = Exact<{
  task?: Maybe<TaskInput>;
  evidence?: Maybe<EvidenceInputType>;
  taskEdited?: Maybe<Scalars['String']>;
}>;


export type CreateBaoverifierFullTaskMutation = (
  { __typename?: 'Mutation' }
  & { createBaoverifierFullTask: (
    { __typename?: 'TaskAndEvidenceType' }
    & { task?: Maybe<(
      { __typename?: 'TaskEntity' }
      & Pick<TaskEntity, 'id'>
    )>, evidence?: Maybe<(
      { __typename?: 'EvidenceEntity' }
      & Pick<EvidenceEntity, 'id'>
      & { attributes?: Maybe<(
        { __typename?: 'Evidence' }
        & { custom_data_fields?: Maybe<Array<Maybe<(
          { __typename: 'ComponentCustomDataFieldsRadio' }
          & ComponentCustomDataFieldsRadioFragment
        ) | (
          { __typename: 'ComponentCustomDataFieldsText' }
          & ComponentCustomDataFieldsTextFragment
        ) | (
          { __typename: 'ComponentCustomDataFieldsCheckbox' }
          & ComponentCustomDataFieldsCheckboxFragment
        ) | (
          { __typename: 'ComponentCustomDataFieldsSelect' }
          & ComponentCustomDataFieldsSelectFragment
        ) | (
          { __typename: 'ComponentCustomDataFieldsNumberRange' }
          & ComponentCustomDataFieldsNumberRangeFragment
        ) | (
          { __typename: 'ComponentCustomDataFieldsPercentage' }
          & ComponentCustomDataFieldsPercentageFragment
          & ComponentCustomDataFieldsPercentageFragment
        ) | (
          { __typename: 'ComponentCustomDataFieldsMetricsSpecific' }
          & ComponentCustomDataFieldsMetricsSpecificFragment
        ) | (
          { __typename: 'ComponentCustomDataFieldsNumberDropDown' }
          & ComponentCustomDataFieldsNumberDropDownFragment
        ) | (
          { __typename: 'ComponentCustomDataFieldsRating' }
          & ComponentCustomDataFieldsRatingFragment
        ) | (
          { __typename: 'ComponentCustomDataFieldsNumberField' }
          & ComponentCustomDataFieldsNumberFieldFragment
        ) | (
          { __typename: 'ComponentCustomDataFieldsDateTimeField' }
          & ComponentCustomDataFieldsDateTimeFieldFragment
        ) | (
          { __typename: 'ComponentCustomDataFieldsDataList' }
          & ComponentCustomDataFieldsDataListFragment
        ) | (
          { __typename: 'ComponentCustomDataFieldsEmailField' }
          & ComponentCustomDataFieldsEmailFieldFragment
        ) | (
          { __typename: 'ComponentCustomDataFieldsPhoneNumberField' }
          & ComponentCustomDataFieldsPhoneNumberFieldFragment
        ) | (
          { __typename: 'ComponentCustomDataFieldsImageField' }
          & ComponentCustomDataFieldsImageFieldFragment
        ) | { __typename: 'Error' }>>> }
        & EvidenceFragment
      )> }
    )> }
  ) }
);

export type CreateBaoverifierFullTaskFromDesktopMutationVariables = Exact<{
  task?: Maybe<TaskInput>;
  evidence?: Maybe<EvidenceInputType>;
  taskEdited?: Maybe<Scalars['String']>;
}>;


export type CreateBaoverifierFullTaskFromDesktopMutation = (
  { __typename?: 'Mutation' }
  & { createBaoverifierFullTaskFromDesktop: (
    { __typename?: 'TaskAndEvidenceType' }
    & { task?: Maybe<(
      { __typename?: 'TaskEntity' }
      & Pick<TaskEntity, 'id'>
    )>, evidence?: Maybe<(
      { __typename?: 'EvidenceEntity' }
      & Pick<EvidenceEntity, 'id'>
      & { attributes?: Maybe<(
        { __typename?: 'Evidence' }
        & { custom_data_fields?: Maybe<Array<Maybe<(
          { __typename: 'ComponentCustomDataFieldsRadio' }
          & ComponentCustomDataFieldsRadioFragment
        ) | (
          { __typename: 'ComponentCustomDataFieldsText' }
          & ComponentCustomDataFieldsTextFragment
        ) | (
          { __typename: 'ComponentCustomDataFieldsCheckbox' }
          & ComponentCustomDataFieldsCheckboxFragment
        ) | (
          { __typename: 'ComponentCustomDataFieldsSelect' }
          & ComponentCustomDataFieldsSelectFragment
        ) | (
          { __typename: 'ComponentCustomDataFieldsNumberRange' }
          & ComponentCustomDataFieldsNumberRangeFragment
        ) | (
          { __typename: 'ComponentCustomDataFieldsPercentage' }
          & ComponentCustomDataFieldsPercentageFragment
          & ComponentCustomDataFieldsPercentageFragment
        ) | (
          { __typename: 'ComponentCustomDataFieldsMetricsSpecific' }
          & ComponentCustomDataFieldsMetricsSpecificFragment
        ) | (
          { __typename: 'ComponentCustomDataFieldsNumberDropDown' }
          & ComponentCustomDataFieldsNumberDropDownFragment
        ) | (
          { __typename: 'ComponentCustomDataFieldsRating' }
          & ComponentCustomDataFieldsRatingFragment
        ) | (
          { __typename: 'ComponentCustomDataFieldsNumberField' }
          & ComponentCustomDataFieldsNumberFieldFragment
        ) | (
          { __typename: 'ComponentCustomDataFieldsDateTimeField' }
          & ComponentCustomDataFieldsDateTimeFieldFragment
        ) | (
          { __typename: 'ComponentCustomDataFieldsDataList' }
          & ComponentCustomDataFieldsDataListFragment
        ) | (
          { __typename: 'ComponentCustomDataFieldsEmailField' }
          & ComponentCustomDataFieldsEmailFieldFragment
        ) | (
          { __typename: 'ComponentCustomDataFieldsPhoneNumberField' }
          & ComponentCustomDataFieldsPhoneNumberFieldFragment
        ) | (
          { __typename: 'ComponentCustomDataFieldsImageField' }
          & ComponentCustomDataFieldsImageFieldFragment
        ) | { __typename: 'Error' }>>> }
        & EvidenceFragment
      )> }
    )> }
  ) }
);

export type CreateDataLabelValueMutationVariables = Exact<{
  input?: Maybe<TaskDataLabelValueInput>;
}>;


export type CreateDataLabelValueMutation = (
  { __typename?: 'Mutation' }
  & { createDataLabelValue?: Maybe<(
    { __typename?: 'TaskDataLabelValue' }
    & Pick<TaskDataLabelValue, 'value'>
  )> }
);

export type CreateEvidenceMutationVariables = Exact<{
  input?: Maybe<EvidenceInput>;
  dataLabelValues?: Maybe<Scalars['JSON']>;
}>;


export type CreateEvidenceMutation = (
  { __typename?: 'Mutation' }
  & { createBaoriderEvidence: (
    { __typename?: 'EvidenceEntity' }
    & Pick<EvidenceEntity, 'id'>
  ) }
);

export type CreateTaskMutationVariables = Exact<{
  input?: Maybe<TaskInput>;
}>;


export type CreateTaskMutation = (
  { __typename?: 'Mutation' }
  & { createBaoverifierTask: (
    { __typename?: 'TaskEntity' }
    & Pick<TaskEntity, 'id'>
  ) }
);

export type MarkNotificationAsReadMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MarkNotificationAsReadMutation = (
  { __typename?: 'Mutation' }
  & { markDataCollectorNotificationAsRead?: Maybe<(
    { __typename?: 'NotificationEntity' }
    & Pick<NotificationEntity, 'id'>
  )> }
);

export type MarkNotificationAsReceivedMutationVariables = Exact<{
  notificationId: Scalars['ID'];
}>;


export type MarkNotificationAsReceivedMutation = (
  { __typename?: 'Mutation' }
  & { markNotificationAsReceived?: Maybe<(
    { __typename?: 'PushNotificationStatusEntity' }
    & Pick<PushNotificationStatusEntity, 'id'>
  )> }
);

export type SuggestCommunityMemberMutationVariables = Exact<{
  input?: Maybe<SuggestCommunityMembersInput>;
}>;


export type SuggestCommunityMemberMutation = (
  { __typename?: 'Mutation' }
  & { suggestCommunityMember: (
    { __typename?: 'CommunityMembersPayload' }
    & { member?: Maybe<(
      { __typename?: 'UsersPermissionsUserEntity' }
      & Pick<UsersPermissionsUserEntity, 'id'>
    )> }
  ) }
);

export type UpdateTaskMutationVariables = Exact<{
  id: Scalars['ID'];
  input?: Maybe<TaskInput>;
}>;


export type UpdateTaskMutation = (
  { __typename?: 'Mutation' }
  & { updateBaoriderTask: (
    { __typename?: 'TaskEntity' }
    & Pick<TaskEntity, 'id'>
  ) }
);

export type UpdateEvidenceMutationVariables = Exact<{
  id: Scalars['ID'];
  input?: Maybe<EvidenceInput>;
}>;


export type UpdateEvidenceMutation = (
  { __typename?: 'Mutation' }
  & { updateBaoriderEvidence: (
    { __typename?: 'Evidence' }
    & Pick<Evidence, 'notes'>
  ) }
);

export type UpdateMyUserMutationVariables = Exact<{
  input?: Maybe<UpdateMyUserInput>;
}>;


export type UpdateMyUserMutation = (
  { __typename?: 'Mutation' }
  & { updateMyUser?: Maybe<(
    { __typename?: 'UsersPermissionsUserEntity' }
    & Pick<UsersPermissionsUserEntity, 'id'>
    & { attributes?: Maybe<(
      { __typename?: 'UsersPermissionsUser' }
      & Pick<UsersPermissionsUser, 'onboarding' | 'pushToken'>
      & { role?: Maybe<(
        { __typename?: 'UsersPermissionsRoleEntityResponse' }
        & { data?: Maybe<(
          { __typename?: 'UsersPermissionsRoleEntity' }
          & Pick<UsersPermissionsRoleEntity, 'id'>
          & { attributes?: Maybe<(
            { __typename?: 'UsersPermissionsRole' }
            & RoleFragment
          )> }
        )> }
      )>, profilePicture?: Maybe<(
        { __typename?: 'UploadFileEntityResponse' }
        & { data?: Maybe<(
          { __typename?: 'UploadFileEntity' }
          & UploadFileFragment
        )> }
      )> }
      & UserFragment
    )> }
  )> }
);

export type VerifyDatacollectOtpMutationVariables = Exact<{
  code: Scalars['String'];
  otp: Scalars['String'];
}>;


export type VerifyDatacollectOtpMutation = (
  { __typename?: 'Mutation' }
  & { verifyDatacollectOtp?: Maybe<(
    { __typename?: 'CodeValid' }
    & Pick<CodeValid, 'valid' | 'code'>
  )> }
);

export type BaoverifierAppQueryVariables = Exact<{ [key: string]: never; }>;


export type BaoverifierAppQuery = (
  { __typename?: 'Query' }
  & { baoverifierApp?: Maybe<(
    { __typename?: 'BaoverifierAppEntityResponse' }
    & { data?: Maybe<(
      { __typename?: 'BaoverifierAppEntity' }
      & Pick<BaoverifierAppEntity, 'id'>
      & { attributes?: Maybe<(
        { __typename?: 'BaoverifierApp' }
        & AppFragment
      )> }
    )> }
  )> }
);

export type CanEditTaskQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CanEditTaskQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'canEditTask'>
);

export type FindDataListOptionWithCountQueryVariables = Exact<{
  orderBy?: Maybe<Scalars['JSON']>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
}>;


export type FindDataListOptionWithCountQuery = (
  { __typename?: 'Query' }
  & { findDataListOptionWithCount?: Maybe<(
    { __typename?: 'DataListOptionWithCount' }
    & Pick<DataListOptionWithCount, 'count'>
    & { data?: Maybe<Array<Maybe<(
      { __typename?: 'DataListOptionEntity' }
      & Pick<DataListOptionEntity, 'id'>
      & { attributes?: Maybe<(
        { __typename?: 'DataListOption' }
        & { data_list?: Maybe<(
          { __typename?: 'DataListEntityResponse' }
          & { data?: Maybe<(
            { __typename?: 'DataListEntity' }
            & Pick<DataListEntity, 'id'>
            & { attributes?: Maybe<(
              { __typename?: 'DataList' }
              & DataListsFragment
            )> }
          )> }
        )> }
        & DataListOptionFragment
      )> }
    )>>> }
  )> }
);

export type GetBaoriderCommunitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBaoriderCommunitiesQuery = (
  { __typename?: 'Query' }
  & { getBaoriderCommunities?: Maybe<Array<Maybe<(
    { __typename?: 'CommunityEntity' }
    & Pick<CommunityEntity, 'id'>
    & { attributes?: Maybe<(
      { __typename?: 'Community' }
      & { featured_image?: Maybe<(
        { __typename?: 'UploadFileEntityResponse' }
        & { data?: Maybe<(
          { __typename?: 'UploadFileEntity' }
          & UploadFileFragment
        )> }
      )> }
      & CommunityFragment
    )> }
  )>>> }
);

export type GetBaoriderCommunityProjectsQueryVariables = Exact<{
  community: Scalars['ID'];
}>;


export type GetBaoriderCommunityProjectsQuery = (
  { __typename?: 'Query' }
  & { getBaoriderCommunityProjects?: Maybe<Array<Maybe<(
    { __typename?: 'ProjectEntity' }
    & Pick<ProjectEntity, 'id'>
    & { attributes?: Maybe<(
      { __typename?: 'Project' }
      & { featured_image?: Maybe<(
        { __typename?: 'UploadFileEntityResponse' }
        & { data?: Maybe<(
          { __typename?: 'UploadFileEntity' }
          & UploadFileFragment
        )> }
      )> }
      & ProjectFragment
    )> }
  )>>> }
);

export type GetBaoriderProjectsQueryVariables = Exact<{
  filters?: Maybe<Scalars['JSON']>;
}>;


export type GetBaoriderProjectsQuery = (
  { __typename?: 'Query' }
  & { getBaoriderProjects?: Maybe<Array<Maybe<(
    { __typename?: 'ProjectEntity' }
    & Pick<ProjectEntity, 'id'>
    & { attributes?: Maybe<(
      { __typename?: 'Project' }
      & { featured_image?: Maybe<(
        { __typename?: 'UploadFileEntityResponse' }
        & { data?: Maybe<(
          { __typename?: 'UploadFileEntity' }
          & UploadFileFragment
        )> }
      )> }
      & ProjectFragment
    )> }
  )>>> }
);

export type GetBaoverifierMostPopularTaskDefinitionsQueryVariables = Exact<{
  sort?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
}>;


export type GetBaoverifierMostPopularTaskDefinitionsQuery = (
  { __typename?: 'Query' }
  & { getBaoverifierMostPopularTaskDefinitions?: Maybe<Array<Maybe<(
    { __typename?: 'PopularTaskDefinitionEntityWithCount' }
    & Pick<PopularTaskDefinitionEntityWithCount, 'count'>
    & { taskDefinition: (
      { __typename?: 'TaskDefinitionEntity' }
      & Pick<TaskDefinitionEntity, 'id'>
      & { attributes?: Maybe<(
        { __typename?: 'TaskDefinition' }
        & Pick<TaskDefinition, 'status'>
        & { category?: Maybe<(
          { __typename?: 'CategoryEntityResponse' }
          & { data?: Maybe<(
            { __typename?: 'CategoryEntity' }
            & Pick<CategoryEntity, 'id'>
            & { attributes?: Maybe<(
              { __typename?: 'Category' }
              & { featureImage?: Maybe<(
                { __typename?: 'UploadFileEntityResponse' }
                & { data?: Maybe<(
                  { __typename?: 'UploadFileEntity' }
                  & UploadFileFragment
                )> }
              )> }
              & CategoryFragment
            )> }
          )> }
        )>, baoleader?: Maybe<(
          { __typename?: 'UsersPermissionsUserEntityResponse' }
          & { data?: Maybe<(
            { __typename?: 'UsersPermissionsUserEntity' }
            & Pick<UsersPermissionsUserEntity, 'id'>
            & { attributes?: Maybe<(
              { __typename?: 'UsersPermissionsUser' }
              & { baoleader?: Maybe<(
                { __typename?: 'UsersPermissionsUserEntityResponse' }
                & { data?: Maybe<(
                  { __typename?: 'UsersPermissionsUserEntity' }
                  & Pick<UsersPermissionsUserEntity, 'id'>
                )> }
              )> }
            )> }
          )> }
        )>, project?: Maybe<(
          { __typename?: 'ProjectEntityResponse' }
          & { data?: Maybe<(
            { __typename?: 'ProjectEntity' }
            & Pick<ProjectEntity, 'id'>
            & { attributes?: Maybe<(
              { __typename?: 'Project' }
              & ProjectFragment
            )> }
          )> }
        )>, task_type?: Maybe<(
          { __typename?: 'TaskTypeEntityResponse' }
          & { data?: Maybe<(
            { __typename?: 'TaskTypeEntity' }
            & Pick<TaskTypeEntity, 'id'>
            & { attributes?: Maybe<(
              { __typename?: 'TaskType' }
              & Pick<TaskType, 'title'>
              & { dataFields?: Maybe<Array<Maybe<(
                { __typename: 'ComponentCustomDataFieldsCheckbox' }
                & ComponentCustomDataFieldsCheckboxFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsRadio' }
                & ComponentCustomDataFieldsRadioFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsSelect' }
                & ComponentCustomDataFieldsSelectFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsText' }
                & ComponentCustomDataFieldsTextFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsNumberRange' }
                & ComponentCustomDataFieldsNumberRangeFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsPercentage' }
                & ComponentCustomDataFieldsPercentageFragment
                & ComponentCustomDataFieldsPercentageFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsMetricsSpecific' }
                & ComponentCustomDataFieldsMetricsSpecificFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsNumberDropDown' }
                & ComponentCustomDataFieldsNumberDropDownFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsRating' }
                & ComponentCustomDataFieldsRatingFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsNumberField' }
                & ComponentCustomDataFieldsNumberFieldFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsDateTimeField' }
                & ComponentCustomDataFieldsDateTimeFieldFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsDataList' }
                & ComponentCustomDataFieldsDataListFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsEmailField' }
                & ComponentCustomDataFieldsEmailFieldFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsPhoneNumberField' }
                & ComponentCustomDataFieldsPhoneNumberFieldFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsImageField' }
                & ComponentCustomDataFieldsImageFieldFragment
              ) | { __typename: 'Error' }>>>, custom_data_fields?: Maybe<(
                { __typename?: 'CustomDataLabelRelationResponseCollection' }
                & { data: Array<(
                  { __typename?: 'CustomDataLabelEntity' }
                  & Pick<CustomDataLabelEntity, 'id'>
                  & { attributes?: Maybe<(
                    { __typename?: 'CustomDataLabel' }
                    & Pick<CustomDataLabel, 'label'>
                    & { type?: Maybe<(
                      { __typename?: 'DataLabelTypeEntityResponse' }
                      & { data?: Maybe<(
                        { __typename?: 'DataLabelTypeEntity' }
                        & Pick<DataLabelTypeEntity, 'id'>
                        & { attributes?: Maybe<(
                          { __typename?: 'DataLabelType' }
                          & Pick<DataLabelType, 'name' | 'has_options'>
                        )> }
                      )> }
                    )>, options?: Maybe<(
                      { __typename?: 'ProjectDataLabelTypeOptionRelationResponseCollection' }
                      & { data: Array<(
                        { __typename?: 'ProjectDataLabelTypeOptionEntity' }
                        & Pick<ProjectDataLabelTypeOptionEntity, 'id'>
                        & { attributes?: Maybe<(
                          { __typename?: 'ProjectDataLabelTypeOption' }
                          & Pick<ProjectDataLabelTypeOption, 'value'>
                        )> }
                      )> }
                    )> }
                  )> }
                )> }
              )> }
            )> }
          )> }
        )> }
      )> }
    ) }
  )>>> }
);

export type GetCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCategoriesQuery = (
  { __typename?: 'Query' }
  & { categories?: Maybe<(
    { __typename?: 'CategoryEntityResponseCollection' }
    & { data: Array<(
      { __typename?: 'CategoryEntity' }
      & Pick<CategoryEntity, 'id'>
      & { attributes?: Maybe<(
        { __typename?: 'Category' }
        & { featureImage?: Maybe<(
          { __typename?: 'UploadFileEntityResponse' }
          & { data?: Maybe<(
            { __typename?: 'UploadFileEntity' }
            & UploadFileFragment
          )> }
        )> }
        & CategoryFragment
      )> }
    )> }
  )> }
);

export type GetDataCollectorTasksLeaderBoardQueryVariables = Exact<{
  sort?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
}>;


export type GetDataCollectorTasksLeaderBoardQuery = (
  { __typename?: 'Query' }
  & { getDataCollectorTasksLeaderBoard?: Maybe<Array<Maybe<(
    { __typename?: 'TasksWithDataCollector' }
    & Pick<TasksWithDataCollector, 'count'>
    & { dataCollector?: Maybe<(
      { __typename?: 'UsersPermissionsUserEntity' }
      & Pick<UsersPermissionsUserEntity, 'id'>
      & { attributes?: Maybe<(
        { __typename?: 'UsersPermissionsUser' }
        & Pick<UsersPermissionsUser, 'firstName' | 'lastName'>
      )> }
    )> }
  )>>> }
);

export type GetDataListQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetDataListQuery = (
  { __typename?: 'Query' }
  & { dataList?: Maybe<(
    { __typename?: 'DataListEntityResponse' }
    & { data?: Maybe<(
      { __typename?: 'DataListEntity' }
      & Pick<DataListEntity, 'id'>
      & { attributes?: Maybe<(
        { __typename?: 'DataList' }
        & DataListsFragment
      )> }
    )> }
  )> }
);

export type GetDataListsQueryVariables = Exact<{
  sort?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  filters?: Maybe<DataListFiltersInput>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
}>;


export type GetDataListsQuery = (
  { __typename?: 'Query' }
  & { dataLists?: Maybe<(
    { __typename?: 'DataListEntityResponseCollection' }
    & { data: Array<(
      { __typename?: 'DataListEntity' }
      & Pick<DataListEntity, 'id'>
      & { attributes?: Maybe<(
        { __typename?: 'DataList' }
        & DataListsFragment
      )> }
    )>, meta: (
      { __typename?: 'ResponseCollectionMeta' }
      & { pagination: (
        { __typename?: 'Pagination' }
        & PaginationFragment
      ) }
    ) }
  )> }
);

export type GetBaoriderEvidenceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetBaoriderEvidenceQuery = (
  { __typename?: 'Query' }
  & { getBaoriderEvidence?: Maybe<(
    { __typename?: 'Evidence' }
    & { photos?: Maybe<(
      { __typename?: 'UploadFileRelationResponseCollection' }
      & { data: Array<(
        { __typename?: 'UploadFileEntity' }
        & UploadFileFragment
      )> }
    )>, custom_data_fields?: Maybe<Array<Maybe<(
      { __typename: 'ComponentCustomDataFieldsRadio' }
      & ComponentCustomDataFieldsRadioFragment
    ) | (
      { __typename: 'ComponentCustomDataFieldsText' }
      & ComponentCustomDataFieldsTextFragment
    ) | (
      { __typename: 'ComponentCustomDataFieldsCheckbox' }
      & ComponentCustomDataFieldsCheckboxFragment
    ) | (
      { __typename: 'ComponentCustomDataFieldsSelect' }
      & ComponentCustomDataFieldsSelectFragment
    ) | (
      { __typename: 'ComponentCustomDataFieldsNumberRange' }
      & ComponentCustomDataFieldsNumberRangeFragment
    ) | (
      { __typename: 'ComponentCustomDataFieldsPercentage' }
      & ComponentCustomDataFieldsPercentageFragment
      & ComponentCustomDataFieldsPercentageFragment
    ) | (
      { __typename: 'ComponentCustomDataFieldsMetricsSpecific' }
      & ComponentCustomDataFieldsMetricsSpecificFragment
    ) | (
      { __typename: 'ComponentCustomDataFieldsNumberDropDown' }
      & ComponentCustomDataFieldsNumberDropDownFragment
    ) | (
      { __typename: 'ComponentCustomDataFieldsRating' }
      & ComponentCustomDataFieldsRatingFragment
    ) | (
      { __typename: 'ComponentCustomDataFieldsNumberField' }
      & ComponentCustomDataFieldsNumberFieldFragment
    ) | (
      { __typename: 'ComponentCustomDataFieldsDateTimeField' }
      & ComponentCustomDataFieldsDateTimeFieldFragment
    ) | (
      { __typename: 'ComponentCustomDataFieldsDataList' }
      & ComponentCustomDataFieldsDataListFragment
    ) | (
      { __typename: 'ComponentCustomDataFieldsEmailField' }
      & ComponentCustomDataFieldsEmailFieldFragment
    ) | (
      { __typename: 'ComponentCustomDataFieldsPhoneNumberField' }
      & ComponentCustomDataFieldsPhoneNumberFieldFragment
    ) | (
      { __typename: 'ComponentCustomDataFieldsImageField' }
      & ComponentCustomDataFieldsImageFieldFragment
    ) | { __typename: 'Error' }>>> }
    & EvidenceFragment
  )> }
);

export type GetNotificationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetNotificationQuery = (
  { __typename?: 'Query' }
  & { getDataCollectorNotification?: Maybe<(
    { __typename?: 'NotificationEntity' }
    & Pick<NotificationEntity, 'id'>
    & { attributes?: Maybe<(
      { __typename?: 'Notification' }
      & NotificationFragment
    )> }
  )> }
);

export type GetNotificationTasksQueryVariables = Exact<{
  sort?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
}>;


export type GetNotificationTasksQuery = (
  { __typename?: 'Query' }
  & { getNotificationTasks?: Maybe<Array<Maybe<(
    { __typename?: 'TaskWithCanEdit' }
    & Pick<TaskWithCanEdit, 'canEdit'>
    & { task?: Maybe<(
      { __typename?: 'TaskEntity' }
      & Pick<TaskEntity, 'id'>
      & { attributes?: Maybe<(
        { __typename?: 'Task' }
        & { baoleader?: Maybe<(
          { __typename?: 'UsersPermissionsUserEntityResponse' }
          & { data?: Maybe<(
            { __typename?: 'UsersPermissionsUserEntity' }
            & Pick<UsersPermissionsUserEntity, 'id'>
            & { attributes?: Maybe<(
              { __typename?: 'UsersPermissionsUser' }
              & { profilePicture?: Maybe<(
                { __typename?: 'UploadFileEntityResponse' }
                & { data?: Maybe<(
                  { __typename?: 'UploadFileEntity' }
                  & UploadFileFragment
                )> }
              )>, baoleader?: Maybe<(
                { __typename?: 'UsersPermissionsUserEntityResponse' }
                & { data?: Maybe<(
                  { __typename?: 'UsersPermissionsUserEntity' }
                  & Pick<UsersPermissionsUserEntity, 'id'>
                )> }
              )> }
              & UserFragment
            )> }
          )> }
        )>, baorider?: Maybe<(
          { __typename?: 'UsersPermissionsUserEntityResponse' }
          & { data?: Maybe<(
            { __typename?: 'UsersPermissionsUserEntity' }
            & Pick<UsersPermissionsUserEntity, 'id'>
            & { attributes?: Maybe<(
              { __typename?: 'UsersPermissionsUser' }
              & { profilePicture?: Maybe<(
                { __typename?: 'UploadFileEntityResponse' }
                & { data?: Maybe<(
                  { __typename?: 'UploadFileEntity' }
                  & UploadFileFragment
                )> }
              )>, baoleader?: Maybe<(
                { __typename?: 'UsersPermissionsUserEntityResponse' }
                & { data?: Maybe<(
                  { __typename?: 'UsersPermissionsUserEntity' }
                  & Pick<UsersPermissionsUserEntity, 'id'>
                )> }
              )> }
              & UserFragment
            )> }
          )> }
        )>, task_definition?: Maybe<(
          { __typename?: 'TaskDefinitionEntityResponse' }
          & { data?: Maybe<(
            { __typename?: 'TaskDefinitionEntity' }
            & Pick<TaskDefinitionEntity, 'id'>
            & { attributes?: Maybe<(
              { __typename?: 'TaskDefinition' }
              & { category?: Maybe<(
                { __typename?: 'CategoryEntityResponse' }
                & { data?: Maybe<(
                  { __typename?: 'CategoryEntity' }
                  & Pick<CategoryEntity, 'id'>
                  & { attributes?: Maybe<(
                    { __typename?: 'Category' }
                    & { featureImage?: Maybe<(
                      { __typename?: 'UploadFileEntityResponse' }
                      & { data?: Maybe<(
                        { __typename?: 'UploadFileEntity' }
                        & UploadFileFragment
                      )> }
                    )> }
                    & CategoryFragment
                  )> }
                )> }
              )>, task_type?: Maybe<(
                { __typename?: 'TaskTypeEntityResponse' }
                & { data?: Maybe<(
                  { __typename?: 'TaskTypeEntity' }
                  & Pick<TaskTypeEntity, 'id'>
                  & { attributes?: Maybe<(
                    { __typename?: 'TaskType' }
                    & Task_TypeFragment
                  )> }
                )> }
              )> }
            )> }
          )> }
        )>, project?: Maybe<(
          { __typename?: 'ProjectEntityResponse' }
          & { data?: Maybe<(
            { __typename?: 'ProjectEntity' }
            & Pick<ProjectEntity, 'id'>
            & { attributes?: Maybe<(
              { __typename?: 'Project' }
              & ProjectFragment
            )> }
          )> }
        )>, evidences?: Maybe<(
          { __typename?: 'EvidenceRelationResponseCollection' }
          & { data: Array<(
            { __typename?: 'EvidenceEntity' }
            & Pick<EvidenceEntity, 'id'>
            & { attributes?: Maybe<(
              { __typename?: 'Evidence' }
              & { custom_data_fields?: Maybe<Array<Maybe<(
                { __typename: 'ComponentCustomDataFieldsRadio' }
                & ComponentCustomDataFieldsRadioFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsText' }
                & ComponentCustomDataFieldsTextFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsCheckbox' }
                & ComponentCustomDataFieldsCheckboxFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsSelect' }
                & ComponentCustomDataFieldsSelectFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsNumberRange' }
                & ComponentCustomDataFieldsNumberRangeFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsPercentage' }
                & ComponentCustomDataFieldsPercentageFragment
                & ComponentCustomDataFieldsPercentageFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsMetricsSpecific' }
                & ComponentCustomDataFieldsMetricsSpecificFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsNumberDropDown' }
                & ComponentCustomDataFieldsNumberDropDownFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsRating' }
                & ComponentCustomDataFieldsRatingFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsNumberField' }
                & ComponentCustomDataFieldsNumberFieldFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsDateTimeField' }
                & ComponentCustomDataFieldsDateTimeFieldFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsDataList' }
                & ComponentCustomDataFieldsDataListFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsEmailField' }
                & ComponentCustomDataFieldsEmailFieldFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsPhoneNumberField' }
                & ComponentCustomDataFieldsPhoneNumberFieldFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsImageField' }
                & ComponentCustomDataFieldsImageFieldFragment
              ) | { __typename: 'Error' }>>>, photos?: Maybe<(
                { __typename?: 'UploadFileRelationResponseCollection' }
                & { data: Array<(
                  { __typename?: 'UploadFileEntity' }
                  & UploadFileFragment
                )> }
              )>, baorider?: Maybe<(
                { __typename?: 'UsersPermissionsUserEntityResponse' }
                & { data?: Maybe<(
                  { __typename?: 'UsersPermissionsUserEntity' }
                  & Pick<UsersPermissionsUserEntity, 'id'>
                )> }
              )> }
              & EvidenceFragment
            )> }
          )> }
        )>, community?: Maybe<(
          { __typename?: 'CommunityEntityResponse' }
          & { data?: Maybe<(
            { __typename?: 'CommunityEntity' }
            & Pick<CommunityEntity, 'id'>
            & { attributes?: Maybe<(
              { __typename?: 'Community' }
              & CommunityFragment
            )> }
          )> }
        )> }
        & TaskFragment
      )> }
    )> }
  )>>> }
);

export type GetNotificationsQueryVariables = Exact<{
  sort?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
}>;


export type GetNotificationsQuery = (
  { __typename?: 'Query' }
  & { getDataCollectorNotifications?: Maybe<Array<Maybe<(
    { __typename?: 'NotificationEntity' }
    & Pick<NotificationEntity, 'id'>
    & { attributes?: Maybe<(
      { __typename?: 'Notification' }
      & NotificationFragment
    )> }
  )>>> }
);

export type GetNumberDataCollectorsTasksQueryVariables = Exact<{
  sort?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
}>;


export type GetNumberDataCollectorsTasksQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getNumberDataCollectorsTasks'>
);

export type GetSingleBaoriderCommunityQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetSingleBaoriderCommunityQuery = (
  { __typename?: 'Query' }
  & { getSingleBaoriderCommunity?: Maybe<(
    { __typename?: 'BaoriderCommunityMetrics' }
    & Pick<BaoriderCommunityMetrics, 'completedTasks' | 'completedProjects' | 'activeMembers'>
    & { community?: Maybe<(
      { __typename?: 'Community' }
      & { featured_image?: Maybe<(
        { __typename?: 'UploadFileEntityResponse' }
        & { data?: Maybe<(
          { __typename?: 'UploadFileEntity' }
          & UploadFileFragment
        )> }
      )>, baoleader?: Maybe<(
        { __typename?: 'UsersPermissionsUserEntityResponse' }
        & { data?: Maybe<(
          { __typename?: 'UsersPermissionsUserEntity' }
          & Pick<UsersPermissionsUserEntity, 'id'>
          & { attributes?: Maybe<(
            { __typename?: 'UsersPermissionsUser' }
            & { profilePicture?: Maybe<(
              { __typename?: 'UploadFileEntityResponse' }
              & { data?: Maybe<(
                { __typename?: 'UploadFileEntity' }
                & UploadFileFragment
              )> }
            )>, baoleader?: Maybe<(
              { __typename?: 'UsersPermissionsUserEntityResponse' }
              & { data?: Maybe<(
                { __typename?: 'UsersPermissionsUserEntity' }
                & Pick<UsersPermissionsUserEntity, 'id'>
              )> }
            )> }
            & UserFragment
          )> }
        )> }
      )> }
      & CommunityFragment
    )> }
  )> }
);

export type GetSingleBaoriderProjectQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetSingleBaoriderProjectQuery = (
  { __typename?: 'Query' }
  & { getSingleBaoriderProject?: Maybe<(
    { __typename?: 'ProjectEntity' }
    & Pick<ProjectEntity, 'id'>
    & { attributes?: Maybe<(
      { __typename?: 'Project' }
      & { featured_image?: Maybe<(
        { __typename?: 'UploadFileEntityResponse' }
        & { data?: Maybe<(
          { __typename?: 'UploadFileEntity' }
          & UploadFileFragment
        )> }
      )> }
      & ProjectFragment
    )> }
  )> }
);

export type GetSingleBaoriderTaskQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetSingleBaoriderTaskQuery = (
  { __typename?: 'Query' }
  & { getSingleBaoriderTask?: Maybe<(
    { __typename?: 'TaskEntity' }
    & Pick<TaskEntity, 'id'>
    & { attributes?: Maybe<(
      { __typename?: 'Task' }
      & { baoleader?: Maybe<(
        { __typename?: 'UsersPermissionsUserEntityResponse' }
        & { data?: Maybe<(
          { __typename?: 'UsersPermissionsUserEntity' }
          & Pick<UsersPermissionsUserEntity, 'id'>
          & { attributes?: Maybe<(
            { __typename?: 'UsersPermissionsUser' }
            & { profilePicture?: Maybe<(
              { __typename?: 'UploadFileEntityResponse' }
              & { data?: Maybe<(
                { __typename?: 'UploadFileEntity' }
                & UploadFileFragment
              )> }
            )>, baoleader?: Maybe<(
              { __typename?: 'UsersPermissionsUserEntityResponse' }
              & { data?: Maybe<(
                { __typename?: 'UsersPermissionsUserEntity' }
                & Pick<UsersPermissionsUserEntity, 'id'>
              )> }
            )> }
            & UserFragment
          )> }
        )> }
      )>, baorider?: Maybe<(
        { __typename?: 'UsersPermissionsUserEntityResponse' }
        & { data?: Maybe<(
          { __typename?: 'UsersPermissionsUserEntity' }
          & Pick<UsersPermissionsUserEntity, 'id'>
          & { attributes?: Maybe<(
            { __typename?: 'UsersPermissionsUser' }
            & { profilePicture?: Maybe<(
              { __typename?: 'UploadFileEntityResponse' }
              & { data?: Maybe<(
                { __typename?: 'UploadFileEntity' }
                & UploadFileFragment
              )> }
            )>, baoleader?: Maybe<(
              { __typename?: 'UsersPermissionsUserEntityResponse' }
              & { data?: Maybe<(
                { __typename?: 'UsersPermissionsUserEntity' }
                & Pick<UsersPermissionsUserEntity, 'id'>
              )> }
            )> }
            & UserFragment
          )> }
        )> }
      )>, task_definition?: Maybe<(
        { __typename?: 'TaskDefinitionEntityResponse' }
        & { data?: Maybe<(
          { __typename?: 'TaskDefinitionEntity' }
          & Pick<TaskDefinitionEntity, 'id'>
          & { attributes?: Maybe<(
            { __typename?: 'TaskDefinition' }
            & { category?: Maybe<(
              { __typename?: 'CategoryEntityResponse' }
              & { data?: Maybe<(
                { __typename?: 'CategoryEntity' }
                & Pick<CategoryEntity, 'id'>
                & { attributes?: Maybe<(
                  { __typename?: 'Category' }
                  & CategoryFragment
                )> }
              )> }
            )>, baoleader?: Maybe<(
              { __typename?: 'UsersPermissionsUserEntityResponse' }
              & { data?: Maybe<(
                { __typename?: 'UsersPermissionsUserEntity' }
                & Pick<UsersPermissionsUserEntity, 'id'>
                & { attributes?: Maybe<(
                  { __typename?: 'UsersPermissionsUser' }
                  & { baoleader?: Maybe<(
                    { __typename?: 'UsersPermissionsUserEntityResponse' }
                    & { data?: Maybe<(
                      { __typename?: 'UsersPermissionsUserEntity' }
                      & Pick<UsersPermissionsUserEntity, 'id'>
                    )> }
                  )> }
                )> }
              )> }
            )>, project?: Maybe<(
              { __typename?: 'ProjectEntityResponse' }
              & { data?: Maybe<(
                { __typename?: 'ProjectEntity' }
                & Pick<ProjectEntity, 'id'>
                & { attributes?: Maybe<(
                  { __typename?: 'Project' }
                  & ProjectFragment
                )> }
              )> }
            )>, task_type?: Maybe<(
              { __typename?: 'TaskTypeEntityResponse' }
              & { data?: Maybe<(
                { __typename?: 'TaskTypeEntity' }
                & Pick<TaskTypeEntity, 'id'>
                & { attributes?: Maybe<(
                  { __typename?: 'TaskType' }
                  & Pick<TaskType, 'title'>
                  & { dataFields?: Maybe<Array<Maybe<(
                    { __typename: 'ComponentCustomDataFieldsCheckbox' }
                    & ComponentCustomDataFieldsCheckboxFragment
                  ) | (
                    { __typename: 'ComponentCustomDataFieldsRadio' }
                    & ComponentCustomDataFieldsRadioFragment
                  ) | (
                    { __typename: 'ComponentCustomDataFieldsSelect' }
                    & ComponentCustomDataFieldsSelectFragment
                  ) | (
                    { __typename: 'ComponentCustomDataFieldsText' }
                    & ComponentCustomDataFieldsTextFragment
                  ) | (
                    { __typename: 'ComponentCustomDataFieldsNumberRange' }
                    & ComponentCustomDataFieldsNumberRangeFragment
                  ) | (
                    { __typename: 'ComponentCustomDataFieldsPercentage' }
                    & ComponentCustomDataFieldsPercentageFragment
                    & ComponentCustomDataFieldsPercentageFragment
                  ) | (
                    { __typename: 'ComponentCustomDataFieldsMetricsSpecific' }
                    & ComponentCustomDataFieldsMetricsSpecificFragment
                  ) | (
                    { __typename: 'ComponentCustomDataFieldsNumberDropDown' }
                    & ComponentCustomDataFieldsNumberDropDownFragment
                  ) | (
                    { __typename: 'ComponentCustomDataFieldsRating' }
                    & ComponentCustomDataFieldsRatingFragment
                  ) | (
                    { __typename: 'ComponentCustomDataFieldsNumberField' }
                    & ComponentCustomDataFieldsNumberFieldFragment
                  ) | (
                    { __typename: 'ComponentCustomDataFieldsDateTimeField' }
                    & ComponentCustomDataFieldsDateTimeFieldFragment
                  ) | (
                    { __typename: 'ComponentCustomDataFieldsDataList' }
                    & ComponentCustomDataFieldsDataListFragment
                  ) | (
                    { __typename: 'ComponentCustomDataFieldsEmailField' }
                    & ComponentCustomDataFieldsEmailFieldFragment
                  ) | (
                    { __typename: 'ComponentCustomDataFieldsPhoneNumberField' }
                    & ComponentCustomDataFieldsPhoneNumberFieldFragment
                  ) | (
                    { __typename: 'ComponentCustomDataFieldsImageField' }
                    & ComponentCustomDataFieldsImageFieldFragment
                  ) | { __typename: 'Error' }>>> }
                )> }
              )> }
            )> }
          )> }
        )> }
      )>, project?: Maybe<(
        { __typename?: 'ProjectEntityResponse' }
        & { data?: Maybe<(
          { __typename?: 'ProjectEntity' }
          & Pick<ProjectEntity, 'id'>
          & { attributes?: Maybe<(
            { __typename?: 'Project' }
            & ProjectFragment
          )> }
        )> }
      )>, evidences?: Maybe<(
        { __typename?: 'EvidenceRelationResponseCollection' }
        & { data: Array<(
          { __typename?: 'EvidenceEntity' }
          & Pick<EvidenceEntity, 'id'>
          & { attributes?: Maybe<(
            { __typename?: 'Evidence' }
            & { photos?: Maybe<(
              { __typename?: 'UploadFileRelationResponseCollection' }
              & { data: Array<(
                { __typename?: 'UploadFileEntity' }
                & UploadFileFragment
              )> }
            )>, custom_data_fields?: Maybe<Array<Maybe<(
              { __typename: 'ComponentCustomDataFieldsRadio' }
              & ComponentCustomDataFieldsRadioFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsText' }
              & ComponentCustomDataFieldsTextFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsCheckbox' }
              & ComponentCustomDataFieldsCheckboxFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsSelect' }
              & ComponentCustomDataFieldsSelectFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsNumberRange' }
              & ComponentCustomDataFieldsNumberRangeFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsPercentage' }
              & ComponentCustomDataFieldsPercentageFragment
              & ComponentCustomDataFieldsPercentageFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsMetricsSpecific' }
              & ComponentCustomDataFieldsMetricsSpecificFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsNumberDropDown' }
              & ComponentCustomDataFieldsNumberDropDownFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsRating' }
              & ComponentCustomDataFieldsRatingFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsNumberField' }
              & ComponentCustomDataFieldsNumberFieldFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsDateTimeField' }
              & ComponentCustomDataFieldsDateTimeFieldFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsDataList' }
              & ComponentCustomDataFieldsDataListFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsEmailField' }
              & ComponentCustomDataFieldsEmailFieldFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsPhoneNumberField' }
              & ComponentCustomDataFieldsPhoneNumberFieldFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsImageField' }
              & ComponentCustomDataFieldsImageFieldFragment
            ) | { __typename: 'Error' }>>>, data_field_values?: Maybe<(
              { __typename?: 'TaskDataLabelValueRelationResponseCollection' }
              & { data: Array<(
                { __typename?: 'TaskDataLabelValueEntity' }
                & Pick<TaskDataLabelValueEntity, 'id'>
                & { attributes?: Maybe<(
                  { __typename?: 'TaskDataLabelValue' }
                  & Pick<TaskDataLabelValue, 'value'>
                  & { data_field?: Maybe<(
                    { __typename?: 'CustomDataLabelEntityResponse' }
                    & { data?: Maybe<(
                      { __typename?: 'CustomDataLabelEntity' }
                      & Pick<CustomDataLabelEntity, 'id'>
                      & { attributes?: Maybe<(
                        { __typename?: 'CustomDataLabel' }
                        & Pick<CustomDataLabel, 'label'>
                      )> }
                    )> }
                  )>, baorider?: Maybe<(
                    { __typename?: 'UsersPermissionsUserEntityResponse' }
                    & { data?: Maybe<(
                      { __typename?: 'UsersPermissionsUserEntity' }
                      & Pick<UsersPermissionsUserEntity, 'id'>
                    )> }
                  )> }
                )> }
              )> }
            )> }
            & EvidenceFragment
          )> }
        )> }
      )>, community?: Maybe<(
        { __typename?: 'CommunityEntityResponse' }
        & { data?: Maybe<(
          { __typename?: 'CommunityEntity' }
          & Pick<CommunityEntity, 'id'>
          & { attributes?: Maybe<(
            { __typename?: 'Community' }
            & CommunityFragment
          )> }
        )> }
      )> }
      & TaskFragment
    )> }
  )> }
);

export type GetBaoriderTasksQueryVariables = Exact<{
  sort?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
  publicationState?: Maybe<PublicationState>;
}>;


export type GetBaoriderTasksQuery = (
  { __typename?: 'Query' }
  & { getBaoriderTasks?: Maybe<(
    { __typename?: 'TasksWithCount' }
    & Pick<TasksWithCount, 'count'>
    & { data?: Maybe<Array<Maybe<(
      { __typename?: 'TaskEntity' }
      & Pick<TaskEntity, 'id'>
      & { attributes?: Maybe<(
        { __typename?: 'Task' }
        & { baoleader?: Maybe<(
          { __typename?: 'UsersPermissionsUserEntityResponse' }
          & { data?: Maybe<(
            { __typename?: 'UsersPermissionsUserEntity' }
            & Pick<UsersPermissionsUserEntity, 'id'>
            & { attributes?: Maybe<(
              { __typename?: 'UsersPermissionsUser' }
              & { profilePicture?: Maybe<(
                { __typename?: 'UploadFileEntityResponse' }
                & { data?: Maybe<(
                  { __typename?: 'UploadFileEntity' }
                  & UploadFileFragment
                )> }
              )>, baoleader?: Maybe<(
                { __typename?: 'UsersPermissionsUserEntityResponse' }
                & { data?: Maybe<(
                  { __typename?: 'UsersPermissionsUserEntity' }
                  & Pick<UsersPermissionsUserEntity, 'id'>
                )> }
              )> }
              & UserFragment
            )> }
          )> }
        )>, baorider?: Maybe<(
          { __typename?: 'UsersPermissionsUserEntityResponse' }
          & { data?: Maybe<(
            { __typename?: 'UsersPermissionsUserEntity' }
            & Pick<UsersPermissionsUserEntity, 'id'>
            & { attributes?: Maybe<(
              { __typename?: 'UsersPermissionsUser' }
              & { profilePicture?: Maybe<(
                { __typename?: 'UploadFileEntityResponse' }
                & { data?: Maybe<(
                  { __typename?: 'UploadFileEntity' }
                  & UploadFileFragment
                )> }
              )>, baoleader?: Maybe<(
                { __typename?: 'UsersPermissionsUserEntityResponse' }
                & { data?: Maybe<(
                  { __typename?: 'UsersPermissionsUserEntity' }
                  & Pick<UsersPermissionsUserEntity, 'id'>
                )> }
              )> }
              & UserFragment
            )> }
          )> }
        )>, task_definition?: Maybe<(
          { __typename?: 'TaskDefinitionEntityResponse' }
          & { data?: Maybe<(
            { __typename?: 'TaskDefinitionEntity' }
            & Pick<TaskDefinitionEntity, 'id'>
            & { attributes?: Maybe<(
              { __typename?: 'TaskDefinition' }
              & { category?: Maybe<(
                { __typename?: 'CategoryEntityResponse' }
                & { data?: Maybe<(
                  { __typename?: 'CategoryEntity' }
                  & Pick<CategoryEntity, 'id'>
                  & { attributes?: Maybe<(
                    { __typename?: 'Category' }
                    & { featureImage?: Maybe<(
                      { __typename?: 'UploadFileEntityResponse' }
                      & { data?: Maybe<(
                        { __typename?: 'UploadFileEntity' }
                        & UploadFileFragment
                      )> }
                    )> }
                    & CategoryFragment
                  )> }
                )> }
              )>, task_type?: Maybe<(
                { __typename?: 'TaskTypeEntityResponse' }
                & { data?: Maybe<(
                  { __typename?: 'TaskTypeEntity' }
                  & Pick<TaskTypeEntity, 'id'>
                  & { attributes?: Maybe<(
                    { __typename?: 'TaskType' }
                    & Task_TypeFragment
                  )> }
                )> }
              )> }
            )> }
          )> }
        )>, project?: Maybe<(
          { __typename?: 'ProjectEntityResponse' }
          & { data?: Maybe<(
            { __typename?: 'ProjectEntity' }
            & Pick<ProjectEntity, 'id'>
            & { attributes?: Maybe<(
              { __typename?: 'Project' }
              & ProjectFragment
            )> }
          )> }
        )>, evidences?: Maybe<(
          { __typename?: 'EvidenceRelationResponseCollection' }
          & { data: Array<(
            { __typename?: 'EvidenceEntity' }
            & Pick<EvidenceEntity, 'id'>
            & { attributes?: Maybe<(
              { __typename?: 'Evidence' }
              & { custom_data_fields?: Maybe<Array<Maybe<(
                { __typename: 'ComponentCustomDataFieldsRadio' }
                & ComponentCustomDataFieldsRadioFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsText' }
                & ComponentCustomDataFieldsTextFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsCheckbox' }
                & ComponentCustomDataFieldsCheckboxFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsSelect' }
                & ComponentCustomDataFieldsSelectFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsNumberRange' }
                & ComponentCustomDataFieldsNumberRangeFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsPercentage' }
                & ComponentCustomDataFieldsPercentageFragment
                & ComponentCustomDataFieldsPercentageFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsMetricsSpecific' }
                & ComponentCustomDataFieldsMetricsSpecificFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsNumberDropDown' }
                & ComponentCustomDataFieldsNumberDropDownFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsRating' }
                & ComponentCustomDataFieldsRatingFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsNumberField' }
                & ComponentCustomDataFieldsNumberFieldFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsDateTimeField' }
                & ComponentCustomDataFieldsDateTimeFieldFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsDataList' }
                & ComponentCustomDataFieldsDataListFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsEmailField' }
                & ComponentCustomDataFieldsEmailFieldFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsPhoneNumberField' }
                & ComponentCustomDataFieldsPhoneNumberFieldFragment
              ) | (
                { __typename: 'ComponentCustomDataFieldsImageField' }
                & ComponentCustomDataFieldsImageFieldFragment
              ) | { __typename: 'Error' }>>>, photos?: Maybe<(
                { __typename?: 'UploadFileRelationResponseCollection' }
                & { data: Array<(
                  { __typename?: 'UploadFileEntity' }
                  & UploadFileFragment
                )> }
              )>, baorider?: Maybe<(
                { __typename?: 'UsersPermissionsUserEntityResponse' }
                & { data?: Maybe<(
                  { __typename?: 'UsersPermissionsUserEntity' }
                  & Pick<UsersPermissionsUserEntity, 'id'>
                )> }
              )> }
              & EvidenceFragment
            )> }
          )> }
        )>, community?: Maybe<(
          { __typename?: 'CommunityEntityResponse' }
          & { data?: Maybe<(
            { __typename?: 'CommunityEntity' }
            & Pick<CommunityEntity, 'id'>
            & { attributes?: Maybe<(
              { __typename?: 'Community' }
              & CommunityFragment
            )> }
          )> }
        )> }
        & TaskFragment
      )> }
    )>>> }
  )> }
);

export type GetUnreadNotificationsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnreadNotificationsCountQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getUnreadNotificationsCount'>
);

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = (
  { __typename?: 'Query' }
  & { me?: Maybe<(
    { __typename?: 'UsersPermissionsMe' }
    & Pick<UsersPermissionsMe, 'username' | 'email' | 'confirmed' | 'blocked'>
    & { role?: Maybe<(
      { __typename?: 'UsersPermissionsMeRole' }
      & Pick<UsersPermissionsMeRole, 'id' | 'name' | 'description' | 'type'>
    )> }
  )> }
);

export type MyUserQueryVariables = Exact<{ [key: string]: never; }>;


export type MyUserQuery = (
  { __typename?: 'Query' }
  & { myUser?: Maybe<(
    { __typename?: 'UsersPermissionsUserEntity' }
    & Pick<UsersPermissionsUserEntity, 'id'>
    & { attributes?: Maybe<(
      { __typename?: 'UsersPermissionsUser' }
      & { profilePicture?: Maybe<(
        { __typename?: 'UploadFileEntityResponse' }
        & { data?: Maybe<(
          { __typename?: 'UploadFileEntity' }
          & UploadFileFragment
        )> }
      )>, community?: Maybe<(
        { __typename?: 'CommunityEntityResponse' }
        & { data?: Maybe<(
          { __typename?: 'CommunityEntity' }
          & Pick<CommunityEntity, 'id'>
          & { attributes?: Maybe<(
            { __typename?: 'Community' }
            & CommunityFragment
          )> }
        )> }
      )> }
      & UserFragment
    )> }
  )> }
);

export type GetBaoverifierTaskDefinitionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetBaoverifierTaskDefinitionQuery = (
  { __typename?: 'Query' }
  & { getBaoverifierTaskDefinition?: Maybe<(
    { __typename?: 'TaskDefinitionEntity' }
    & Pick<TaskDefinitionEntity, 'id'>
    & { attributes?: Maybe<(
      { __typename?: 'TaskDefinition' }
      & { category?: Maybe<(
        { __typename?: 'CategoryEntityResponse' }
        & { data?: Maybe<(
          { __typename?: 'CategoryEntity' }
          & Pick<CategoryEntity, 'id'>
          & { attributes?: Maybe<(
            { __typename?: 'Category' }
            & { featureImage?: Maybe<(
              { __typename?: 'UploadFileEntityResponse' }
              & { data?: Maybe<(
                { __typename?: 'UploadFileEntity' }
                & UploadFileFragment
              )> }
            )> }
            & CategoryFragment
          )> }
        )> }
      )>, baoleader?: Maybe<(
        { __typename?: 'UsersPermissionsUserEntityResponse' }
        & { data?: Maybe<(
          { __typename?: 'UsersPermissionsUserEntity' }
          & Pick<UsersPermissionsUserEntity, 'id'>
          & { attributes?: Maybe<(
            { __typename?: 'UsersPermissionsUser' }
            & { baoleader?: Maybe<(
              { __typename?: 'UsersPermissionsUserEntityResponse' }
              & { data?: Maybe<(
                { __typename?: 'UsersPermissionsUserEntity' }
                & Pick<UsersPermissionsUserEntity, 'id'>
              )> }
            )> }
          )> }
        )> }
      )>, project?: Maybe<(
        { __typename?: 'ProjectEntityResponse' }
        & { data?: Maybe<(
          { __typename?: 'ProjectEntity' }
          & Pick<ProjectEntity, 'id'>
          & { attributes?: Maybe<(
            { __typename?: 'Project' }
            & ProjectFragment
          )> }
        )> }
      )>, task_type?: Maybe<(
        { __typename?: 'TaskTypeEntityResponse' }
        & { data?: Maybe<(
          { __typename?: 'TaskTypeEntity' }
          & Pick<TaskTypeEntity, 'id'>
          & { attributes?: Maybe<(
            { __typename?: 'TaskType' }
            & Pick<TaskType, 'title'>
            & { dataFields?: Maybe<Array<Maybe<(
              { __typename: 'ComponentCustomDataFieldsCheckbox' }
              & ComponentCustomDataFieldsCheckboxFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsRadio' }
              & ComponentCustomDataFieldsRadioFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsSelect' }
              & ComponentCustomDataFieldsSelectFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsText' }
              & ComponentCustomDataFieldsTextFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsNumberRange' }
              & ComponentCustomDataFieldsNumberRangeFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsPercentage' }
              & ComponentCustomDataFieldsPercentageFragment
              & ComponentCustomDataFieldsPercentageFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsMetricsSpecific' }
              & ComponentCustomDataFieldsMetricsSpecificFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsNumberDropDown' }
              & ComponentCustomDataFieldsNumberDropDownFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsRating' }
              & ComponentCustomDataFieldsRatingFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsNumberField' }
              & ComponentCustomDataFieldsNumberFieldFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsDateTimeField' }
              & ComponentCustomDataFieldsDateTimeFieldFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsDataList' }
              & ComponentCustomDataFieldsDataListFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsEmailField' }
              & ComponentCustomDataFieldsEmailFieldFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsPhoneNumberField' }
              & ComponentCustomDataFieldsPhoneNumberFieldFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsImageField' }
              & ComponentCustomDataFieldsImageFieldFragment
            ) | { __typename: 'Error' }>>>, custom_data_fields?: Maybe<(
              { __typename?: 'CustomDataLabelRelationResponseCollection' }
              & { data: Array<(
                { __typename?: 'CustomDataLabelEntity' }
                & Pick<CustomDataLabelEntity, 'id'>
                & { attributes?: Maybe<(
                  { __typename?: 'CustomDataLabel' }
                  & Pick<CustomDataLabel, 'label'>
                  & { type?: Maybe<(
                    { __typename?: 'DataLabelTypeEntityResponse' }
                    & { data?: Maybe<(
                      { __typename?: 'DataLabelTypeEntity' }
                      & Pick<DataLabelTypeEntity, 'id'>
                      & { attributes?: Maybe<(
                        { __typename?: 'DataLabelType' }
                        & Pick<DataLabelType, 'name' | 'has_options'>
                      )> }
                    )> }
                  )>, options?: Maybe<(
                    { __typename?: 'ProjectDataLabelTypeOptionRelationResponseCollection' }
                    & { data: Array<(
                      { __typename?: 'ProjectDataLabelTypeOptionEntity' }
                      & Pick<ProjectDataLabelTypeOptionEntity, 'id'>
                      & { attributes?: Maybe<(
                        { __typename?: 'ProjectDataLabelTypeOption' }
                        & Pick<ProjectDataLabelTypeOption, 'value'>
                      )> }
                    )> }
                  )> }
                )> }
              )> }
            )> }
          )> }
        )> }
      )> }
      & Task_DefinitionFragment
    )> }
  )> }
);

export type GetBaoverifierTaskDefinitionsQueryVariables = Exact<{
  sort?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  filters?: Maybe<Scalars['JSON']>;
  pagination?: Maybe<PaginationArg>;
}>;


export type GetBaoverifierTaskDefinitionsQuery = (
  { __typename?: 'Query' }
  & { getBaoverifierTaskDefinitions?: Maybe<Array<Maybe<(
    { __typename?: 'TaskDefinitionEntity' }
    & Pick<TaskDefinitionEntity, 'id'>
    & { attributes?: Maybe<(
      { __typename?: 'TaskDefinition' }
      & { category?: Maybe<(
        { __typename?: 'CategoryEntityResponse' }
        & { data?: Maybe<(
          { __typename?: 'CategoryEntity' }
          & Pick<CategoryEntity, 'id'>
          & { attributes?: Maybe<(
            { __typename?: 'Category' }
            & { featureImage?: Maybe<(
              { __typename?: 'UploadFileEntityResponse' }
              & { data?: Maybe<(
                { __typename?: 'UploadFileEntity' }
                & UploadFileFragment
              )> }
            )> }
            & CategoryFragment
          )> }
        )> }
      )>, baoleader?: Maybe<(
        { __typename?: 'UsersPermissionsUserEntityResponse' }
        & { data?: Maybe<(
          { __typename?: 'UsersPermissionsUserEntity' }
          & Pick<UsersPermissionsUserEntity, 'id'>
          & { attributes?: Maybe<(
            { __typename?: 'UsersPermissionsUser' }
            & { baoleader?: Maybe<(
              { __typename?: 'UsersPermissionsUserEntityResponse' }
              & { data?: Maybe<(
                { __typename?: 'UsersPermissionsUserEntity' }
                & Pick<UsersPermissionsUserEntity, 'id'>
              )> }
            )> }
          )> }
        )> }
      )>, project?: Maybe<(
        { __typename?: 'ProjectEntityResponse' }
        & { data?: Maybe<(
          { __typename?: 'ProjectEntity' }
          & Pick<ProjectEntity, 'id'>
          & { attributes?: Maybe<(
            { __typename?: 'Project' }
            & ProjectFragment
          )> }
        )> }
      )>, task_type?: Maybe<(
        { __typename?: 'TaskTypeEntityResponse' }
        & { data?: Maybe<(
          { __typename?: 'TaskTypeEntity' }
          & Pick<TaskTypeEntity, 'id'>
          & { attributes?: Maybe<(
            { __typename?: 'TaskType' }
            & Pick<TaskType, 'title'>
            & { dataFields?: Maybe<Array<Maybe<(
              { __typename: 'ComponentCustomDataFieldsCheckbox' }
              & ComponentCustomDataFieldsCheckboxFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsRadio' }
              & ComponentCustomDataFieldsRadioFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsSelect' }
              & ComponentCustomDataFieldsSelectFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsText' }
              & ComponentCustomDataFieldsTextFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsNumberRange' }
              & ComponentCustomDataFieldsNumberRangeFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsPercentage' }
              & ComponentCustomDataFieldsPercentageFragment
              & ComponentCustomDataFieldsPercentageFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsMetricsSpecific' }
              & ComponentCustomDataFieldsMetricsSpecificFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsNumberDropDown' }
              & ComponentCustomDataFieldsNumberDropDownFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsRating' }
              & ComponentCustomDataFieldsRatingFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsNumberField' }
              & ComponentCustomDataFieldsNumberFieldFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsDateTimeField' }
              & ComponentCustomDataFieldsDateTimeFieldFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsDataList' }
              & ComponentCustomDataFieldsDataListFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsEmailField' }
              & ComponentCustomDataFieldsEmailFieldFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsPhoneNumberField' }
              & ComponentCustomDataFieldsPhoneNumberFieldFragment
            ) | (
              { __typename: 'ComponentCustomDataFieldsImageField' }
              & ComponentCustomDataFieldsImageFieldFragment
            ) | { __typename: 'Error' }>>>, custom_data_fields?: Maybe<(
              { __typename?: 'CustomDataLabelRelationResponseCollection' }
              & { data: Array<(
                { __typename?: 'CustomDataLabelEntity' }
                & Pick<CustomDataLabelEntity, 'id'>
                & { attributes?: Maybe<(
                  { __typename?: 'CustomDataLabel' }
                  & Pick<CustomDataLabel, 'label'>
                  & { type?: Maybe<(
                    { __typename?: 'DataLabelTypeEntityResponse' }
                    & { data?: Maybe<(
                      { __typename?: 'DataLabelTypeEntity' }
                      & Pick<DataLabelTypeEntity, 'id'>
                      & { attributes?: Maybe<(
                        { __typename?: 'DataLabelType' }
                        & Pick<DataLabelType, 'name' | 'has_options'>
                      )> }
                    )> }
                  )>, options?: Maybe<(
                    { __typename?: 'ProjectDataLabelTypeOptionRelationResponseCollection' }
                    & { data: Array<(
                      { __typename?: 'ProjectDataLabelTypeOptionEntity' }
                      & Pick<ProjectDataLabelTypeOptionEntity, 'id'>
                      & { attributes?: Maybe<(
                        { __typename?: 'ProjectDataLabelTypeOption' }
                        & Pick<ProjectDataLabelTypeOption, 'value'>
                      )> }
                    )> }
                  )> }
                )> }
              )> }
            )> }
          )> }
        )> }
      )> }
      & Task_DefinitionFragment
    )> }
  )>>> }
);

export type TermsAndConditionQueryVariables = Exact<{ [key: string]: never; }>;


export type TermsAndConditionQuery = (
  { __typename?: 'Query' }
  & { termsAndCondition?: Maybe<(
    { __typename?: 'TermsAndConditionEntityResponse' }
    & { data?: Maybe<(
      { __typename?: 'TermsAndConditionEntity' }
      & Pick<TermsAndConditionEntity, 'id'>
      & { attributes?: Maybe<(
        { __typename?: 'TermsAndCondition' }
        & { terms_pdf: (
          { __typename?: 'UploadFileEntityResponse' }
          & { data?: Maybe<(
            { __typename?: 'UploadFileEntity' }
            & Pick<UploadFileEntity, 'id'>
            & { attributes?: Maybe<(
              { __typename?: 'UploadFile' }
              & Pick<UploadFile, 'url'>
            )> }
          )> }
        ) }
      )> }
    )> }
  )> }
);

export const AppFragmentDoc = gql`
    fragment app on BaoverifierApp {
  status
  appVersion
  description
  updatedAt
  createdAt
}
    `;
export const CategoryFragmentDoc = gql`
    fragment category on Category {
  title
  description
}
    `;
export const CommunityFragmentDoc = gql`
    fragment community on Community {
  createdAt
  updatedAt
  name
  description
  chief_name
  location
}
    `;
export const ComponentCustomDataFieldsCheckboxFragmentDoc = gql`
    fragment componentCustomDataFieldsCheckbox on ComponentCustomDataFieldsCheckbox {
  id
  label
  isRequired
  option {
    id
    option
  }
}
    `;
export const ComponentCustomDataFieldsDataListFragmentDoc = gql`
    fragment componentCustomDataFieldsDataList on ComponentCustomDataFieldsDataList {
  id
  label
  isRequired
  listId
  option {
    id
    option
  }
}
    `;
export const ComponentCustomDataFieldsDateTimeFieldFragmentDoc = gql`
    fragment componentCustomDataFieldsDateTimeField on ComponentCustomDataFieldsDateTimeField {
  id
  label
  isRequired
  datetime
}
    `;
export const ComponentCustomDataFieldsEmailFieldFragmentDoc = gql`
    fragment componentCustomDataFieldsEmailField on ComponentCustomDataFieldsEmailField {
  id
  label
  isRequired
  email
}
    `;
export const UploadFileFragmentDoc = gql`
    fragment uploadFile on UploadFileEntity {
  id
  attributes {
    createdAt
    updatedAt
    name
    alternativeText
    caption
    size
    mime
    url
    provider
    width
    height
    formats
    hash
    ext
  }
}
    `;
export const ComponentCustomDataFieldsImageFieldFragmentDoc = gql`
    fragment componentCustomDataFieldsImageField on ComponentCustomDataFieldsImageField {
  id
  isRequired
  label
  imageUrls
  upload_state
  images {
    data {
      ...uploadFile
    }
  }
}
    ${UploadFileFragmentDoc}`;
export const ComponentCustomDataFieldsMetricsSpecificFragmentDoc = gql`
    fragment componentCustomDataFieldsMetricsSpecific on ComponentCustomDataFieldsMetricsSpecific {
  id
  label
  max
  min
  isRequired
  metric
  number_value
}
    `;
export const ComponentCustomDataFieldsNumberDropDownFragmentDoc = gql`
    fragment componentCustomDataFieldsNumberDropDown on ComponentCustomDataFieldsNumberDropDown {
  id
  label
  isRequired
  value
  max
  min
}
    `;
export const ComponentCustomDataFieldsNumberFieldFragmentDoc = gql`
    fragment componentCustomDataFieldsNumberField on ComponentCustomDataFieldsNumberField {
  id
  label
  max
  min
  number_field_value
  isRequired
}
    `;
export const ComponentCustomDataFieldsNumberRangeFragmentDoc = gql`
    fragment componentCustomDataFieldsNumberRange on ComponentCustomDataFieldsNumberRange {
  id
  label
  min
  isRequired
  max
}
    `;
export const ComponentCustomDataFieldsPercentageFragmentDoc = gql`
    fragment componentCustomDataFieldsPercentage on ComponentCustomDataFieldsPercentage {
  id
  label
  isRequired
  value
}
    `;
export const ComponentCustomDataFieldsPhoneNumberFieldFragmentDoc = gql`
    fragment componentCustomDataFieldsPhoneNumberField on ComponentCustomDataFieldsPhoneNumberField {
  id
  label
  isRequired
  phoneNumber
}
    `;
export const ComponentCustomDataFieldsRadioFragmentDoc = gql`
    fragment componentCustomDataFieldsRadio on ComponentCustomDataFieldsRadio {
  id
  label
  isRequired
  option {
    id
    option
  }
}
    `;
export const ComponentCustomDataFieldsRatingFragmentDoc = gql`
    fragment componentCustomDataFieldsRating on ComponentCustomDataFieldsRating {
  id
  label
  isRequired
  rating
  number_of_stars
}
    `;
export const ComponentCustomDataFieldsSelectFragmentDoc = gql`
    fragment componentCustomDataFieldsSelect on ComponentCustomDataFieldsSelect {
  id
  label
  isRequired
  option {
    id
    option
    __typename
  }
}
    `;
export const ComponentCustomDataFieldsTextFragmentDoc = gql`
    fragment componentCustomDataFieldsText on ComponentCustomDataFieldsText {
  id
  label
  text_value
  isRequired
}
    `;
export const DataListOptionFragmentDoc = gql`
    fragment dataListOption on DataListOption {
  createdAt
  status
  updatedAt
  value
  publishedAt
}
    `;
export const DataListsFragmentDoc = gql`
    fragment dataLists on DataList {
  name
  createdAt
  updatedAt
  status
  publishedAt
  updateKey
}
    `;
export const EvidenceFragmentDoc = gql`
    fragment evidence on Evidence {
  notes
  location
  createdAt
  updatedAt
  upload_state
  cancellationReason
  requestedInfo
}
    `;
export const NotificationFragmentDoc = gql`
    fragment notification on Notification {
  title
  message
  read
  status
  action
  type
  attachment {
    data {
      id
      attributes {
        url
        mime
        width
        height
      }
    }
  }
  nextScheduledNotificationDetails {
    id
    sendAt
    endAt
    recur
    status
    priority
  }
  createdAt
  updatedAt
  publishedAt
}
    `;
export const PaginationFragmentDoc = gql`
    fragment pagination on Pagination {
  total
  page
  pageSize
  pageCount
}
    `;
export const ProjectFragmentDoc = gql`
    fragment project on Project {
  breakdown
  name
  createdAt
  updatedAt
  collaborators
  reward
  status
  statement
  description
  outcomes
}
    `;
export const RoleFragmentDoc = gql`
    fragment role on UsersPermissionsRole {
  name
  description
  type
  createdAt
  updatedAt
}
    `;
export const TaskFragmentDoc = gql`
    fragment task on Task {
  createdAt
  updatedAt
  accepted_at
  status
  location
  task_origin
}
    `;
export const Task_DefinitionFragmentDoc = gql`
    fragment task_definition on TaskDefinition {
  status
  createdAt
  updatedAt
}
    `;
export const Task_TypeFragmentDoc = gql`
    fragment task_type on TaskType {
  title
  ER_ID
  photoEvidence
  documentedEvidence
  environmentalImpact
  socialImpact
  status
  createdAt
  updatedAt
  withComment
  photoRequired
}
    `;
export const UserFragmentDoc = gql`
    fragment user on UsersPermissionsUser {
  firstName
  lastName
  username
  idNumber
  phoneNumber
  email
  confirmed
  receiveAllTimeWeeklyStatusReport
  receiveLoginReminder
  receiveWeeklyStatusReport
  receiveProjectNotifications
  blocked
  camera_permission
  location_permission
  media_library_permission
  createdAt
  updatedAt
}
    `;
export const AcceptBaoriderTaskDocument = gql`
    mutation acceptBaoriderTask($id: ID!) {
  acceptBaoriderTask(id: $id) {
    id
    attributes {
      ...task
      baoleader {
        data {
          id
          attributes {
            ...user
            profilePicture {
              data {
                ...uploadFile
              }
            }
            baoleader {
              data {
                id
              }
            }
          }
        }
      }
      baorider {
        data {
          id
          attributes {
            ...user
            profilePicture {
              data {
                ...uploadFile
              }
            }
            baoleader {
              data {
                id
              }
            }
          }
        }
      }
      task_definition {
        data {
          id
          attributes {
            category {
              data {
                id
                attributes {
                  ...category
                }
              }
            }
            task_type {
              data {
                id
                attributes {
                  ...task_type
                }
              }
            }
          }
        }
      }
      project {
        data {
          id
          attributes {
            ...project
          }
        }
      }
    }
  }
}
    ${TaskFragmentDoc}
${UserFragmentDoc}
${UploadFileFragmentDoc}
${CategoryFragmentDoc}
${Task_TypeFragmentDoc}
${ProjectFragmentDoc}`;
export type AcceptBaoriderTaskMutationFn = ApolloReactCommon.MutationFunction<AcceptBaoriderTaskMutation, AcceptBaoriderTaskMutationVariables>;
export type AcceptBaoriderTaskComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AcceptBaoriderTaskMutation, AcceptBaoriderTaskMutationVariables>, 'mutation'>;

    export const AcceptBaoriderTaskComponent = (props: AcceptBaoriderTaskComponentProps) => (
      <ApolloReactComponents.Mutation<AcceptBaoriderTaskMutation, AcceptBaoriderTaskMutationVariables> mutation={AcceptBaoriderTaskDocument} {...props} />
    );
    
export type AcceptBaoriderTaskProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AcceptBaoriderTaskMutation, AcceptBaoriderTaskMutationVariables>
    } & TChildProps;
export function withAcceptBaoriderTask<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AcceptBaoriderTaskMutation,
  AcceptBaoriderTaskMutationVariables,
  AcceptBaoriderTaskProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AcceptBaoriderTaskMutation, AcceptBaoriderTaskMutationVariables, AcceptBaoriderTaskProps<TChildProps, TDataName>>(AcceptBaoriderTaskDocument, {
      alias: 'acceptBaoriderTask',
      ...operationOptions
    });
};

/**
 * __useAcceptBaoriderTaskMutation__
 *
 * To run a mutation, you first call `useAcceptBaoriderTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptBaoriderTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptBaoriderTaskMutation, { data, loading, error }] = useAcceptBaoriderTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcceptBaoriderTaskMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptBaoriderTaskMutation, AcceptBaoriderTaskMutationVariables>) {
        return ApolloReactHooks.useMutation<AcceptBaoriderTaskMutation, AcceptBaoriderTaskMutationVariables>(AcceptBaoriderTaskDocument, baseOptions);
      }
export type AcceptBaoriderTaskMutationHookResult = ReturnType<typeof useAcceptBaoriderTaskMutation>;
export type AcceptBaoriderTaskMutationResult = ApolloReactCommon.MutationResult<AcceptBaoriderTaskMutation>;
export type AcceptBaoriderTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<AcceptBaoriderTaskMutation, AcceptBaoriderTaskMutationVariables>;
export const ChangeMyPasswordDocument = gql`
    mutation changeMyPassword($password: String!, $passwordNew: String!, $passwordConfirmation: String!) {
  changeMyPassword(
    password: $password
    passwordNew: $passwordNew
    passwordConfirmation: $passwordConfirmation
  ) {
    id
  }
}
    `;
export type ChangeMyPasswordMutationFn = ApolloReactCommon.MutationFunction<ChangeMyPasswordMutation, ChangeMyPasswordMutationVariables>;
export type ChangeMyPasswordComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ChangeMyPasswordMutation, ChangeMyPasswordMutationVariables>, 'mutation'>;

    export const ChangeMyPasswordComponent = (props: ChangeMyPasswordComponentProps) => (
      <ApolloReactComponents.Mutation<ChangeMyPasswordMutation, ChangeMyPasswordMutationVariables> mutation={ChangeMyPasswordDocument} {...props} />
    );
    
export type ChangeMyPasswordProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ChangeMyPasswordMutation, ChangeMyPasswordMutationVariables>
    } & TChildProps;
export function withChangeMyPassword<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ChangeMyPasswordMutation,
  ChangeMyPasswordMutationVariables,
  ChangeMyPasswordProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ChangeMyPasswordMutation, ChangeMyPasswordMutationVariables, ChangeMyPasswordProps<TChildProps, TDataName>>(ChangeMyPasswordDocument, {
      alias: 'changeMyPassword',
      ...operationOptions
    });
};

/**
 * __useChangeMyPasswordMutation__
 *
 * To run a mutation, you first call `useChangeMyPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeMyPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeMyPasswordMutation, { data, loading, error }] = useChangeMyPasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *      passwordNew: // value for 'passwordNew'
 *      passwordConfirmation: // value for 'passwordConfirmation'
 *   },
 * });
 */
export function useChangeMyPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChangeMyPasswordMutation, ChangeMyPasswordMutationVariables>) {
        return ApolloReactHooks.useMutation<ChangeMyPasswordMutation, ChangeMyPasswordMutationVariables>(ChangeMyPasswordDocument, baseOptions);
      }
export type ChangeMyPasswordMutationHookResult = ReturnType<typeof useChangeMyPasswordMutation>;
export type ChangeMyPasswordMutationResult = ApolloReactCommon.MutationResult<ChangeMyPasswordMutation>;
export type ChangeMyPasswordMutationOptions = ApolloReactCommon.BaseMutationOptions<ChangeMyPasswordMutation, ChangeMyPasswordMutationVariables>;
export const CreateBaoverifierFullTaskDocument = gql`
    mutation createBaoverifierFullTask($task: TaskInput, $evidence: EvidenceInputType, $taskEdited: String) {
  createBaoverifierFullTask(
    task: $task
    evidence: $evidence
    taskEdited: $taskEdited
  ) {
    task {
      id
    }
    evidence {
      id
      attributes {
        ...evidence
        custom_data_fields {
          ...componentCustomDataFieldsMetricsSpecific
          ...componentCustomDataFieldsNumberRange
          ...componentCustomDataFieldsNumberDropDown
          ...componentCustomDataFieldsPercentage
          ...componentCustomDataFieldsRadio
          ...componentCustomDataFieldsText
          ...componentCustomDataFieldsImageField
          ...componentCustomDataFieldsDataList
          ...componentCustomDataFieldsCheckbox
          ...componentCustomDataFieldsSelect
          ...componentCustomDataFieldsPercentage
          ...componentCustomDataFieldsRating
          ...componentCustomDataFieldsNumberField
          ...componentCustomDataFieldsDateTimeField
          ...componentCustomDataFieldsPhoneNumberField
          ...componentCustomDataFieldsEmailField
          __typename
        }
      }
    }
  }
}
    ${EvidenceFragmentDoc}
${ComponentCustomDataFieldsMetricsSpecificFragmentDoc}
${ComponentCustomDataFieldsNumberRangeFragmentDoc}
${ComponentCustomDataFieldsNumberDropDownFragmentDoc}
${ComponentCustomDataFieldsPercentageFragmentDoc}
${ComponentCustomDataFieldsRadioFragmentDoc}
${ComponentCustomDataFieldsTextFragmentDoc}
${ComponentCustomDataFieldsImageFieldFragmentDoc}
${ComponentCustomDataFieldsDataListFragmentDoc}
${ComponentCustomDataFieldsCheckboxFragmentDoc}
${ComponentCustomDataFieldsSelectFragmentDoc}
${ComponentCustomDataFieldsRatingFragmentDoc}
${ComponentCustomDataFieldsNumberFieldFragmentDoc}
${ComponentCustomDataFieldsDateTimeFieldFragmentDoc}
${ComponentCustomDataFieldsPhoneNumberFieldFragmentDoc}
${ComponentCustomDataFieldsEmailFieldFragmentDoc}`;
export type CreateBaoverifierFullTaskMutationFn = ApolloReactCommon.MutationFunction<CreateBaoverifierFullTaskMutation, CreateBaoverifierFullTaskMutationVariables>;
export type CreateBaoverifierFullTaskComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateBaoverifierFullTaskMutation, CreateBaoverifierFullTaskMutationVariables>, 'mutation'>;

    export const CreateBaoverifierFullTaskComponent = (props: CreateBaoverifierFullTaskComponentProps) => (
      <ApolloReactComponents.Mutation<CreateBaoverifierFullTaskMutation, CreateBaoverifierFullTaskMutationVariables> mutation={CreateBaoverifierFullTaskDocument} {...props} />
    );
    
export type CreateBaoverifierFullTaskProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateBaoverifierFullTaskMutation, CreateBaoverifierFullTaskMutationVariables>
    } & TChildProps;
export function withCreateBaoverifierFullTask<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateBaoverifierFullTaskMutation,
  CreateBaoverifierFullTaskMutationVariables,
  CreateBaoverifierFullTaskProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateBaoverifierFullTaskMutation, CreateBaoverifierFullTaskMutationVariables, CreateBaoverifierFullTaskProps<TChildProps, TDataName>>(CreateBaoverifierFullTaskDocument, {
      alias: 'createBaoverifierFullTask',
      ...operationOptions
    });
};

/**
 * __useCreateBaoverifierFullTaskMutation__
 *
 * To run a mutation, you first call `useCreateBaoverifierFullTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBaoverifierFullTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBaoverifierFullTaskMutation, { data, loading, error }] = useCreateBaoverifierFullTaskMutation({
 *   variables: {
 *      task: // value for 'task'
 *      evidence: // value for 'evidence'
 *      taskEdited: // value for 'taskEdited'
 *   },
 * });
 */
export function useCreateBaoverifierFullTaskMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBaoverifierFullTaskMutation, CreateBaoverifierFullTaskMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateBaoverifierFullTaskMutation, CreateBaoverifierFullTaskMutationVariables>(CreateBaoverifierFullTaskDocument, baseOptions);
      }
export type CreateBaoverifierFullTaskMutationHookResult = ReturnType<typeof useCreateBaoverifierFullTaskMutation>;
export type CreateBaoverifierFullTaskMutationResult = ApolloReactCommon.MutationResult<CreateBaoverifierFullTaskMutation>;
export type CreateBaoverifierFullTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateBaoverifierFullTaskMutation, CreateBaoverifierFullTaskMutationVariables>;
export const CreateBaoverifierFullTaskFromDesktopDocument = gql`
    mutation createBaoverifierFullTaskFromDesktop($task: TaskInput, $evidence: EvidenceInputType, $taskEdited: String) {
  createBaoverifierFullTaskFromDesktop(
    task: $task
    evidence: $evidence
    taskEdited: $taskEdited
  ) {
    task {
      id
    }
    evidence {
      id
      attributes {
        ...evidence
        custom_data_fields {
          ...componentCustomDataFieldsMetricsSpecific
          ...componentCustomDataFieldsNumberRange
          ...componentCustomDataFieldsNumberDropDown
          ...componentCustomDataFieldsPercentage
          ...componentCustomDataFieldsRadio
          ...componentCustomDataFieldsText
          ...componentCustomDataFieldsImageField
          ...componentCustomDataFieldsDataList
          ...componentCustomDataFieldsCheckbox
          ...componentCustomDataFieldsSelect
          ...componentCustomDataFieldsPercentage
          ...componentCustomDataFieldsRating
          ...componentCustomDataFieldsNumberField
          ...componentCustomDataFieldsDateTimeField
          ...componentCustomDataFieldsPhoneNumberField
          ...componentCustomDataFieldsEmailField
          __typename
        }
      }
    }
  }
}
    ${EvidenceFragmentDoc}
${ComponentCustomDataFieldsMetricsSpecificFragmentDoc}
${ComponentCustomDataFieldsNumberRangeFragmentDoc}
${ComponentCustomDataFieldsNumberDropDownFragmentDoc}
${ComponentCustomDataFieldsPercentageFragmentDoc}
${ComponentCustomDataFieldsRadioFragmentDoc}
${ComponentCustomDataFieldsTextFragmentDoc}
${ComponentCustomDataFieldsImageFieldFragmentDoc}
${ComponentCustomDataFieldsDataListFragmentDoc}
${ComponentCustomDataFieldsCheckboxFragmentDoc}
${ComponentCustomDataFieldsSelectFragmentDoc}
${ComponentCustomDataFieldsRatingFragmentDoc}
${ComponentCustomDataFieldsNumberFieldFragmentDoc}
${ComponentCustomDataFieldsDateTimeFieldFragmentDoc}
${ComponentCustomDataFieldsPhoneNumberFieldFragmentDoc}
${ComponentCustomDataFieldsEmailFieldFragmentDoc}`;
export type CreateBaoverifierFullTaskFromDesktopMutationFn = ApolloReactCommon.MutationFunction<CreateBaoverifierFullTaskFromDesktopMutation, CreateBaoverifierFullTaskFromDesktopMutationVariables>;
export type CreateBaoverifierFullTaskFromDesktopComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateBaoverifierFullTaskFromDesktopMutation, CreateBaoverifierFullTaskFromDesktopMutationVariables>, 'mutation'>;

    export const CreateBaoverifierFullTaskFromDesktopComponent = (props: CreateBaoverifierFullTaskFromDesktopComponentProps) => (
      <ApolloReactComponents.Mutation<CreateBaoverifierFullTaskFromDesktopMutation, CreateBaoverifierFullTaskFromDesktopMutationVariables> mutation={CreateBaoverifierFullTaskFromDesktopDocument} {...props} />
    );
    
export type CreateBaoverifierFullTaskFromDesktopProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateBaoverifierFullTaskFromDesktopMutation, CreateBaoverifierFullTaskFromDesktopMutationVariables>
    } & TChildProps;
export function withCreateBaoverifierFullTaskFromDesktop<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateBaoverifierFullTaskFromDesktopMutation,
  CreateBaoverifierFullTaskFromDesktopMutationVariables,
  CreateBaoverifierFullTaskFromDesktopProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateBaoverifierFullTaskFromDesktopMutation, CreateBaoverifierFullTaskFromDesktopMutationVariables, CreateBaoverifierFullTaskFromDesktopProps<TChildProps, TDataName>>(CreateBaoverifierFullTaskFromDesktopDocument, {
      alias: 'createBaoverifierFullTaskFromDesktop',
      ...operationOptions
    });
};

/**
 * __useCreateBaoverifierFullTaskFromDesktopMutation__
 *
 * To run a mutation, you first call `useCreateBaoverifierFullTaskFromDesktopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBaoverifierFullTaskFromDesktopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBaoverifierFullTaskFromDesktopMutation, { data, loading, error }] = useCreateBaoverifierFullTaskFromDesktopMutation({
 *   variables: {
 *      task: // value for 'task'
 *      evidence: // value for 'evidence'
 *      taskEdited: // value for 'taskEdited'
 *   },
 * });
 */
export function useCreateBaoverifierFullTaskFromDesktopMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBaoverifierFullTaskFromDesktopMutation, CreateBaoverifierFullTaskFromDesktopMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateBaoverifierFullTaskFromDesktopMutation, CreateBaoverifierFullTaskFromDesktopMutationVariables>(CreateBaoverifierFullTaskFromDesktopDocument, baseOptions);
      }
export type CreateBaoverifierFullTaskFromDesktopMutationHookResult = ReturnType<typeof useCreateBaoverifierFullTaskFromDesktopMutation>;
export type CreateBaoverifierFullTaskFromDesktopMutationResult = ApolloReactCommon.MutationResult<CreateBaoverifierFullTaskFromDesktopMutation>;
export type CreateBaoverifierFullTaskFromDesktopMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateBaoverifierFullTaskFromDesktopMutation, CreateBaoverifierFullTaskFromDesktopMutationVariables>;
export const CreateDataLabelValueDocument = gql`
    mutation createDataLabelValue($input: TaskDataLabelValueInput) {
  createDataLabelValue(input: $input) {
    value
  }
}
    `;
export type CreateDataLabelValueMutationFn = ApolloReactCommon.MutationFunction<CreateDataLabelValueMutation, CreateDataLabelValueMutationVariables>;
export type CreateDataLabelValueComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateDataLabelValueMutation, CreateDataLabelValueMutationVariables>, 'mutation'>;

    export const CreateDataLabelValueComponent = (props: CreateDataLabelValueComponentProps) => (
      <ApolloReactComponents.Mutation<CreateDataLabelValueMutation, CreateDataLabelValueMutationVariables> mutation={CreateDataLabelValueDocument} {...props} />
    );
    
export type CreateDataLabelValueProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateDataLabelValueMutation, CreateDataLabelValueMutationVariables>
    } & TChildProps;
export function withCreateDataLabelValue<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateDataLabelValueMutation,
  CreateDataLabelValueMutationVariables,
  CreateDataLabelValueProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateDataLabelValueMutation, CreateDataLabelValueMutationVariables, CreateDataLabelValueProps<TChildProps, TDataName>>(CreateDataLabelValueDocument, {
      alias: 'createDataLabelValue',
      ...operationOptions
    });
};

/**
 * __useCreateDataLabelValueMutation__
 *
 * To run a mutation, you first call `useCreateDataLabelValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDataLabelValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDataLabelValueMutation, { data, loading, error }] = useCreateDataLabelValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDataLabelValueMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDataLabelValueMutation, CreateDataLabelValueMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateDataLabelValueMutation, CreateDataLabelValueMutationVariables>(CreateDataLabelValueDocument, baseOptions);
      }
export type CreateDataLabelValueMutationHookResult = ReturnType<typeof useCreateDataLabelValueMutation>;
export type CreateDataLabelValueMutationResult = ApolloReactCommon.MutationResult<CreateDataLabelValueMutation>;
export type CreateDataLabelValueMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateDataLabelValueMutation, CreateDataLabelValueMutationVariables>;
export const CreateEvidenceDocument = gql`
    mutation createEvidence($input: EvidenceInput, $dataLabelValues: JSON) {
  createBaoriderEvidence(input: $input, dataLabelValuesArr: $dataLabelValues) {
    id
  }
}
    `;
export type CreateEvidenceMutationFn = ApolloReactCommon.MutationFunction<CreateEvidenceMutation, CreateEvidenceMutationVariables>;
export type CreateEvidenceComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateEvidenceMutation, CreateEvidenceMutationVariables>, 'mutation'>;

    export const CreateEvidenceComponent = (props: CreateEvidenceComponentProps) => (
      <ApolloReactComponents.Mutation<CreateEvidenceMutation, CreateEvidenceMutationVariables> mutation={CreateEvidenceDocument} {...props} />
    );
    
export type CreateEvidenceProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateEvidenceMutation, CreateEvidenceMutationVariables>
    } & TChildProps;
export function withCreateEvidence<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateEvidenceMutation,
  CreateEvidenceMutationVariables,
  CreateEvidenceProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateEvidenceMutation, CreateEvidenceMutationVariables, CreateEvidenceProps<TChildProps, TDataName>>(CreateEvidenceDocument, {
      alias: 'createEvidence',
      ...operationOptions
    });
};

/**
 * __useCreateEvidenceMutation__
 *
 * To run a mutation, you first call `useCreateEvidenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEvidenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEvidenceMutation, { data, loading, error }] = useCreateEvidenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *      dataLabelValues: // value for 'dataLabelValues'
 *   },
 * });
 */
export function useCreateEvidenceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateEvidenceMutation, CreateEvidenceMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateEvidenceMutation, CreateEvidenceMutationVariables>(CreateEvidenceDocument, baseOptions);
      }
export type CreateEvidenceMutationHookResult = ReturnType<typeof useCreateEvidenceMutation>;
export type CreateEvidenceMutationResult = ApolloReactCommon.MutationResult<CreateEvidenceMutation>;
export type CreateEvidenceMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateEvidenceMutation, CreateEvidenceMutationVariables>;
export const CreateTaskDocument = gql`
    mutation createTask($input: TaskInput) {
  createBaoverifierTask(input: $input) {
    id
  }
}
    `;
export type CreateTaskMutationFn = ApolloReactCommon.MutationFunction<CreateTaskMutation, CreateTaskMutationVariables>;
export type CreateTaskComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateTaskMutation, CreateTaskMutationVariables>, 'mutation'>;

    export const CreateTaskComponent = (props: CreateTaskComponentProps) => (
      <ApolloReactComponents.Mutation<CreateTaskMutation, CreateTaskMutationVariables> mutation={CreateTaskDocument} {...props} />
    );
    
export type CreateTaskProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateTaskMutation, CreateTaskMutationVariables>
    } & TChildProps;
export function withCreateTask<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateTaskMutation,
  CreateTaskMutationVariables,
  CreateTaskProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateTaskMutation, CreateTaskMutationVariables, CreateTaskProps<TChildProps, TDataName>>(CreateTaskDocument, {
      alias: 'createTask',
      ...operationOptions
    });
};

/**
 * __useCreateTaskMutation__
 *
 * To run a mutation, you first call `useCreateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskMutation, { data, loading, error }] = useCreateTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaskMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTaskMutation, CreateTaskMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateTaskMutation, CreateTaskMutationVariables>(CreateTaskDocument, baseOptions);
      }
export type CreateTaskMutationHookResult = ReturnType<typeof useCreateTaskMutation>;
export type CreateTaskMutationResult = ApolloReactCommon.MutationResult<CreateTaskMutation>;
export type CreateTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateTaskMutation, CreateTaskMutationVariables>;
export const MarkNotificationAsReadDocument = gql`
    mutation markNotificationAsRead($id: ID!) {
  markDataCollectorNotificationAsRead(id: $id) {
    id
  }
}
    `;
export type MarkNotificationAsReadMutationFn = ApolloReactCommon.MutationFunction<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;
export type MarkNotificationAsReadComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>, 'mutation'>;

    export const MarkNotificationAsReadComponent = (props: MarkNotificationAsReadComponentProps) => (
      <ApolloReactComponents.Mutation<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables> mutation={MarkNotificationAsReadDocument} {...props} />
    );
    
export type MarkNotificationAsReadProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>
    } & TChildProps;
export function withMarkNotificationAsRead<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MarkNotificationAsReadMutation,
  MarkNotificationAsReadMutationVariables,
  MarkNotificationAsReadProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables, MarkNotificationAsReadProps<TChildProps, TDataName>>(MarkNotificationAsReadDocument, {
      alias: 'markNotificationAsRead',
      ...operationOptions
    });
};

/**
 * __useMarkNotificationAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationAsReadMutation, { data, loading, error }] = useMarkNotificationAsReadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkNotificationAsReadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>) {
        return ApolloReactHooks.useMutation<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>(MarkNotificationAsReadDocument, baseOptions);
      }
export type MarkNotificationAsReadMutationHookResult = ReturnType<typeof useMarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationResult = ApolloReactCommon.MutationResult<MarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationOptions = ApolloReactCommon.BaseMutationOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;
export const MarkNotificationAsReceivedDocument = gql`
    mutation markNotificationAsReceived($notificationId: ID!) {
  markNotificationAsReceived(notificationId: $notificationId) {
    id
  }
}
    `;
export type MarkNotificationAsReceivedMutationFn = ApolloReactCommon.MutationFunction<MarkNotificationAsReceivedMutation, MarkNotificationAsReceivedMutationVariables>;
export type MarkNotificationAsReceivedComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<MarkNotificationAsReceivedMutation, MarkNotificationAsReceivedMutationVariables>, 'mutation'>;

    export const MarkNotificationAsReceivedComponent = (props: MarkNotificationAsReceivedComponentProps) => (
      <ApolloReactComponents.Mutation<MarkNotificationAsReceivedMutation, MarkNotificationAsReceivedMutationVariables> mutation={MarkNotificationAsReceivedDocument} {...props} />
    );
    
export type MarkNotificationAsReceivedProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<MarkNotificationAsReceivedMutation, MarkNotificationAsReceivedMutationVariables>
    } & TChildProps;
export function withMarkNotificationAsReceived<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MarkNotificationAsReceivedMutation,
  MarkNotificationAsReceivedMutationVariables,
  MarkNotificationAsReceivedProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, MarkNotificationAsReceivedMutation, MarkNotificationAsReceivedMutationVariables, MarkNotificationAsReceivedProps<TChildProps, TDataName>>(MarkNotificationAsReceivedDocument, {
      alias: 'markNotificationAsReceived',
      ...operationOptions
    });
};

/**
 * __useMarkNotificationAsReceivedMutation__
 *
 * To run a mutation, you first call `useMarkNotificationAsReceivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationAsReceivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationAsReceivedMutation, { data, loading, error }] = useMarkNotificationAsReceivedMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useMarkNotificationAsReceivedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkNotificationAsReceivedMutation, MarkNotificationAsReceivedMutationVariables>) {
        return ApolloReactHooks.useMutation<MarkNotificationAsReceivedMutation, MarkNotificationAsReceivedMutationVariables>(MarkNotificationAsReceivedDocument, baseOptions);
      }
export type MarkNotificationAsReceivedMutationHookResult = ReturnType<typeof useMarkNotificationAsReceivedMutation>;
export type MarkNotificationAsReceivedMutationResult = ApolloReactCommon.MutationResult<MarkNotificationAsReceivedMutation>;
export type MarkNotificationAsReceivedMutationOptions = ApolloReactCommon.BaseMutationOptions<MarkNotificationAsReceivedMutation, MarkNotificationAsReceivedMutationVariables>;
export const SuggestCommunityMemberDocument = gql`
    mutation suggestCommunityMember($input: SuggestCommunityMembersInput) {
  suggestCommunityMember(input: $input) {
    member {
      id
    }
  }
}
    `;
export type SuggestCommunityMemberMutationFn = ApolloReactCommon.MutationFunction<SuggestCommunityMemberMutation, SuggestCommunityMemberMutationVariables>;
export type SuggestCommunityMemberComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SuggestCommunityMemberMutation, SuggestCommunityMemberMutationVariables>, 'mutation'>;

    export const SuggestCommunityMemberComponent = (props: SuggestCommunityMemberComponentProps) => (
      <ApolloReactComponents.Mutation<SuggestCommunityMemberMutation, SuggestCommunityMemberMutationVariables> mutation={SuggestCommunityMemberDocument} {...props} />
    );
    
export type SuggestCommunityMemberProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<SuggestCommunityMemberMutation, SuggestCommunityMemberMutationVariables>
    } & TChildProps;
export function withSuggestCommunityMember<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SuggestCommunityMemberMutation,
  SuggestCommunityMemberMutationVariables,
  SuggestCommunityMemberProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, SuggestCommunityMemberMutation, SuggestCommunityMemberMutationVariables, SuggestCommunityMemberProps<TChildProps, TDataName>>(SuggestCommunityMemberDocument, {
      alias: 'suggestCommunityMember',
      ...operationOptions
    });
};

/**
 * __useSuggestCommunityMemberMutation__
 *
 * To run a mutation, you first call `useSuggestCommunityMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuggestCommunityMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suggestCommunityMemberMutation, { data, loading, error }] = useSuggestCommunityMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuggestCommunityMemberMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SuggestCommunityMemberMutation, SuggestCommunityMemberMutationVariables>) {
        return ApolloReactHooks.useMutation<SuggestCommunityMemberMutation, SuggestCommunityMemberMutationVariables>(SuggestCommunityMemberDocument, baseOptions);
      }
export type SuggestCommunityMemberMutationHookResult = ReturnType<typeof useSuggestCommunityMemberMutation>;
export type SuggestCommunityMemberMutationResult = ApolloReactCommon.MutationResult<SuggestCommunityMemberMutation>;
export type SuggestCommunityMemberMutationOptions = ApolloReactCommon.BaseMutationOptions<SuggestCommunityMemberMutation, SuggestCommunityMemberMutationVariables>;
export const UpdateTaskDocument = gql`
    mutation updateTask($id: ID!, $input: TaskInput) {
  updateBaoriderTask(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateTaskMutationFn = ApolloReactCommon.MutationFunction<UpdateTaskMutation, UpdateTaskMutationVariables>;
export type UpdateTaskComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateTaskMutation, UpdateTaskMutationVariables>, 'mutation'>;

    export const UpdateTaskComponent = (props: UpdateTaskComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateTaskMutation, UpdateTaskMutationVariables> mutation={UpdateTaskDocument} {...props} />
    );
    
export type UpdateTaskProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateTaskMutation, UpdateTaskMutationVariables>
    } & TChildProps;
export function withUpdateTask<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateTaskMutation,
  UpdateTaskMutationVariables,
  UpdateTaskProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateTaskMutation, UpdateTaskMutationVariables, UpdateTaskProps<TChildProps, TDataName>>(UpdateTaskDocument, {
      alias: 'updateTask',
      ...operationOptions
    });
};

/**
 * __useUpdateTaskMutation__
 *
 * To run a mutation, you first call `useUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskMutation, { data, loading, error }] = useUpdateTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTaskMutation, UpdateTaskMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateTaskMutation, UpdateTaskMutationVariables>(UpdateTaskDocument, baseOptions);
      }
export type UpdateTaskMutationHookResult = ReturnType<typeof useUpdateTaskMutation>;
export type UpdateTaskMutationResult = ApolloReactCommon.MutationResult<UpdateTaskMutation>;
export type UpdateTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTaskMutation, UpdateTaskMutationVariables>;
export const UpdateEvidenceDocument = gql`
    mutation updateEvidence($id: ID!, $input: EvidenceInput) {
  updateBaoriderEvidence(id: $id, input: $input) {
    notes
  }
}
    `;
export type UpdateEvidenceMutationFn = ApolloReactCommon.MutationFunction<UpdateEvidenceMutation, UpdateEvidenceMutationVariables>;
export type UpdateEvidenceComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateEvidenceMutation, UpdateEvidenceMutationVariables>, 'mutation'>;

    export const UpdateEvidenceComponent = (props: UpdateEvidenceComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateEvidenceMutation, UpdateEvidenceMutationVariables> mutation={UpdateEvidenceDocument} {...props} />
    );
    
export type UpdateEvidenceProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateEvidenceMutation, UpdateEvidenceMutationVariables>
    } & TChildProps;
export function withUpdateEvidence<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateEvidenceMutation,
  UpdateEvidenceMutationVariables,
  UpdateEvidenceProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateEvidenceMutation, UpdateEvidenceMutationVariables, UpdateEvidenceProps<TChildProps, TDataName>>(UpdateEvidenceDocument, {
      alias: 'updateEvidence',
      ...operationOptions
    });
};

/**
 * __useUpdateEvidenceMutation__
 *
 * To run a mutation, you first call `useUpdateEvidenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEvidenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEvidenceMutation, { data, loading, error }] = useUpdateEvidenceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEvidenceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEvidenceMutation, UpdateEvidenceMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateEvidenceMutation, UpdateEvidenceMutationVariables>(UpdateEvidenceDocument, baseOptions);
      }
export type UpdateEvidenceMutationHookResult = ReturnType<typeof useUpdateEvidenceMutation>;
export type UpdateEvidenceMutationResult = ApolloReactCommon.MutationResult<UpdateEvidenceMutation>;
export type UpdateEvidenceMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateEvidenceMutation, UpdateEvidenceMutationVariables>;
export const UpdateMyUserDocument = gql`
    mutation updateMyUser($input: updateMyUserInput) {
  updateMyUser(input: $input) {
    id
    attributes {
      ...user
      role {
        data {
          id
          attributes {
            ...role
          }
        }
      }
      onboarding
      pushToken
      profilePicture {
        data {
          ...uploadFile
        }
      }
    }
  }
}
    ${UserFragmentDoc}
${RoleFragmentDoc}
${UploadFileFragmentDoc}`;
export type UpdateMyUserMutationFn = ApolloReactCommon.MutationFunction<UpdateMyUserMutation, UpdateMyUserMutationVariables>;
export type UpdateMyUserComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateMyUserMutation, UpdateMyUserMutationVariables>, 'mutation'>;

    export const UpdateMyUserComponent = (props: UpdateMyUserComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateMyUserMutation, UpdateMyUserMutationVariables> mutation={UpdateMyUserDocument} {...props} />
    );
    
export type UpdateMyUserProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateMyUserMutation, UpdateMyUserMutationVariables>
    } & TChildProps;
export function withUpdateMyUser<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateMyUserMutation,
  UpdateMyUserMutationVariables,
  UpdateMyUserProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateMyUserMutation, UpdateMyUserMutationVariables, UpdateMyUserProps<TChildProps, TDataName>>(UpdateMyUserDocument, {
      alias: 'updateMyUser',
      ...operationOptions
    });
};

/**
 * __useUpdateMyUserMutation__
 *
 * To run a mutation, you first call `useUpdateMyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyUserMutation, { data, loading, error }] = useUpdateMyUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMyUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMyUserMutation, UpdateMyUserMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateMyUserMutation, UpdateMyUserMutationVariables>(UpdateMyUserDocument, baseOptions);
      }
export type UpdateMyUserMutationHookResult = ReturnType<typeof useUpdateMyUserMutation>;
export type UpdateMyUserMutationResult = ApolloReactCommon.MutationResult<UpdateMyUserMutation>;
export type UpdateMyUserMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateMyUserMutation, UpdateMyUserMutationVariables>;
export const VerifyDatacollectOtpDocument = gql`
    mutation verifyDatacollectOtp($code: String!, $otp: String!) {
  verifyDatacollectOtp(code: $code, otp: $otp) {
    valid
    code
  }
}
    `;
export type VerifyDatacollectOtpMutationFn = ApolloReactCommon.MutationFunction<VerifyDatacollectOtpMutation, VerifyDatacollectOtpMutationVariables>;
export type VerifyDatacollectOtpComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<VerifyDatacollectOtpMutation, VerifyDatacollectOtpMutationVariables>, 'mutation'>;

    export const VerifyDatacollectOtpComponent = (props: VerifyDatacollectOtpComponentProps) => (
      <ApolloReactComponents.Mutation<VerifyDatacollectOtpMutation, VerifyDatacollectOtpMutationVariables> mutation={VerifyDatacollectOtpDocument} {...props} />
    );
    
export type VerifyDatacollectOtpProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<VerifyDatacollectOtpMutation, VerifyDatacollectOtpMutationVariables>
    } & TChildProps;
export function withVerifyDatacollectOtp<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  VerifyDatacollectOtpMutation,
  VerifyDatacollectOtpMutationVariables,
  VerifyDatacollectOtpProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, VerifyDatacollectOtpMutation, VerifyDatacollectOtpMutationVariables, VerifyDatacollectOtpProps<TChildProps, TDataName>>(VerifyDatacollectOtpDocument, {
      alias: 'verifyDatacollectOtp',
      ...operationOptions
    });
};

/**
 * __useVerifyDatacollectOtpMutation__
 *
 * To run a mutation, you first call `useVerifyDatacollectOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyDatacollectOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyDatacollectOtpMutation, { data, loading, error }] = useVerifyDatacollectOtpMutation({
 *   variables: {
 *      code: // value for 'code'
 *      otp: // value for 'otp'
 *   },
 * });
 */
export function useVerifyDatacollectOtpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VerifyDatacollectOtpMutation, VerifyDatacollectOtpMutationVariables>) {
        return ApolloReactHooks.useMutation<VerifyDatacollectOtpMutation, VerifyDatacollectOtpMutationVariables>(VerifyDatacollectOtpDocument, baseOptions);
      }
export type VerifyDatacollectOtpMutationHookResult = ReturnType<typeof useVerifyDatacollectOtpMutation>;
export type VerifyDatacollectOtpMutationResult = ApolloReactCommon.MutationResult<VerifyDatacollectOtpMutation>;
export type VerifyDatacollectOtpMutationOptions = ApolloReactCommon.BaseMutationOptions<VerifyDatacollectOtpMutation, VerifyDatacollectOtpMutationVariables>;
export const BaoverifierAppDocument = gql`
    query BaoverifierApp {
  baoverifierApp {
    data {
      id
      attributes {
        ...app
      }
    }
  }
}
    ${AppFragmentDoc}`;
export type BaoverifierAppComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BaoverifierAppQuery, BaoverifierAppQueryVariables>, 'query'>;

    export const BaoverifierAppComponent = (props: BaoverifierAppComponentProps) => (
      <ApolloReactComponents.Query<BaoverifierAppQuery, BaoverifierAppQueryVariables> query={BaoverifierAppDocument} {...props} />
    );
    
export type BaoverifierAppProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<BaoverifierAppQuery, BaoverifierAppQueryVariables>
    } & TChildProps;
export function withBaoverifierApp<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BaoverifierAppQuery,
  BaoverifierAppQueryVariables,
  BaoverifierAppProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, BaoverifierAppQuery, BaoverifierAppQueryVariables, BaoverifierAppProps<TChildProps, TDataName>>(BaoverifierAppDocument, {
      alias: 'baoverifierApp',
      ...operationOptions
    });
};

/**
 * __useBaoverifierAppQuery__
 *
 * To run a query within a React component, call `useBaoverifierAppQuery` and pass it any options that fit your needs.
 * When your component renders, `useBaoverifierAppQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBaoverifierAppQuery({
 *   variables: {
 *   },
 * });
 */
export function useBaoverifierAppQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BaoverifierAppQuery, BaoverifierAppQueryVariables>) {
        return ApolloReactHooks.useQuery<BaoverifierAppQuery, BaoverifierAppQueryVariables>(BaoverifierAppDocument, baseOptions);
      }
export function useBaoverifierAppLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BaoverifierAppQuery, BaoverifierAppQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<BaoverifierAppQuery, BaoverifierAppQueryVariables>(BaoverifierAppDocument, baseOptions);
        }
export type BaoverifierAppQueryHookResult = ReturnType<typeof useBaoverifierAppQuery>;
export type BaoverifierAppLazyQueryHookResult = ReturnType<typeof useBaoverifierAppLazyQuery>;
export type BaoverifierAppQueryResult = ApolloReactCommon.QueryResult<BaoverifierAppQuery, BaoverifierAppQueryVariables>;
export const CanEditTaskDocument = gql`
    query canEditTask($id: ID!) {
  canEditTask(id: $id)
}
    `;
export type CanEditTaskComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CanEditTaskQuery, CanEditTaskQueryVariables>, 'query'> & ({ variables: CanEditTaskQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CanEditTaskComponent = (props: CanEditTaskComponentProps) => (
      <ApolloReactComponents.Query<CanEditTaskQuery, CanEditTaskQueryVariables> query={CanEditTaskDocument} {...props} />
    );
    
export type CanEditTaskProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CanEditTaskQuery, CanEditTaskQueryVariables>
    } & TChildProps;
export function withCanEditTask<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CanEditTaskQuery,
  CanEditTaskQueryVariables,
  CanEditTaskProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CanEditTaskQuery, CanEditTaskQueryVariables, CanEditTaskProps<TChildProps, TDataName>>(CanEditTaskDocument, {
      alias: 'canEditTask',
      ...operationOptions
    });
};

/**
 * __useCanEditTaskQuery__
 *
 * To run a query within a React component, call `useCanEditTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanEditTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanEditTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCanEditTaskQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CanEditTaskQuery, CanEditTaskQueryVariables>) {
        return ApolloReactHooks.useQuery<CanEditTaskQuery, CanEditTaskQueryVariables>(CanEditTaskDocument, baseOptions);
      }
export function useCanEditTaskLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CanEditTaskQuery, CanEditTaskQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CanEditTaskQuery, CanEditTaskQueryVariables>(CanEditTaskDocument, baseOptions);
        }
export type CanEditTaskQueryHookResult = ReturnType<typeof useCanEditTaskQuery>;
export type CanEditTaskLazyQueryHookResult = ReturnType<typeof useCanEditTaskLazyQuery>;
export type CanEditTaskQueryResult = ApolloReactCommon.QueryResult<CanEditTaskQuery, CanEditTaskQueryVariables>;
export const FindDataListOptionWithCountDocument = gql`
    query findDataListOptionWithCount($orderBy: JSON, $filters: JSON, $pagination: PaginationArg) {
  findDataListOptionWithCount(
    orderBy: $orderBy
    filters: $filters
    publicationState: LIVE
    pagination: $pagination
  ) {
    count
    data {
      id
      attributes {
        ...dataListOption
        data_list {
          data {
            id
            attributes {
              ...dataLists
            }
          }
        }
      }
    }
  }
}
    ${DataListOptionFragmentDoc}
${DataListsFragmentDoc}`;
export type FindDataListOptionWithCountComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FindDataListOptionWithCountQuery, FindDataListOptionWithCountQueryVariables>, 'query'>;

    export const FindDataListOptionWithCountComponent = (props: FindDataListOptionWithCountComponentProps) => (
      <ApolloReactComponents.Query<FindDataListOptionWithCountQuery, FindDataListOptionWithCountQueryVariables> query={FindDataListOptionWithCountDocument} {...props} />
    );
    
export type FindDataListOptionWithCountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FindDataListOptionWithCountQuery, FindDataListOptionWithCountQueryVariables>
    } & TChildProps;
export function withFindDataListOptionWithCount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FindDataListOptionWithCountQuery,
  FindDataListOptionWithCountQueryVariables,
  FindDataListOptionWithCountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FindDataListOptionWithCountQuery, FindDataListOptionWithCountQueryVariables, FindDataListOptionWithCountProps<TChildProps, TDataName>>(FindDataListOptionWithCountDocument, {
      alias: 'findDataListOptionWithCount',
      ...operationOptions
    });
};

/**
 * __useFindDataListOptionWithCountQuery__
 *
 * To run a query within a React component, call `useFindDataListOptionWithCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindDataListOptionWithCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindDataListOptionWithCountQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useFindDataListOptionWithCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FindDataListOptionWithCountQuery, FindDataListOptionWithCountQueryVariables>) {
        return ApolloReactHooks.useQuery<FindDataListOptionWithCountQuery, FindDataListOptionWithCountQueryVariables>(FindDataListOptionWithCountDocument, baseOptions);
      }
export function useFindDataListOptionWithCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindDataListOptionWithCountQuery, FindDataListOptionWithCountQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FindDataListOptionWithCountQuery, FindDataListOptionWithCountQueryVariables>(FindDataListOptionWithCountDocument, baseOptions);
        }
export type FindDataListOptionWithCountQueryHookResult = ReturnType<typeof useFindDataListOptionWithCountQuery>;
export type FindDataListOptionWithCountLazyQueryHookResult = ReturnType<typeof useFindDataListOptionWithCountLazyQuery>;
export type FindDataListOptionWithCountQueryResult = ApolloReactCommon.QueryResult<FindDataListOptionWithCountQuery, FindDataListOptionWithCountQueryVariables>;
export const GetBaoriderCommunitiesDocument = gql`
    query getBaoriderCommunities {
  getBaoriderCommunities {
    id
    attributes {
      ...community
      featured_image {
        data {
          ...uploadFile
        }
      }
    }
  }
}
    ${CommunityFragmentDoc}
${UploadFileFragmentDoc}`;
export type GetBaoriderCommunitiesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetBaoriderCommunitiesQuery, GetBaoriderCommunitiesQueryVariables>, 'query'>;

    export const GetBaoriderCommunitiesComponent = (props: GetBaoriderCommunitiesComponentProps) => (
      <ApolloReactComponents.Query<GetBaoriderCommunitiesQuery, GetBaoriderCommunitiesQueryVariables> query={GetBaoriderCommunitiesDocument} {...props} />
    );
    
export type GetBaoriderCommunitiesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetBaoriderCommunitiesQuery, GetBaoriderCommunitiesQueryVariables>
    } & TChildProps;
export function withGetBaoriderCommunities<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetBaoriderCommunitiesQuery,
  GetBaoriderCommunitiesQueryVariables,
  GetBaoriderCommunitiesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetBaoriderCommunitiesQuery, GetBaoriderCommunitiesQueryVariables, GetBaoriderCommunitiesProps<TChildProps, TDataName>>(GetBaoriderCommunitiesDocument, {
      alias: 'getBaoriderCommunities',
      ...operationOptions
    });
};

/**
 * __useGetBaoriderCommunitiesQuery__
 *
 * To run a query within a React component, call `useGetBaoriderCommunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBaoriderCommunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBaoriderCommunitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBaoriderCommunitiesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBaoriderCommunitiesQuery, GetBaoriderCommunitiesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBaoriderCommunitiesQuery, GetBaoriderCommunitiesQueryVariables>(GetBaoriderCommunitiesDocument, baseOptions);
      }
export function useGetBaoriderCommunitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBaoriderCommunitiesQuery, GetBaoriderCommunitiesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBaoriderCommunitiesQuery, GetBaoriderCommunitiesQueryVariables>(GetBaoriderCommunitiesDocument, baseOptions);
        }
export type GetBaoriderCommunitiesQueryHookResult = ReturnType<typeof useGetBaoriderCommunitiesQuery>;
export type GetBaoriderCommunitiesLazyQueryHookResult = ReturnType<typeof useGetBaoriderCommunitiesLazyQuery>;
export type GetBaoriderCommunitiesQueryResult = ApolloReactCommon.QueryResult<GetBaoriderCommunitiesQuery, GetBaoriderCommunitiesQueryVariables>;
export const GetBaoriderCommunityProjectsDocument = gql`
    query getBaoriderCommunityProjects($community: ID!) {
  getBaoriderCommunityProjects(community: $community) {
    id
    attributes {
      ...project
      featured_image {
        data {
          ...uploadFile
        }
      }
    }
  }
}
    ${ProjectFragmentDoc}
${UploadFileFragmentDoc}`;
export type GetBaoriderCommunityProjectsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetBaoriderCommunityProjectsQuery, GetBaoriderCommunityProjectsQueryVariables>, 'query'> & ({ variables: GetBaoriderCommunityProjectsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetBaoriderCommunityProjectsComponent = (props: GetBaoriderCommunityProjectsComponentProps) => (
      <ApolloReactComponents.Query<GetBaoriderCommunityProjectsQuery, GetBaoriderCommunityProjectsQueryVariables> query={GetBaoriderCommunityProjectsDocument} {...props} />
    );
    
export type GetBaoriderCommunityProjectsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetBaoriderCommunityProjectsQuery, GetBaoriderCommunityProjectsQueryVariables>
    } & TChildProps;
export function withGetBaoriderCommunityProjects<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetBaoriderCommunityProjectsQuery,
  GetBaoriderCommunityProjectsQueryVariables,
  GetBaoriderCommunityProjectsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetBaoriderCommunityProjectsQuery, GetBaoriderCommunityProjectsQueryVariables, GetBaoriderCommunityProjectsProps<TChildProps, TDataName>>(GetBaoriderCommunityProjectsDocument, {
      alias: 'getBaoriderCommunityProjects',
      ...operationOptions
    });
};

/**
 * __useGetBaoriderCommunityProjectsQuery__
 *
 * To run a query within a React component, call `useGetBaoriderCommunityProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBaoriderCommunityProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBaoriderCommunityProjectsQuery({
 *   variables: {
 *      community: // value for 'community'
 *   },
 * });
 */
export function useGetBaoriderCommunityProjectsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBaoriderCommunityProjectsQuery, GetBaoriderCommunityProjectsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBaoriderCommunityProjectsQuery, GetBaoriderCommunityProjectsQueryVariables>(GetBaoriderCommunityProjectsDocument, baseOptions);
      }
export function useGetBaoriderCommunityProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBaoriderCommunityProjectsQuery, GetBaoriderCommunityProjectsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBaoriderCommunityProjectsQuery, GetBaoriderCommunityProjectsQueryVariables>(GetBaoriderCommunityProjectsDocument, baseOptions);
        }
export type GetBaoriderCommunityProjectsQueryHookResult = ReturnType<typeof useGetBaoriderCommunityProjectsQuery>;
export type GetBaoriderCommunityProjectsLazyQueryHookResult = ReturnType<typeof useGetBaoriderCommunityProjectsLazyQuery>;
export type GetBaoriderCommunityProjectsQueryResult = ApolloReactCommon.QueryResult<GetBaoriderCommunityProjectsQuery, GetBaoriderCommunityProjectsQueryVariables>;
export const GetBaoriderProjectsDocument = gql`
    query getBaoriderProjects($filters: JSON) {
  getBaoriderProjects(filters: $filters) {
    id
    attributes {
      ...project
      featured_image {
        data {
          ...uploadFile
        }
      }
    }
  }
}
    ${ProjectFragmentDoc}
${UploadFileFragmentDoc}`;
export type GetBaoriderProjectsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetBaoriderProjectsQuery, GetBaoriderProjectsQueryVariables>, 'query'>;

    export const GetBaoriderProjectsComponent = (props: GetBaoriderProjectsComponentProps) => (
      <ApolloReactComponents.Query<GetBaoriderProjectsQuery, GetBaoriderProjectsQueryVariables> query={GetBaoriderProjectsDocument} {...props} />
    );
    
export type GetBaoriderProjectsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetBaoriderProjectsQuery, GetBaoriderProjectsQueryVariables>
    } & TChildProps;
export function withGetBaoriderProjects<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetBaoriderProjectsQuery,
  GetBaoriderProjectsQueryVariables,
  GetBaoriderProjectsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetBaoriderProjectsQuery, GetBaoriderProjectsQueryVariables, GetBaoriderProjectsProps<TChildProps, TDataName>>(GetBaoriderProjectsDocument, {
      alias: 'getBaoriderProjects',
      ...operationOptions
    });
};

/**
 * __useGetBaoriderProjectsQuery__
 *
 * To run a query within a React component, call `useGetBaoriderProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBaoriderProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBaoriderProjectsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetBaoriderProjectsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBaoriderProjectsQuery, GetBaoriderProjectsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBaoriderProjectsQuery, GetBaoriderProjectsQueryVariables>(GetBaoriderProjectsDocument, baseOptions);
      }
export function useGetBaoriderProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBaoriderProjectsQuery, GetBaoriderProjectsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBaoriderProjectsQuery, GetBaoriderProjectsQueryVariables>(GetBaoriderProjectsDocument, baseOptions);
        }
export type GetBaoriderProjectsQueryHookResult = ReturnType<typeof useGetBaoriderProjectsQuery>;
export type GetBaoriderProjectsLazyQueryHookResult = ReturnType<typeof useGetBaoriderProjectsLazyQuery>;
export type GetBaoriderProjectsQueryResult = ApolloReactCommon.QueryResult<GetBaoriderProjectsQuery, GetBaoriderProjectsQueryVariables>;
export const GetBaoverifierMostPopularTaskDefinitionsDocument = gql`
    query getBaoverifierMostPopularTaskDefinitions($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  getBaoverifierMostPopularTaskDefinitions(
    sort: $sort
    filters: $filters
    publicationState: LIVE
    pagination: $pagination
  ) {
    count
    taskDefinition {
      id
      attributes {
        status
        category {
          data {
            id
            attributes {
              ...category
              featureImage {
                data {
                  ...uploadFile
                }
              }
            }
          }
        }
        baoleader {
          data {
            id
            attributes {
              baoleader {
                data {
                  id
                }
              }
            }
          }
        }
        project {
          data {
            id
            attributes {
              ...project
            }
          }
        }
        task_type {
          data {
            id
            attributes {
              title
              dataFields {
                ...componentCustomDataFieldsMetricsSpecific
                ...componentCustomDataFieldsNumberRange
                ...componentCustomDataFieldsNumberDropDown
                ...componentCustomDataFieldsPercentage
                ...componentCustomDataFieldsRadio
                ...componentCustomDataFieldsText
                ...componentCustomDataFieldsImageField
                ...componentCustomDataFieldsDataList
                ...componentCustomDataFieldsCheckbox
                ...componentCustomDataFieldsSelect
                ...componentCustomDataFieldsDateTimeField
                ...componentCustomDataFieldsPercentage
                ...componentCustomDataFieldsRating
                ...componentCustomDataFieldsNumberField
                ...componentCustomDataFieldsPhoneNumberField
                ...componentCustomDataFieldsEmailField
                __typename
              }
              custom_data_fields {
                data {
                  id
                  attributes {
                    label
                    type {
                      data {
                        id
                        attributes {
                          name
                          has_options
                        }
                      }
                    }
                    options {
                      data {
                        id
                        attributes {
                          value
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${CategoryFragmentDoc}
${UploadFileFragmentDoc}
${ProjectFragmentDoc}
${ComponentCustomDataFieldsMetricsSpecificFragmentDoc}
${ComponentCustomDataFieldsNumberRangeFragmentDoc}
${ComponentCustomDataFieldsNumberDropDownFragmentDoc}
${ComponentCustomDataFieldsPercentageFragmentDoc}
${ComponentCustomDataFieldsRadioFragmentDoc}
${ComponentCustomDataFieldsTextFragmentDoc}
${ComponentCustomDataFieldsImageFieldFragmentDoc}
${ComponentCustomDataFieldsDataListFragmentDoc}
${ComponentCustomDataFieldsCheckboxFragmentDoc}
${ComponentCustomDataFieldsSelectFragmentDoc}
${ComponentCustomDataFieldsDateTimeFieldFragmentDoc}
${ComponentCustomDataFieldsRatingFragmentDoc}
${ComponentCustomDataFieldsNumberFieldFragmentDoc}
${ComponentCustomDataFieldsPhoneNumberFieldFragmentDoc}
${ComponentCustomDataFieldsEmailFieldFragmentDoc}`;
export type GetBaoverifierMostPopularTaskDefinitionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetBaoverifierMostPopularTaskDefinitionsQuery, GetBaoverifierMostPopularTaskDefinitionsQueryVariables>, 'query'>;

    export const GetBaoverifierMostPopularTaskDefinitionsComponent = (props: GetBaoverifierMostPopularTaskDefinitionsComponentProps) => (
      <ApolloReactComponents.Query<GetBaoverifierMostPopularTaskDefinitionsQuery, GetBaoverifierMostPopularTaskDefinitionsQueryVariables> query={GetBaoverifierMostPopularTaskDefinitionsDocument} {...props} />
    );
    
export type GetBaoverifierMostPopularTaskDefinitionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetBaoverifierMostPopularTaskDefinitionsQuery, GetBaoverifierMostPopularTaskDefinitionsQueryVariables>
    } & TChildProps;
export function withGetBaoverifierMostPopularTaskDefinitions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetBaoverifierMostPopularTaskDefinitionsQuery,
  GetBaoverifierMostPopularTaskDefinitionsQueryVariables,
  GetBaoverifierMostPopularTaskDefinitionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetBaoverifierMostPopularTaskDefinitionsQuery, GetBaoverifierMostPopularTaskDefinitionsQueryVariables, GetBaoverifierMostPopularTaskDefinitionsProps<TChildProps, TDataName>>(GetBaoverifierMostPopularTaskDefinitionsDocument, {
      alias: 'getBaoverifierMostPopularTaskDefinitions',
      ...operationOptions
    });
};

/**
 * __useGetBaoverifierMostPopularTaskDefinitionsQuery__
 *
 * To run a query within a React component, call `useGetBaoverifierMostPopularTaskDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBaoverifierMostPopularTaskDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBaoverifierMostPopularTaskDefinitionsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetBaoverifierMostPopularTaskDefinitionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBaoverifierMostPopularTaskDefinitionsQuery, GetBaoverifierMostPopularTaskDefinitionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBaoverifierMostPopularTaskDefinitionsQuery, GetBaoverifierMostPopularTaskDefinitionsQueryVariables>(GetBaoverifierMostPopularTaskDefinitionsDocument, baseOptions);
      }
export function useGetBaoverifierMostPopularTaskDefinitionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBaoverifierMostPopularTaskDefinitionsQuery, GetBaoverifierMostPopularTaskDefinitionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBaoverifierMostPopularTaskDefinitionsQuery, GetBaoverifierMostPopularTaskDefinitionsQueryVariables>(GetBaoverifierMostPopularTaskDefinitionsDocument, baseOptions);
        }
export type GetBaoverifierMostPopularTaskDefinitionsQueryHookResult = ReturnType<typeof useGetBaoverifierMostPopularTaskDefinitionsQuery>;
export type GetBaoverifierMostPopularTaskDefinitionsLazyQueryHookResult = ReturnType<typeof useGetBaoverifierMostPopularTaskDefinitionsLazyQuery>;
export type GetBaoverifierMostPopularTaskDefinitionsQueryResult = ApolloReactCommon.QueryResult<GetBaoverifierMostPopularTaskDefinitionsQuery, GetBaoverifierMostPopularTaskDefinitionsQueryVariables>;
export const GetCategoriesDocument = gql`
    query getCategories {
  categories {
    data {
      id
      attributes {
        ...category
        featureImage {
          data {
            ...uploadFile
          }
        }
      }
    }
  }
}
    ${CategoryFragmentDoc}
${UploadFileFragmentDoc}`;
export type GetCategoriesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCategoriesQuery, GetCategoriesQueryVariables>, 'query'>;

    export const GetCategoriesComponent = (props: GetCategoriesComponentProps) => (
      <ApolloReactComponents.Query<GetCategoriesQuery, GetCategoriesQueryVariables> query={GetCategoriesDocument} {...props} />
    );
    
export type GetCategoriesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCategoriesQuery, GetCategoriesQueryVariables>
    } & TChildProps;
export function withGetCategories<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCategoriesQuery,
  GetCategoriesQueryVariables,
  GetCategoriesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCategoriesQuery, GetCategoriesQueryVariables, GetCategoriesProps<TChildProps, TDataName>>(GetCategoriesDocument, {
      alias: 'getCategories',
      ...operationOptions
    });
};

/**
 * __useGetCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
        return ApolloReactHooks.useQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, baseOptions);
      }
export function useGetCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, baseOptions);
        }
export type GetCategoriesQueryHookResult = ReturnType<typeof useGetCategoriesQuery>;
export type GetCategoriesLazyQueryHookResult = ReturnType<typeof useGetCategoriesLazyQuery>;
export type GetCategoriesQueryResult = ApolloReactCommon.QueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const GetDataCollectorTasksLeaderBoardDocument = gql`
    query getDataCollectorTasksLeaderBoard($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  getDataCollectorTasksLeaderBoard(
    sort: $sort
    filters: $filters
    pagination: $pagination
  ) {
    dataCollector {
      id
      attributes {
        firstName
        lastName
      }
    }
    count
  }
}
    `;
export type GetDataCollectorTasksLeaderBoardComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetDataCollectorTasksLeaderBoardQuery, GetDataCollectorTasksLeaderBoardQueryVariables>, 'query'>;

    export const GetDataCollectorTasksLeaderBoardComponent = (props: GetDataCollectorTasksLeaderBoardComponentProps) => (
      <ApolloReactComponents.Query<GetDataCollectorTasksLeaderBoardQuery, GetDataCollectorTasksLeaderBoardQueryVariables> query={GetDataCollectorTasksLeaderBoardDocument} {...props} />
    );
    
export type GetDataCollectorTasksLeaderBoardProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetDataCollectorTasksLeaderBoardQuery, GetDataCollectorTasksLeaderBoardQueryVariables>
    } & TChildProps;
export function withGetDataCollectorTasksLeaderBoard<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetDataCollectorTasksLeaderBoardQuery,
  GetDataCollectorTasksLeaderBoardQueryVariables,
  GetDataCollectorTasksLeaderBoardProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetDataCollectorTasksLeaderBoardQuery, GetDataCollectorTasksLeaderBoardQueryVariables, GetDataCollectorTasksLeaderBoardProps<TChildProps, TDataName>>(GetDataCollectorTasksLeaderBoardDocument, {
      alias: 'getDataCollectorTasksLeaderBoard',
      ...operationOptions
    });
};

/**
 * __useGetDataCollectorTasksLeaderBoardQuery__
 *
 * To run a query within a React component, call `useGetDataCollectorTasksLeaderBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataCollectorTasksLeaderBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataCollectorTasksLeaderBoardQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetDataCollectorTasksLeaderBoardQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDataCollectorTasksLeaderBoardQuery, GetDataCollectorTasksLeaderBoardQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDataCollectorTasksLeaderBoardQuery, GetDataCollectorTasksLeaderBoardQueryVariables>(GetDataCollectorTasksLeaderBoardDocument, baseOptions);
      }
export function useGetDataCollectorTasksLeaderBoardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDataCollectorTasksLeaderBoardQuery, GetDataCollectorTasksLeaderBoardQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDataCollectorTasksLeaderBoardQuery, GetDataCollectorTasksLeaderBoardQueryVariables>(GetDataCollectorTasksLeaderBoardDocument, baseOptions);
        }
export type GetDataCollectorTasksLeaderBoardQueryHookResult = ReturnType<typeof useGetDataCollectorTasksLeaderBoardQuery>;
export type GetDataCollectorTasksLeaderBoardLazyQueryHookResult = ReturnType<typeof useGetDataCollectorTasksLeaderBoardLazyQuery>;
export type GetDataCollectorTasksLeaderBoardQueryResult = ApolloReactCommon.QueryResult<GetDataCollectorTasksLeaderBoardQuery, GetDataCollectorTasksLeaderBoardQueryVariables>;
export const GetDataListDocument = gql`
    query getDataList($id: ID!) {
  dataList(id: $id) {
    data {
      id
      attributes {
        ...dataLists
      }
    }
  }
}
    ${DataListsFragmentDoc}`;
export type GetDataListComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetDataListQuery, GetDataListQueryVariables>, 'query'> & ({ variables: GetDataListQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetDataListComponent = (props: GetDataListComponentProps) => (
      <ApolloReactComponents.Query<GetDataListQuery, GetDataListQueryVariables> query={GetDataListDocument} {...props} />
    );
    
export type GetDataListProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetDataListQuery, GetDataListQueryVariables>
    } & TChildProps;
export function withGetDataList<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetDataListQuery,
  GetDataListQueryVariables,
  GetDataListProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetDataListQuery, GetDataListQueryVariables, GetDataListProps<TChildProps, TDataName>>(GetDataListDocument, {
      alias: 'getDataList',
      ...operationOptions
    });
};

/**
 * __useGetDataListQuery__
 *
 * To run a query within a React component, call `useGetDataListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDataListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDataListQuery, GetDataListQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDataListQuery, GetDataListQueryVariables>(GetDataListDocument, baseOptions);
      }
export function useGetDataListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDataListQuery, GetDataListQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDataListQuery, GetDataListQueryVariables>(GetDataListDocument, baseOptions);
        }
export type GetDataListQueryHookResult = ReturnType<typeof useGetDataListQuery>;
export type GetDataListLazyQueryHookResult = ReturnType<typeof useGetDataListLazyQuery>;
export type GetDataListQueryResult = ApolloReactCommon.QueryResult<GetDataListQuery, GetDataListQueryVariables>;
export const GetDataListsDocument = gql`
    query getDataLists($sort: [String], $filters: DataListFiltersInput, $pagination: PaginationArg, $publicationState: PublicationState) {
  dataLists(
    sort: $sort
    pagination: $pagination
    filters: $filters
    publicationState: $publicationState
  ) {
    data {
      id
      attributes {
        ...dataLists
      }
    }
    meta {
      pagination {
        ...pagination
      }
    }
  }
}
    ${DataListsFragmentDoc}
${PaginationFragmentDoc}`;
export type GetDataListsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetDataListsQuery, GetDataListsQueryVariables>, 'query'>;

    export const GetDataListsComponent = (props: GetDataListsComponentProps) => (
      <ApolloReactComponents.Query<GetDataListsQuery, GetDataListsQueryVariables> query={GetDataListsDocument} {...props} />
    );
    
export type GetDataListsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetDataListsQuery, GetDataListsQueryVariables>
    } & TChildProps;
export function withGetDataLists<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetDataListsQuery,
  GetDataListsQueryVariables,
  GetDataListsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetDataListsQuery, GetDataListsQueryVariables, GetDataListsProps<TChildProps, TDataName>>(GetDataListsDocument, {
      alias: 'getDataLists',
      ...operationOptions
    });
};

/**
 * __useGetDataListsQuery__
 *
 * To run a query within a React component, call `useGetDataListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataListsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      publicationState: // value for 'publicationState'
 *   },
 * });
 */
export function useGetDataListsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDataListsQuery, GetDataListsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetDataListsQuery, GetDataListsQueryVariables>(GetDataListsDocument, baseOptions);
      }
export function useGetDataListsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDataListsQuery, GetDataListsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetDataListsQuery, GetDataListsQueryVariables>(GetDataListsDocument, baseOptions);
        }
export type GetDataListsQueryHookResult = ReturnType<typeof useGetDataListsQuery>;
export type GetDataListsLazyQueryHookResult = ReturnType<typeof useGetDataListsLazyQuery>;
export type GetDataListsQueryResult = ApolloReactCommon.QueryResult<GetDataListsQuery, GetDataListsQueryVariables>;
export const GetBaoriderEvidenceDocument = gql`
    query getBaoriderEvidence($id: ID!) {
  getBaoriderEvidence(id: $id) {
    ...evidence
    photos {
      data {
        ...uploadFile
      }
    }
    custom_data_fields {
      ...componentCustomDataFieldsMetricsSpecific
      ...componentCustomDataFieldsNumberRange
      ...componentCustomDataFieldsNumberDropDown
      ...componentCustomDataFieldsPercentage
      ...componentCustomDataFieldsRadio
      ...componentCustomDataFieldsText
      ...componentCustomDataFieldsImageField
      ...componentCustomDataFieldsDataList
      ...componentCustomDataFieldsCheckbox
      ...componentCustomDataFieldsSelect
      ...componentCustomDataFieldsPercentage
      ...componentCustomDataFieldsRating
      ...componentCustomDataFieldsNumberField
      ...componentCustomDataFieldsDateTimeField
      ...componentCustomDataFieldsPhoneNumberField
      ...componentCustomDataFieldsEmailField
      __typename
    }
  }
}
    ${EvidenceFragmentDoc}
${UploadFileFragmentDoc}
${ComponentCustomDataFieldsMetricsSpecificFragmentDoc}
${ComponentCustomDataFieldsNumberRangeFragmentDoc}
${ComponentCustomDataFieldsNumberDropDownFragmentDoc}
${ComponentCustomDataFieldsPercentageFragmentDoc}
${ComponentCustomDataFieldsRadioFragmentDoc}
${ComponentCustomDataFieldsTextFragmentDoc}
${ComponentCustomDataFieldsImageFieldFragmentDoc}
${ComponentCustomDataFieldsDataListFragmentDoc}
${ComponentCustomDataFieldsCheckboxFragmentDoc}
${ComponentCustomDataFieldsSelectFragmentDoc}
${ComponentCustomDataFieldsRatingFragmentDoc}
${ComponentCustomDataFieldsNumberFieldFragmentDoc}
${ComponentCustomDataFieldsDateTimeFieldFragmentDoc}
${ComponentCustomDataFieldsPhoneNumberFieldFragmentDoc}
${ComponentCustomDataFieldsEmailFieldFragmentDoc}`;
export type GetBaoriderEvidenceComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetBaoriderEvidenceQuery, GetBaoriderEvidenceQueryVariables>, 'query'> & ({ variables: GetBaoriderEvidenceQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetBaoriderEvidenceComponent = (props: GetBaoriderEvidenceComponentProps) => (
      <ApolloReactComponents.Query<GetBaoriderEvidenceQuery, GetBaoriderEvidenceQueryVariables> query={GetBaoriderEvidenceDocument} {...props} />
    );
    
export type GetBaoriderEvidenceProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetBaoriderEvidenceQuery, GetBaoriderEvidenceQueryVariables>
    } & TChildProps;
export function withGetBaoriderEvidence<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetBaoriderEvidenceQuery,
  GetBaoriderEvidenceQueryVariables,
  GetBaoriderEvidenceProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetBaoriderEvidenceQuery, GetBaoriderEvidenceQueryVariables, GetBaoriderEvidenceProps<TChildProps, TDataName>>(GetBaoriderEvidenceDocument, {
      alias: 'getBaoriderEvidence',
      ...operationOptions
    });
};

/**
 * __useGetBaoriderEvidenceQuery__
 *
 * To run a query within a React component, call `useGetBaoriderEvidenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBaoriderEvidenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBaoriderEvidenceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBaoriderEvidenceQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBaoriderEvidenceQuery, GetBaoriderEvidenceQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBaoriderEvidenceQuery, GetBaoriderEvidenceQueryVariables>(GetBaoriderEvidenceDocument, baseOptions);
      }
export function useGetBaoriderEvidenceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBaoriderEvidenceQuery, GetBaoriderEvidenceQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBaoriderEvidenceQuery, GetBaoriderEvidenceQueryVariables>(GetBaoriderEvidenceDocument, baseOptions);
        }
export type GetBaoriderEvidenceQueryHookResult = ReturnType<typeof useGetBaoriderEvidenceQuery>;
export type GetBaoriderEvidenceLazyQueryHookResult = ReturnType<typeof useGetBaoriderEvidenceLazyQuery>;
export type GetBaoriderEvidenceQueryResult = ApolloReactCommon.QueryResult<GetBaoriderEvidenceQuery, GetBaoriderEvidenceQueryVariables>;
export const GetNotificationDocument = gql`
    query getNotification($id: ID!) {
  getDataCollectorNotification(id: $id) {
    id
    attributes {
      ...notification
    }
  }
}
    ${NotificationFragmentDoc}`;
export type GetNotificationComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNotificationQuery, GetNotificationQueryVariables>, 'query'> & ({ variables: GetNotificationQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetNotificationComponent = (props: GetNotificationComponentProps) => (
      <ApolloReactComponents.Query<GetNotificationQuery, GetNotificationQueryVariables> query={GetNotificationDocument} {...props} />
    );
    
export type GetNotificationProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNotificationQuery, GetNotificationQueryVariables>
    } & TChildProps;
export function withGetNotification<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNotificationQuery,
  GetNotificationQueryVariables,
  GetNotificationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNotificationQuery, GetNotificationQueryVariables, GetNotificationProps<TChildProps, TDataName>>(GetNotificationDocument, {
      alias: 'getNotification',
      ...operationOptions
    });
};

/**
 * __useGetNotificationQuery__
 *
 * To run a query within a React component, call `useGetNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNotificationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNotificationQuery, GetNotificationQueryVariables>) {
        return ApolloReactHooks.useQuery<GetNotificationQuery, GetNotificationQueryVariables>(GetNotificationDocument, baseOptions);
      }
export function useGetNotificationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNotificationQuery, GetNotificationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetNotificationQuery, GetNotificationQueryVariables>(GetNotificationDocument, baseOptions);
        }
export type GetNotificationQueryHookResult = ReturnType<typeof useGetNotificationQuery>;
export type GetNotificationLazyQueryHookResult = ReturnType<typeof useGetNotificationLazyQuery>;
export type GetNotificationQueryResult = ApolloReactCommon.QueryResult<GetNotificationQuery, GetNotificationQueryVariables>;
export const GetNotificationTasksDocument = gql`
    query getNotificationTasks($sort: [String], $filters: JSON, $pagination: PaginationArg, $publicationState: PublicationState) {
  getNotificationTasks(
    sort: $sort
    pagination: $pagination
    filters: $filters
    publicationState: $publicationState
  ) {
    task {
      id
      attributes {
        ...task
        baoleader {
          data {
            id
            attributes {
              ...user
              profilePicture {
                data {
                  ...uploadFile
                }
              }
              baoleader {
                data {
                  id
                }
              }
            }
          }
        }
        baorider {
          data {
            id
            attributes {
              ...user
              profilePicture {
                data {
                  ...uploadFile
                }
              }
              baoleader {
                data {
                  id
                }
              }
            }
          }
        }
        task_definition {
          data {
            id
            attributes {
              category {
                data {
                  id
                  attributes {
                    ...category
                    featureImage {
                      data {
                        ...uploadFile
                      }
                    }
                  }
                }
              }
              task_type {
                data {
                  id
                  attributes {
                    ...task_type
                  }
                }
              }
            }
          }
        }
        project {
          data {
            id
            attributes {
              ...project
            }
          }
        }
        evidences {
          data {
            id
            attributes {
              ...evidence
              custom_data_fields {
                ...componentCustomDataFieldsMetricsSpecific
                ...componentCustomDataFieldsNumberRange
                ...componentCustomDataFieldsNumberDropDown
                ...componentCustomDataFieldsPercentage
                ...componentCustomDataFieldsRadio
                ...componentCustomDataFieldsText
                ...componentCustomDataFieldsCheckbox
                ...componentCustomDataFieldsImageField
                ...componentCustomDataFieldsSelect
                ...componentCustomDataFieldsDateTimeField
                ...componentCustomDataFieldsRating
                ...componentCustomDataFieldsNumberField
                ...componentCustomDataFieldsDataList
                ...componentCustomDataFieldsPercentage
                ...componentCustomDataFieldsPhoneNumberField
                ...componentCustomDataFieldsEmailField
                __typename
              }
              photos {
                data {
                  ...uploadFile
                }
              }
              baorider {
                data {
                  id
                }
              }
            }
          }
        }
        community {
          data {
            id
            attributes {
              ...community
            }
          }
        }
      }
    }
    canEdit
  }
}
    ${TaskFragmentDoc}
${UserFragmentDoc}
${UploadFileFragmentDoc}
${CategoryFragmentDoc}
${Task_TypeFragmentDoc}
${ProjectFragmentDoc}
${EvidenceFragmentDoc}
${ComponentCustomDataFieldsMetricsSpecificFragmentDoc}
${ComponentCustomDataFieldsNumberRangeFragmentDoc}
${ComponentCustomDataFieldsNumberDropDownFragmentDoc}
${ComponentCustomDataFieldsPercentageFragmentDoc}
${ComponentCustomDataFieldsRadioFragmentDoc}
${ComponentCustomDataFieldsTextFragmentDoc}
${ComponentCustomDataFieldsCheckboxFragmentDoc}
${ComponentCustomDataFieldsImageFieldFragmentDoc}
${ComponentCustomDataFieldsSelectFragmentDoc}
${ComponentCustomDataFieldsDateTimeFieldFragmentDoc}
${ComponentCustomDataFieldsRatingFragmentDoc}
${ComponentCustomDataFieldsNumberFieldFragmentDoc}
${ComponentCustomDataFieldsDataListFragmentDoc}
${ComponentCustomDataFieldsPhoneNumberFieldFragmentDoc}
${ComponentCustomDataFieldsEmailFieldFragmentDoc}
${CommunityFragmentDoc}`;
export type GetNotificationTasksComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNotificationTasksQuery, GetNotificationTasksQueryVariables>, 'query'>;

    export const GetNotificationTasksComponent = (props: GetNotificationTasksComponentProps) => (
      <ApolloReactComponents.Query<GetNotificationTasksQuery, GetNotificationTasksQueryVariables> query={GetNotificationTasksDocument} {...props} />
    );
    
export type GetNotificationTasksProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNotificationTasksQuery, GetNotificationTasksQueryVariables>
    } & TChildProps;
export function withGetNotificationTasks<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNotificationTasksQuery,
  GetNotificationTasksQueryVariables,
  GetNotificationTasksProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNotificationTasksQuery, GetNotificationTasksQueryVariables, GetNotificationTasksProps<TChildProps, TDataName>>(GetNotificationTasksDocument, {
      alias: 'getNotificationTasks',
      ...operationOptions
    });
};

/**
 * __useGetNotificationTasksQuery__
 *
 * To run a query within a React component, call `useGetNotificationTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationTasksQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      publicationState: // value for 'publicationState'
 *   },
 * });
 */
export function useGetNotificationTasksQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNotificationTasksQuery, GetNotificationTasksQueryVariables>) {
        return ApolloReactHooks.useQuery<GetNotificationTasksQuery, GetNotificationTasksQueryVariables>(GetNotificationTasksDocument, baseOptions);
      }
export function useGetNotificationTasksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNotificationTasksQuery, GetNotificationTasksQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetNotificationTasksQuery, GetNotificationTasksQueryVariables>(GetNotificationTasksDocument, baseOptions);
        }
export type GetNotificationTasksQueryHookResult = ReturnType<typeof useGetNotificationTasksQuery>;
export type GetNotificationTasksLazyQueryHookResult = ReturnType<typeof useGetNotificationTasksLazyQuery>;
export type GetNotificationTasksQueryResult = ApolloReactCommon.QueryResult<GetNotificationTasksQuery, GetNotificationTasksQueryVariables>;
export const GetNotificationsDocument = gql`
    query getNotifications($sort: [String], $filters: JSON, $pagination: PaginationArg, $publicationState: PublicationState) {
  getDataCollectorNotifications(
    sort: $sort
    pagination: $pagination
    filters: $filters
    publicationState: $publicationState
  ) {
    id
    attributes {
      ...notification
    }
  }
}
    ${NotificationFragmentDoc}`;
export type GetNotificationsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNotificationsQuery, GetNotificationsQueryVariables>, 'query'>;

    export const GetNotificationsComponent = (props: GetNotificationsComponentProps) => (
      <ApolloReactComponents.Query<GetNotificationsQuery, GetNotificationsQueryVariables> query={GetNotificationsDocument} {...props} />
    );
    
export type GetNotificationsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNotificationsQuery, GetNotificationsQueryVariables>
    } & TChildProps;
export function withGetNotifications<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNotificationsQuery,
  GetNotificationsQueryVariables,
  GetNotificationsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNotificationsQuery, GetNotificationsQueryVariables, GetNotificationsProps<TChildProps, TDataName>>(GetNotificationsDocument, {
      alias: 'getNotifications',
      ...operationOptions
    });
};

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      publicationState: // value for 'publicationState'
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, baseOptions);
      }
export function useGetNotificationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, baseOptions);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsQueryResult = ApolloReactCommon.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const GetNumberDataCollectorsTasksDocument = gql`
    query getNumberDataCollectorsTasks($sort: [String], $filters: JSON, $pagination: PaginationArg, $publicationState: PublicationState) {
  getNumberDataCollectorsTasks(
    sort: $sort
    pagination: $pagination
    filters: $filters
    publicationState: $publicationState
  )
}
    `;
export type GetNumberDataCollectorsTasksComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNumberDataCollectorsTasksQuery, GetNumberDataCollectorsTasksQueryVariables>, 'query'>;

    export const GetNumberDataCollectorsTasksComponent = (props: GetNumberDataCollectorsTasksComponentProps) => (
      <ApolloReactComponents.Query<GetNumberDataCollectorsTasksQuery, GetNumberDataCollectorsTasksQueryVariables> query={GetNumberDataCollectorsTasksDocument} {...props} />
    );
    
export type GetNumberDataCollectorsTasksProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNumberDataCollectorsTasksQuery, GetNumberDataCollectorsTasksQueryVariables>
    } & TChildProps;
export function withGetNumberDataCollectorsTasks<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNumberDataCollectorsTasksQuery,
  GetNumberDataCollectorsTasksQueryVariables,
  GetNumberDataCollectorsTasksProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNumberDataCollectorsTasksQuery, GetNumberDataCollectorsTasksQueryVariables, GetNumberDataCollectorsTasksProps<TChildProps, TDataName>>(GetNumberDataCollectorsTasksDocument, {
      alias: 'getNumberDataCollectorsTasks',
      ...operationOptions
    });
};

/**
 * __useGetNumberDataCollectorsTasksQuery__
 *
 * To run a query within a React component, call `useGetNumberDataCollectorsTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNumberDataCollectorsTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNumberDataCollectorsTasksQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      publicationState: // value for 'publicationState'
 *   },
 * });
 */
export function useGetNumberDataCollectorsTasksQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNumberDataCollectorsTasksQuery, GetNumberDataCollectorsTasksQueryVariables>) {
        return ApolloReactHooks.useQuery<GetNumberDataCollectorsTasksQuery, GetNumberDataCollectorsTasksQueryVariables>(GetNumberDataCollectorsTasksDocument, baseOptions);
      }
export function useGetNumberDataCollectorsTasksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNumberDataCollectorsTasksQuery, GetNumberDataCollectorsTasksQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetNumberDataCollectorsTasksQuery, GetNumberDataCollectorsTasksQueryVariables>(GetNumberDataCollectorsTasksDocument, baseOptions);
        }
export type GetNumberDataCollectorsTasksQueryHookResult = ReturnType<typeof useGetNumberDataCollectorsTasksQuery>;
export type GetNumberDataCollectorsTasksLazyQueryHookResult = ReturnType<typeof useGetNumberDataCollectorsTasksLazyQuery>;
export type GetNumberDataCollectorsTasksQueryResult = ApolloReactCommon.QueryResult<GetNumberDataCollectorsTasksQuery, GetNumberDataCollectorsTasksQueryVariables>;
export const GetSingleBaoriderCommunityDocument = gql`
    query getSingleBaoriderCommunity($id: ID!) {
  getSingleBaoriderCommunity(id: $id) {
    community {
      ...community
      featured_image {
        data {
          ...uploadFile
        }
      }
      baoleader {
        data {
          id
          attributes {
            ...user
            profilePicture {
              data {
                ...uploadFile
              }
            }
            baoleader {
              data {
                id
              }
            }
          }
        }
      }
    }
    completedTasks
    completedProjects
    activeMembers
  }
}
    ${CommunityFragmentDoc}
${UploadFileFragmentDoc}
${UserFragmentDoc}`;
export type GetSingleBaoriderCommunityComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSingleBaoriderCommunityQuery, GetSingleBaoriderCommunityQueryVariables>, 'query'> & ({ variables: GetSingleBaoriderCommunityQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSingleBaoriderCommunityComponent = (props: GetSingleBaoriderCommunityComponentProps) => (
      <ApolloReactComponents.Query<GetSingleBaoriderCommunityQuery, GetSingleBaoriderCommunityQueryVariables> query={GetSingleBaoriderCommunityDocument} {...props} />
    );
    
export type GetSingleBaoriderCommunityProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetSingleBaoriderCommunityQuery, GetSingleBaoriderCommunityQueryVariables>
    } & TChildProps;
export function withGetSingleBaoriderCommunity<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetSingleBaoriderCommunityQuery,
  GetSingleBaoriderCommunityQueryVariables,
  GetSingleBaoriderCommunityProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetSingleBaoriderCommunityQuery, GetSingleBaoriderCommunityQueryVariables, GetSingleBaoriderCommunityProps<TChildProps, TDataName>>(GetSingleBaoriderCommunityDocument, {
      alias: 'getSingleBaoriderCommunity',
      ...operationOptions
    });
};

/**
 * __useGetSingleBaoriderCommunityQuery__
 *
 * To run a query within a React component, call `useGetSingleBaoriderCommunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleBaoriderCommunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleBaoriderCommunityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSingleBaoriderCommunityQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSingleBaoriderCommunityQuery, GetSingleBaoriderCommunityQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSingleBaoriderCommunityQuery, GetSingleBaoriderCommunityQueryVariables>(GetSingleBaoriderCommunityDocument, baseOptions);
      }
export function useGetSingleBaoriderCommunityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSingleBaoriderCommunityQuery, GetSingleBaoriderCommunityQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSingleBaoriderCommunityQuery, GetSingleBaoriderCommunityQueryVariables>(GetSingleBaoriderCommunityDocument, baseOptions);
        }
export type GetSingleBaoriderCommunityQueryHookResult = ReturnType<typeof useGetSingleBaoriderCommunityQuery>;
export type GetSingleBaoriderCommunityLazyQueryHookResult = ReturnType<typeof useGetSingleBaoriderCommunityLazyQuery>;
export type GetSingleBaoriderCommunityQueryResult = ApolloReactCommon.QueryResult<GetSingleBaoriderCommunityQuery, GetSingleBaoriderCommunityQueryVariables>;
export const GetSingleBaoriderProjectDocument = gql`
    query getSingleBaoriderProject($id: ID!) {
  getSingleBaoriderProject(id: $id) {
    id
    attributes {
      ...project
      featured_image {
        data {
          ...uploadFile
        }
      }
    }
  }
}
    ${ProjectFragmentDoc}
${UploadFileFragmentDoc}`;
export type GetSingleBaoriderProjectComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSingleBaoriderProjectQuery, GetSingleBaoriderProjectQueryVariables>, 'query'> & ({ variables: GetSingleBaoriderProjectQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSingleBaoriderProjectComponent = (props: GetSingleBaoriderProjectComponentProps) => (
      <ApolloReactComponents.Query<GetSingleBaoriderProjectQuery, GetSingleBaoriderProjectQueryVariables> query={GetSingleBaoriderProjectDocument} {...props} />
    );
    
export type GetSingleBaoriderProjectProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetSingleBaoriderProjectQuery, GetSingleBaoriderProjectQueryVariables>
    } & TChildProps;
export function withGetSingleBaoriderProject<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetSingleBaoriderProjectQuery,
  GetSingleBaoriderProjectQueryVariables,
  GetSingleBaoriderProjectProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetSingleBaoriderProjectQuery, GetSingleBaoriderProjectQueryVariables, GetSingleBaoriderProjectProps<TChildProps, TDataName>>(GetSingleBaoriderProjectDocument, {
      alias: 'getSingleBaoriderProject',
      ...operationOptions
    });
};

/**
 * __useGetSingleBaoriderProjectQuery__
 *
 * To run a query within a React component, call `useGetSingleBaoriderProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleBaoriderProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleBaoriderProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSingleBaoriderProjectQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSingleBaoriderProjectQuery, GetSingleBaoriderProjectQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSingleBaoriderProjectQuery, GetSingleBaoriderProjectQueryVariables>(GetSingleBaoriderProjectDocument, baseOptions);
      }
export function useGetSingleBaoriderProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSingleBaoriderProjectQuery, GetSingleBaoriderProjectQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSingleBaoriderProjectQuery, GetSingleBaoriderProjectQueryVariables>(GetSingleBaoriderProjectDocument, baseOptions);
        }
export type GetSingleBaoriderProjectQueryHookResult = ReturnType<typeof useGetSingleBaoriderProjectQuery>;
export type GetSingleBaoriderProjectLazyQueryHookResult = ReturnType<typeof useGetSingleBaoriderProjectLazyQuery>;
export type GetSingleBaoriderProjectQueryResult = ApolloReactCommon.QueryResult<GetSingleBaoriderProjectQuery, GetSingleBaoriderProjectQueryVariables>;
export const GetSingleBaoriderTaskDocument = gql`
    query getSingleBaoriderTask($id: ID!) {
  getSingleBaoriderTask(id: $id) {
    id
    attributes {
      ...task
      baoleader {
        data {
          id
          attributes {
            ...user
            profilePicture {
              data {
                ...uploadFile
              }
            }
            baoleader {
              data {
                id
              }
            }
          }
        }
      }
      baorider {
        data {
          id
          attributes {
            ...user
            profilePicture {
              data {
                ...uploadFile
              }
            }
            baoleader {
              data {
                id
              }
            }
          }
        }
      }
      task_definition {
        data {
          id
          attributes {
            category {
              data {
                id
                attributes {
                  ...category
                }
              }
            }
            baoleader {
              data {
                id
                attributes {
                  baoleader {
                    data {
                      id
                    }
                  }
                }
              }
            }
            project {
              data {
                id
                attributes {
                  ...project
                }
              }
            }
            task_type {
              data {
                id
                attributes {
                  title
                  dataFields {
                    ...componentCustomDataFieldsMetricsSpecific
                    ...componentCustomDataFieldsNumberRange
                    ...componentCustomDataFieldsNumberDropDown
                    ...componentCustomDataFieldsPercentage
                    ...componentCustomDataFieldsRadio
                    ...componentCustomDataFieldsText
                    ...componentCustomDataFieldsImageField
                    ...componentCustomDataFieldsDataList
                    ...componentCustomDataFieldsCheckbox
                    ...componentCustomDataFieldsSelect
                    ...componentCustomDataFieldsPercentage
                    ...componentCustomDataFieldsRating
                    ...componentCustomDataFieldsNumberField
                    ...componentCustomDataFieldsDateTimeField
                    ...componentCustomDataFieldsPhoneNumberField
                    ...componentCustomDataFieldsEmailField
                    __typename
                  }
                }
              }
            }
          }
        }
      }
      project {
        data {
          id
          attributes {
            ...project
          }
        }
      }
      evidences {
        data {
          id
          attributes {
            ...evidence
            photos {
              data {
                ...uploadFile
              }
            }
            custom_data_fields {
              ...componentCustomDataFieldsMetricsSpecific
              ...componentCustomDataFieldsNumberRange
              ...componentCustomDataFieldsNumberDropDown
              ...componentCustomDataFieldsPercentage
              ...componentCustomDataFieldsRadio
              ...componentCustomDataFieldsText
              ...componentCustomDataFieldsImageField
              ...componentCustomDataFieldsDataList
              ...componentCustomDataFieldsCheckbox
              ...componentCustomDataFieldsSelect
              ...componentCustomDataFieldsPercentage
              ...componentCustomDataFieldsRating
              ...componentCustomDataFieldsNumberField
              ...componentCustomDataFieldsDateTimeField
              ...componentCustomDataFieldsPhoneNumberField
              ...componentCustomDataFieldsEmailField
              __typename
            }
            data_field_values {
              data {
                id
                attributes {
                  value
                  data_field {
                    data {
                      id
                      attributes {
                        label
                      }
                    }
                  }
                  baorider {
                    data {
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
      community {
        data {
          id
          attributes {
            ...community
          }
        }
      }
    }
  }
}
    ${TaskFragmentDoc}
${UserFragmentDoc}
${UploadFileFragmentDoc}
${CategoryFragmentDoc}
${ProjectFragmentDoc}
${ComponentCustomDataFieldsMetricsSpecificFragmentDoc}
${ComponentCustomDataFieldsNumberRangeFragmentDoc}
${ComponentCustomDataFieldsNumberDropDownFragmentDoc}
${ComponentCustomDataFieldsPercentageFragmentDoc}
${ComponentCustomDataFieldsRadioFragmentDoc}
${ComponentCustomDataFieldsTextFragmentDoc}
${ComponentCustomDataFieldsImageFieldFragmentDoc}
${ComponentCustomDataFieldsDataListFragmentDoc}
${ComponentCustomDataFieldsCheckboxFragmentDoc}
${ComponentCustomDataFieldsSelectFragmentDoc}
${ComponentCustomDataFieldsRatingFragmentDoc}
${ComponentCustomDataFieldsNumberFieldFragmentDoc}
${ComponentCustomDataFieldsDateTimeFieldFragmentDoc}
${ComponentCustomDataFieldsPhoneNumberFieldFragmentDoc}
${ComponentCustomDataFieldsEmailFieldFragmentDoc}
${EvidenceFragmentDoc}
${CommunityFragmentDoc}`;
export type GetSingleBaoriderTaskComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSingleBaoriderTaskQuery, GetSingleBaoriderTaskQueryVariables>, 'query'> & ({ variables: GetSingleBaoriderTaskQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSingleBaoriderTaskComponent = (props: GetSingleBaoriderTaskComponentProps) => (
      <ApolloReactComponents.Query<GetSingleBaoriderTaskQuery, GetSingleBaoriderTaskQueryVariables> query={GetSingleBaoriderTaskDocument} {...props} />
    );
    
export type GetSingleBaoriderTaskProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetSingleBaoriderTaskQuery, GetSingleBaoriderTaskQueryVariables>
    } & TChildProps;
export function withGetSingleBaoriderTask<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetSingleBaoriderTaskQuery,
  GetSingleBaoriderTaskQueryVariables,
  GetSingleBaoriderTaskProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetSingleBaoriderTaskQuery, GetSingleBaoriderTaskQueryVariables, GetSingleBaoriderTaskProps<TChildProps, TDataName>>(GetSingleBaoriderTaskDocument, {
      alias: 'getSingleBaoriderTask',
      ...operationOptions
    });
};

/**
 * __useGetSingleBaoriderTaskQuery__
 *
 * To run a query within a React component, call `useGetSingleBaoriderTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleBaoriderTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleBaoriderTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSingleBaoriderTaskQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSingleBaoriderTaskQuery, GetSingleBaoriderTaskQueryVariables>) {
        return ApolloReactHooks.useQuery<GetSingleBaoriderTaskQuery, GetSingleBaoriderTaskQueryVariables>(GetSingleBaoriderTaskDocument, baseOptions);
      }
export function useGetSingleBaoriderTaskLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSingleBaoriderTaskQuery, GetSingleBaoriderTaskQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetSingleBaoriderTaskQuery, GetSingleBaoriderTaskQueryVariables>(GetSingleBaoriderTaskDocument, baseOptions);
        }
export type GetSingleBaoriderTaskQueryHookResult = ReturnType<typeof useGetSingleBaoriderTaskQuery>;
export type GetSingleBaoriderTaskLazyQueryHookResult = ReturnType<typeof useGetSingleBaoriderTaskLazyQuery>;
export type GetSingleBaoriderTaskQueryResult = ApolloReactCommon.QueryResult<GetSingleBaoriderTaskQuery, GetSingleBaoriderTaskQueryVariables>;
export const GetBaoriderTasksDocument = gql`
    query getBaoriderTasks($sort: [String], $filters: JSON, $pagination: PaginationArg, $publicationState: PublicationState) {
  getBaoriderTasks(
    sort: $sort
    pagination: $pagination
    filters: $filters
    publicationState: $publicationState
  ) {
    data {
      id
      attributes {
        ...task
        baoleader {
          data {
            id
            attributes {
              ...user
              profilePicture {
                data {
                  ...uploadFile
                }
              }
              baoleader {
                data {
                  id
                }
              }
            }
          }
        }
        baorider {
          data {
            id
            attributes {
              ...user
              profilePicture {
                data {
                  ...uploadFile
                }
              }
              baoleader {
                data {
                  id
                }
              }
            }
          }
        }
        task_definition {
          data {
            id
            attributes {
              category {
                data {
                  id
                  attributes {
                    ...category
                    featureImage {
                      data {
                        ...uploadFile
                      }
                    }
                  }
                }
              }
              task_type {
                data {
                  id
                  attributes {
                    ...task_type
                  }
                }
              }
            }
          }
        }
        project {
          data {
            id
            attributes {
              ...project
            }
          }
        }
        evidences {
          data {
            id
            attributes {
              ...evidence
              custom_data_fields {
                ...componentCustomDataFieldsMetricsSpecific
                ...componentCustomDataFieldsNumberRange
                ...componentCustomDataFieldsNumberDropDown
                ...componentCustomDataFieldsPercentage
                ...componentCustomDataFieldsRadio
                ...componentCustomDataFieldsText
                ...componentCustomDataFieldsCheckbox
                ...componentCustomDataFieldsImageField
                ...componentCustomDataFieldsSelect
                ...componentCustomDataFieldsDateTimeField
                ...componentCustomDataFieldsRating
                ...componentCustomDataFieldsNumberField
                ...componentCustomDataFieldsDataList
                ...componentCustomDataFieldsPercentage
                ...componentCustomDataFieldsPhoneNumberField
                ...componentCustomDataFieldsEmailField
                __typename
              }
              photos {
                data {
                  ...uploadFile
                }
              }
              baorider {
                data {
                  id
                }
              }
            }
          }
        }
        community {
          data {
            id
            attributes {
              ...community
            }
          }
        }
      }
    }
    count
  }
}
    ${TaskFragmentDoc}
${UserFragmentDoc}
${UploadFileFragmentDoc}
${CategoryFragmentDoc}
${Task_TypeFragmentDoc}
${ProjectFragmentDoc}
${EvidenceFragmentDoc}
${ComponentCustomDataFieldsMetricsSpecificFragmentDoc}
${ComponentCustomDataFieldsNumberRangeFragmentDoc}
${ComponentCustomDataFieldsNumberDropDownFragmentDoc}
${ComponentCustomDataFieldsPercentageFragmentDoc}
${ComponentCustomDataFieldsRadioFragmentDoc}
${ComponentCustomDataFieldsTextFragmentDoc}
${ComponentCustomDataFieldsCheckboxFragmentDoc}
${ComponentCustomDataFieldsImageFieldFragmentDoc}
${ComponentCustomDataFieldsSelectFragmentDoc}
${ComponentCustomDataFieldsDateTimeFieldFragmentDoc}
${ComponentCustomDataFieldsRatingFragmentDoc}
${ComponentCustomDataFieldsNumberFieldFragmentDoc}
${ComponentCustomDataFieldsDataListFragmentDoc}
${ComponentCustomDataFieldsPhoneNumberFieldFragmentDoc}
${ComponentCustomDataFieldsEmailFieldFragmentDoc}
${CommunityFragmentDoc}`;
export type GetBaoriderTasksComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetBaoriderTasksQuery, GetBaoriderTasksQueryVariables>, 'query'>;

    export const GetBaoriderTasksComponent = (props: GetBaoriderTasksComponentProps) => (
      <ApolloReactComponents.Query<GetBaoriderTasksQuery, GetBaoriderTasksQueryVariables> query={GetBaoriderTasksDocument} {...props} />
    );
    
export type GetBaoriderTasksProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetBaoriderTasksQuery, GetBaoriderTasksQueryVariables>
    } & TChildProps;
export function withGetBaoriderTasks<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetBaoriderTasksQuery,
  GetBaoriderTasksQueryVariables,
  GetBaoriderTasksProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetBaoriderTasksQuery, GetBaoriderTasksQueryVariables, GetBaoriderTasksProps<TChildProps, TDataName>>(GetBaoriderTasksDocument, {
      alias: 'getBaoriderTasks',
      ...operationOptions
    });
};

/**
 * __useGetBaoriderTasksQuery__
 *
 * To run a query within a React component, call `useGetBaoriderTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBaoriderTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBaoriderTasksQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      publicationState: // value for 'publicationState'
 *   },
 * });
 */
export function useGetBaoriderTasksQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBaoriderTasksQuery, GetBaoriderTasksQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBaoriderTasksQuery, GetBaoriderTasksQueryVariables>(GetBaoriderTasksDocument, baseOptions);
      }
export function useGetBaoriderTasksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBaoriderTasksQuery, GetBaoriderTasksQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBaoriderTasksQuery, GetBaoriderTasksQueryVariables>(GetBaoriderTasksDocument, baseOptions);
        }
export type GetBaoriderTasksQueryHookResult = ReturnType<typeof useGetBaoriderTasksQuery>;
export type GetBaoriderTasksLazyQueryHookResult = ReturnType<typeof useGetBaoriderTasksLazyQuery>;
export type GetBaoriderTasksQueryResult = ApolloReactCommon.QueryResult<GetBaoriderTasksQuery, GetBaoriderTasksQueryVariables>;
export const GetUnreadNotificationsCountDocument = gql`
    query getUnreadNotificationsCount {
  getUnreadNotificationsCount
}
    `;
export type GetUnreadNotificationsCountComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetUnreadNotificationsCountQuery, GetUnreadNotificationsCountQueryVariables>, 'query'>;

    export const GetUnreadNotificationsCountComponent = (props: GetUnreadNotificationsCountComponentProps) => (
      <ApolloReactComponents.Query<GetUnreadNotificationsCountQuery, GetUnreadNotificationsCountQueryVariables> query={GetUnreadNotificationsCountDocument} {...props} />
    );
    
export type GetUnreadNotificationsCountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetUnreadNotificationsCountQuery, GetUnreadNotificationsCountQueryVariables>
    } & TChildProps;
export function withGetUnreadNotificationsCount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetUnreadNotificationsCountQuery,
  GetUnreadNotificationsCountQueryVariables,
  GetUnreadNotificationsCountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetUnreadNotificationsCountQuery, GetUnreadNotificationsCountQueryVariables, GetUnreadNotificationsCountProps<TChildProps, TDataName>>(GetUnreadNotificationsCountDocument, {
      alias: 'getUnreadNotificationsCount',
      ...operationOptions
    });
};

/**
 * __useGetUnreadNotificationsCountQuery__
 *
 * To run a query within a React component, call `useGetUnreadNotificationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnreadNotificationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnreadNotificationsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnreadNotificationsCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUnreadNotificationsCountQuery, GetUnreadNotificationsCountQueryVariables>) {
        return ApolloReactHooks.useQuery<GetUnreadNotificationsCountQuery, GetUnreadNotificationsCountQueryVariables>(GetUnreadNotificationsCountDocument, baseOptions);
      }
export function useGetUnreadNotificationsCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUnreadNotificationsCountQuery, GetUnreadNotificationsCountQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetUnreadNotificationsCountQuery, GetUnreadNotificationsCountQueryVariables>(GetUnreadNotificationsCountDocument, baseOptions);
        }
export type GetUnreadNotificationsCountQueryHookResult = ReturnType<typeof useGetUnreadNotificationsCountQuery>;
export type GetUnreadNotificationsCountLazyQueryHookResult = ReturnType<typeof useGetUnreadNotificationsCountLazyQuery>;
export type GetUnreadNotificationsCountQueryResult = ApolloReactCommon.QueryResult<GetUnreadNotificationsCountQuery, GetUnreadNotificationsCountQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    username
    email
    confirmed
    blocked
    role {
      id
      name
      description
      type
    }
  }
}
    `;
export type MeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MeQuery, MeQueryVariables>, 'query'>;

    export const MeComponent = (props: MeComponentProps) => (
      <ApolloReactComponents.Query<MeQuery, MeQueryVariables> query={MeDocument} {...props} />
    );
    
export type MeProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<MeQuery, MeQueryVariables>
    } & TChildProps;
export function withMe<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MeQuery,
  MeQueryVariables,
  MeProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, MeQuery, MeQueryVariables, MeProps<TChildProps, TDataName>>(MeDocument, {
      alias: 'me',
      ...operationOptions
    });
};

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MeQuery, MeQueryVariables>) {
        return ApolloReactHooks.useQuery<MeQuery, MeQueryVariables>(MeDocument, baseOptions);
      }
export function useMeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, baseOptions);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = ApolloReactCommon.QueryResult<MeQuery, MeQueryVariables>;
export const MyUserDocument = gql`
    query myUser {
  myUser {
    id
    attributes {
      ...user
      profilePicture {
        data {
          ...uploadFile
        }
      }
      community {
        data {
          id
          attributes {
            ...community
          }
        }
      }
    }
  }
}
    ${UserFragmentDoc}
${UploadFileFragmentDoc}
${CommunityFragmentDoc}`;
export type MyUserComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MyUserQuery, MyUserQueryVariables>, 'query'>;

    export const MyUserComponent = (props: MyUserComponentProps) => (
      <ApolloReactComponents.Query<MyUserQuery, MyUserQueryVariables> query={MyUserDocument} {...props} />
    );
    
export type MyUserProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<MyUserQuery, MyUserQueryVariables>
    } & TChildProps;
export function withMyUser<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MyUserQuery,
  MyUserQueryVariables,
  MyUserProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, MyUserQuery, MyUserQueryVariables, MyUserProps<TChildProps, TDataName>>(MyUserDocument, {
      alias: 'myUser',
      ...operationOptions
    });
};

/**
 * __useMyUserQuery__
 *
 * To run a query within a React component, call `useMyUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyUserQuery, MyUserQueryVariables>) {
        return ApolloReactHooks.useQuery<MyUserQuery, MyUserQueryVariables>(MyUserDocument, baseOptions);
      }
export function useMyUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyUserQuery, MyUserQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MyUserQuery, MyUserQueryVariables>(MyUserDocument, baseOptions);
        }
export type MyUserQueryHookResult = ReturnType<typeof useMyUserQuery>;
export type MyUserLazyQueryHookResult = ReturnType<typeof useMyUserLazyQuery>;
export type MyUserQueryResult = ApolloReactCommon.QueryResult<MyUserQuery, MyUserQueryVariables>;
export const GetBaoverifierTaskDefinitionDocument = gql`
    query getBaoverifierTaskDefinition($id: ID!) {
  getBaoverifierTaskDefinition(id: $id) {
    id
    attributes {
      ...task_definition
      category {
        data {
          id
          attributes {
            ...category
            featureImage {
              data {
                ...uploadFile
              }
            }
          }
        }
      }
      baoleader {
        data {
          id
          attributes {
            baoleader {
              data {
                id
              }
            }
          }
        }
      }
      project {
        data {
          id
          attributes {
            ...project
          }
        }
      }
      task_type {
        data {
          id
          attributes {
            title
            dataFields {
              ...componentCustomDataFieldsMetricsSpecific
              ...componentCustomDataFieldsNumberRange
              ...componentCustomDataFieldsNumberDropDown
              ...componentCustomDataFieldsPercentage
              ...componentCustomDataFieldsRadio
              ...componentCustomDataFieldsText
              ...componentCustomDataFieldsImageField
              ...componentCustomDataFieldsDataList
              ...componentCustomDataFieldsCheckbox
              ...componentCustomDataFieldsSelect
              ...componentCustomDataFieldsDateTimeField
              ...componentCustomDataFieldsPercentage
              ...componentCustomDataFieldsRating
              ...componentCustomDataFieldsNumberField
              ...componentCustomDataFieldsPhoneNumberField
              ...componentCustomDataFieldsEmailField
              __typename
            }
            custom_data_fields {
              data {
                id
                attributes {
                  label
                  type {
                    data {
                      id
                      attributes {
                        name
                        has_options
                      }
                    }
                  }
                  options {
                    data {
                      id
                      attributes {
                        value
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${Task_DefinitionFragmentDoc}
${CategoryFragmentDoc}
${UploadFileFragmentDoc}
${ProjectFragmentDoc}
${ComponentCustomDataFieldsMetricsSpecificFragmentDoc}
${ComponentCustomDataFieldsNumberRangeFragmentDoc}
${ComponentCustomDataFieldsNumberDropDownFragmentDoc}
${ComponentCustomDataFieldsPercentageFragmentDoc}
${ComponentCustomDataFieldsRadioFragmentDoc}
${ComponentCustomDataFieldsTextFragmentDoc}
${ComponentCustomDataFieldsImageFieldFragmentDoc}
${ComponentCustomDataFieldsDataListFragmentDoc}
${ComponentCustomDataFieldsCheckboxFragmentDoc}
${ComponentCustomDataFieldsSelectFragmentDoc}
${ComponentCustomDataFieldsDateTimeFieldFragmentDoc}
${ComponentCustomDataFieldsRatingFragmentDoc}
${ComponentCustomDataFieldsNumberFieldFragmentDoc}
${ComponentCustomDataFieldsPhoneNumberFieldFragmentDoc}
${ComponentCustomDataFieldsEmailFieldFragmentDoc}`;
export type GetBaoverifierTaskDefinitionComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetBaoverifierTaskDefinitionQuery, GetBaoverifierTaskDefinitionQueryVariables>, 'query'> & ({ variables: GetBaoverifierTaskDefinitionQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetBaoverifierTaskDefinitionComponent = (props: GetBaoverifierTaskDefinitionComponentProps) => (
      <ApolloReactComponents.Query<GetBaoverifierTaskDefinitionQuery, GetBaoverifierTaskDefinitionQueryVariables> query={GetBaoverifierTaskDefinitionDocument} {...props} />
    );
    
export type GetBaoverifierTaskDefinitionProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetBaoverifierTaskDefinitionQuery, GetBaoverifierTaskDefinitionQueryVariables>
    } & TChildProps;
export function withGetBaoverifierTaskDefinition<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetBaoverifierTaskDefinitionQuery,
  GetBaoverifierTaskDefinitionQueryVariables,
  GetBaoverifierTaskDefinitionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetBaoverifierTaskDefinitionQuery, GetBaoverifierTaskDefinitionQueryVariables, GetBaoverifierTaskDefinitionProps<TChildProps, TDataName>>(GetBaoverifierTaskDefinitionDocument, {
      alias: 'getBaoverifierTaskDefinition',
      ...operationOptions
    });
};

/**
 * __useGetBaoverifierTaskDefinitionQuery__
 *
 * To run a query within a React component, call `useGetBaoverifierTaskDefinitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBaoverifierTaskDefinitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBaoverifierTaskDefinitionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBaoverifierTaskDefinitionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBaoverifierTaskDefinitionQuery, GetBaoverifierTaskDefinitionQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBaoverifierTaskDefinitionQuery, GetBaoverifierTaskDefinitionQueryVariables>(GetBaoverifierTaskDefinitionDocument, baseOptions);
      }
export function useGetBaoverifierTaskDefinitionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBaoverifierTaskDefinitionQuery, GetBaoverifierTaskDefinitionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBaoverifierTaskDefinitionQuery, GetBaoverifierTaskDefinitionQueryVariables>(GetBaoverifierTaskDefinitionDocument, baseOptions);
        }
export type GetBaoverifierTaskDefinitionQueryHookResult = ReturnType<typeof useGetBaoverifierTaskDefinitionQuery>;
export type GetBaoverifierTaskDefinitionLazyQueryHookResult = ReturnType<typeof useGetBaoverifierTaskDefinitionLazyQuery>;
export type GetBaoverifierTaskDefinitionQueryResult = ApolloReactCommon.QueryResult<GetBaoverifierTaskDefinitionQuery, GetBaoverifierTaskDefinitionQueryVariables>;
export const GetBaoverifierTaskDefinitionsDocument = gql`
    query getBaoverifierTaskDefinitions($sort: [String], $filters: JSON, $pagination: PaginationArg) {
  getBaoverifierTaskDefinitions(
    sort: $sort
    filters: $filters
    publicationState: LIVE
    pagination: $pagination
  ) {
    id
    attributes {
      ...task_definition
      category {
        data {
          id
          attributes {
            ...category
            featureImage {
              data {
                ...uploadFile
              }
            }
          }
        }
      }
      baoleader {
        data {
          id
          attributes {
            baoleader {
              data {
                id
              }
            }
          }
        }
      }
      project {
        data {
          id
          attributes {
            ...project
          }
        }
      }
      task_type {
        data {
          id
          attributes {
            title
            dataFields {
              ...componentCustomDataFieldsMetricsSpecific
              ...componentCustomDataFieldsNumberRange
              ...componentCustomDataFieldsNumberDropDown
              ...componentCustomDataFieldsPercentage
              ...componentCustomDataFieldsRadio
              ...componentCustomDataFieldsText
              ...componentCustomDataFieldsImageField
              ...componentCustomDataFieldsDataList
              ...componentCustomDataFieldsCheckbox
              ...componentCustomDataFieldsSelect
              ...componentCustomDataFieldsDateTimeField
              ...componentCustomDataFieldsPercentage
              ...componentCustomDataFieldsRating
              ...componentCustomDataFieldsNumberField
              ...componentCustomDataFieldsPhoneNumberField
              ...componentCustomDataFieldsEmailField
              __typename
            }
            custom_data_fields {
              data {
                id
                attributes {
                  label
                  type {
                    data {
                      id
                      attributes {
                        name
                        has_options
                      }
                    }
                  }
                  options {
                    data {
                      id
                      attributes {
                        value
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${Task_DefinitionFragmentDoc}
${CategoryFragmentDoc}
${UploadFileFragmentDoc}
${ProjectFragmentDoc}
${ComponentCustomDataFieldsMetricsSpecificFragmentDoc}
${ComponentCustomDataFieldsNumberRangeFragmentDoc}
${ComponentCustomDataFieldsNumberDropDownFragmentDoc}
${ComponentCustomDataFieldsPercentageFragmentDoc}
${ComponentCustomDataFieldsRadioFragmentDoc}
${ComponentCustomDataFieldsTextFragmentDoc}
${ComponentCustomDataFieldsImageFieldFragmentDoc}
${ComponentCustomDataFieldsDataListFragmentDoc}
${ComponentCustomDataFieldsCheckboxFragmentDoc}
${ComponentCustomDataFieldsSelectFragmentDoc}
${ComponentCustomDataFieldsDateTimeFieldFragmentDoc}
${ComponentCustomDataFieldsRatingFragmentDoc}
${ComponentCustomDataFieldsNumberFieldFragmentDoc}
${ComponentCustomDataFieldsPhoneNumberFieldFragmentDoc}
${ComponentCustomDataFieldsEmailFieldFragmentDoc}`;
export type GetBaoverifierTaskDefinitionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetBaoverifierTaskDefinitionsQuery, GetBaoverifierTaskDefinitionsQueryVariables>, 'query'>;

    export const GetBaoverifierTaskDefinitionsComponent = (props: GetBaoverifierTaskDefinitionsComponentProps) => (
      <ApolloReactComponents.Query<GetBaoverifierTaskDefinitionsQuery, GetBaoverifierTaskDefinitionsQueryVariables> query={GetBaoverifierTaskDefinitionsDocument} {...props} />
    );
    
export type GetBaoverifierTaskDefinitionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetBaoverifierTaskDefinitionsQuery, GetBaoverifierTaskDefinitionsQueryVariables>
    } & TChildProps;
export function withGetBaoverifierTaskDefinitions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetBaoverifierTaskDefinitionsQuery,
  GetBaoverifierTaskDefinitionsQueryVariables,
  GetBaoverifierTaskDefinitionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetBaoverifierTaskDefinitionsQuery, GetBaoverifierTaskDefinitionsQueryVariables, GetBaoverifierTaskDefinitionsProps<TChildProps, TDataName>>(GetBaoverifierTaskDefinitionsDocument, {
      alias: 'getBaoverifierTaskDefinitions',
      ...operationOptions
    });
};

/**
 * __useGetBaoverifierTaskDefinitionsQuery__
 *
 * To run a query within a React component, call `useGetBaoverifierTaskDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBaoverifierTaskDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBaoverifierTaskDefinitionsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetBaoverifierTaskDefinitionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBaoverifierTaskDefinitionsQuery, GetBaoverifierTaskDefinitionsQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBaoverifierTaskDefinitionsQuery, GetBaoverifierTaskDefinitionsQueryVariables>(GetBaoverifierTaskDefinitionsDocument, baseOptions);
      }
export function useGetBaoverifierTaskDefinitionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBaoverifierTaskDefinitionsQuery, GetBaoverifierTaskDefinitionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBaoverifierTaskDefinitionsQuery, GetBaoverifierTaskDefinitionsQueryVariables>(GetBaoverifierTaskDefinitionsDocument, baseOptions);
        }
export type GetBaoverifierTaskDefinitionsQueryHookResult = ReturnType<typeof useGetBaoverifierTaskDefinitionsQuery>;
export type GetBaoverifierTaskDefinitionsLazyQueryHookResult = ReturnType<typeof useGetBaoverifierTaskDefinitionsLazyQuery>;
export type GetBaoverifierTaskDefinitionsQueryResult = ApolloReactCommon.QueryResult<GetBaoverifierTaskDefinitionsQuery, GetBaoverifierTaskDefinitionsQueryVariables>;
export const TermsAndConditionDocument = gql`
    query termsAndCondition {
  termsAndCondition {
    data {
      id
      attributes {
        terms_pdf {
          data {
            id
            attributes {
              url
            }
          }
        }
      }
    }
  }
}
    `;
export type TermsAndConditionComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TermsAndConditionQuery, TermsAndConditionQueryVariables>, 'query'>;

    export const TermsAndConditionComponent = (props: TermsAndConditionComponentProps) => (
      <ApolloReactComponents.Query<TermsAndConditionQuery, TermsAndConditionQueryVariables> query={TermsAndConditionDocument} {...props} />
    );
    
export type TermsAndConditionProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<TermsAndConditionQuery, TermsAndConditionQueryVariables>
    } & TChildProps;
export function withTermsAndCondition<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TermsAndConditionQuery,
  TermsAndConditionQueryVariables,
  TermsAndConditionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, TermsAndConditionQuery, TermsAndConditionQueryVariables, TermsAndConditionProps<TChildProps, TDataName>>(TermsAndConditionDocument, {
      alias: 'termsAndCondition',
      ...operationOptions
    });
};

/**
 * __useTermsAndConditionQuery__
 *
 * To run a query within a React component, call `useTermsAndConditionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTermsAndConditionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTermsAndConditionQuery({
 *   variables: {
 *   },
 * });
 */
export function useTermsAndConditionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TermsAndConditionQuery, TermsAndConditionQueryVariables>) {
        return ApolloReactHooks.useQuery<TermsAndConditionQuery, TermsAndConditionQueryVariables>(TermsAndConditionDocument, baseOptions);
      }
export function useTermsAndConditionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TermsAndConditionQuery, TermsAndConditionQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<TermsAndConditionQuery, TermsAndConditionQueryVariables>(TermsAndConditionDocument, baseOptions);
        }
export type TermsAndConditionQueryHookResult = ReturnType<typeof useTermsAndConditionQuery>;
export type TermsAndConditionLazyQueryHookResult = ReturnType<typeof useTermsAndConditionLazyQuery>;
export type TermsAndConditionQueryResult = ApolloReactCommon.QueryResult<TermsAndConditionQuery, TermsAndConditionQueryVariables>;